// MATPASS — Dictionnaire de traduction UI (FR / EN / NL)
// Les clés sont l'identifiant sémantique, chaque valeur est { fr, en, nl }.
// Ajout facile : dupliquer une entrée existante.

const dict = {
  // ---------- Navigation (Header)
  "nav.search": { fr: "Rechercher", en: "Search", nl: "Zoeken" },
  "nav.pricing": { fr: "Tarifs", en: "Pricing", nl: "Prijzen" },
  "nav.post_ad": { fr: "Déposer une annonce", en: "Post an ad", nl: "Advertentie plaatsen" },
  "nav.favorites": { fr: "Favoris", en: "Favorites", nl: "Favorieten" },
  "nav.messages": { fr: "Messages", en: "Messages", nl: "Berichten" },
  "nav.dashboard": { fr: "Mon tableau de bord", en: "My dashboard", nl: "Mijn dashboard" },
  "nav.my_listings": { fr: "Mes annonces", en: "My listings", nl: "Mijn advertenties" },
  "nav.home": { fr: "Accueil", en: "Home", nl: "Home" },
  "nav.profile": { fr: "Mon compte", en: "My account", nl: "Mijn account" },
  "nav.settings": { fr: "Paramètres", en: "Settings", nl: "Instellingen" },
  "nav.login": { fr: "Connexion", en: "Sign in", nl: "Inloggen" },
  "nav.register": { fr: "S'inscrire", en: "Sign up", nl: "Registreren" },
  "nav.logout": { fr: "Déconnexion", en: "Sign out", nl: "Uitloggen" },
  "nav.admin": { fr: "Administration", en: "Admin", nl: "Beheer" },
  "nav.change_lang": { fr: "Changer de langue", en: "Change language", nl: "Taal wijzigen" },
  "nav.back": { fr: "Retour", en: "Back", nl: "Terug" },
  "nav.back_aria": {
    fr: "Revenir à la page précédente",
    en: "Go back to the previous page",
    nl: "Terug naar de vorige pagina",
  },

  // ---------- Pagination
  "pagination.showing": {
    fr: "Affichage de {from} à {to} sur {total} résultats",
    en: "Showing {from} to {to} of {total} results",
    nl: "Weergave van {from} tot {to} van {total} resultaten",
  },
  "pagination.aria": { fr: "Pagination", en: "Pagination", nl: "Paginering" },
  "pagination.page": { fr: "Page", en: "Page", nl: "Pagina" },

  // ---------- Service chooser (home hub)
  "services.kicker": { fr: "Choisissez votre service", en: "Choose your service", nl: "Kies uw dienst" },
  "services.chooser_title": {
    fr: "Par où commencez-vous ?",
    en: "Where do you start?",
    nl: "Waar wilt u beginnen?",
  },
  "services.subtitle": {
    fr: "Deux façons d'avancer : trouvez un fournisseur près de chez vous, ou explorez le marché de l'occasion.",
    en: "Two ways forward: find a supplier near you, or browse the used equipment marketplace.",
    nl: "Twee manieren om verder te gaan: vind een leverancier bij u in de buurt, of verken de tweedehandsmarkt.",
  },
  "services.suppliers_title": { fr: "Trouver un fournisseur", en: "Find a supplier", nl: "Vind een leverancier" },
  "services.suppliers_desc": {
    fr: "Trouvez rapidement un fournisseur de matériel professionnel près de chez vous.",
    en: "Quickly find a professional equipment supplier near you.",
    nl: "Vind snel een leverancier van professioneel materieel bij u in de buurt.",
  },
  "services.suppliers_cta": { fr: "Rechercher →", en: "Search →", nl: "Zoeken →" },
  "services.shared_meta": {
    fr: "Vente • Location • Réparation • Pièces détachées",
    en: "Sale • Rental • Repair • Spare parts",
    nl: "Verkoop • Verhuur • Reparatie • Onderdelen",
  },
  "services.marketplace_title": { fr: "Marché de l'occasion", en: "Used marketplace", nl: "Tweedehandsmarkt" },
  "services.marketplace_desc": {
    fr: "Achetez ou vendez du matériel professionnel d'occasion entre particuliers et professionnels.",
    en: "Buy or sell used professional equipment between individuals and businesses.",
    nl: "Koop of verkoop tweedehands professioneel materieel tussen particulieren en professionals.",
  },
  "services.marketplace_cta": { fr: "Voir les annonces →", en: "View listings →", nl: "Advertenties bekijken →" },
  "services.back": { fr: "Retour au choix des services", en: "Back to service choice", nl: "Terug naar dienstkeuze" },

  // ---------- Suppliers directory + map
  "suppliers.kicker": { fr: "Fournisseurs", en: "Suppliers", nl: "Leveranciers" },
  "suppliers.title": { fr: "Rechercher un fournisseur", en: "Find a supplier", nl: "Zoek een leverancier" },
  "suppliers.subtitle": {
    fr: "Gagnez du temps : localisez vente, location, réparation et pièces près de votre chantier — utile aussi pour préparer vos devis.",
    en: "Save time: locate sales, rental, repair and parts near your job site — also useful when preparing quotes.",
    nl: "Bespaar tijd: lokaliseer verkoop, verhuur, reparatie en onderdelen bij uw werf — ook nuttig om offertes voor te bereiden.",
  },
  "suppliers.jobsite_title": {
    fr: "Près de votre chantier ?",
    en: "Near your job site?",
    nl: "Dicht bij uw werf?",
  },
  "suppliers.jobsite_hint": {
    fr: "On remplit le code postal et la ville. Cliquez ensuite sur Rechercher pour voir les fournisseurs autour de vous.",
    en: "We fill in the postal code and city. Then click Search to see suppliers around you.",
    nl: "We vullen postcode en stad in. Klik daarna op Zoeken om leveranciers in de buurt te zien.",
  },
  "suppliers.jobsite_cta": {
    fr: "Utiliser ma position",
    en: "Use my location",
    nl: "Mijn locatie gebruiken",
  },
  "suppliers.postal_label": { fr: "Code postal", en: "Postal code", nl: "Postcode" },
  "suppliers.city_label": { fr: "Ville", en: "City", nl: "Stad" },
  "suppliers.city_placeholder": { fr: "Ex : Waterloo", en: "e.g. Waterloo", nl: "Bijv. Waterloo" },
  "suppliers.q_label": { fr: "Mot-clé", en: "Keyword", nl: "Trefwoord" },
  "suppliers.q_placeholder": {
    fr: "Nom, marque, service…",
    en: "Name, brand, service…",
    nl: "Naam, merk, dienst…",
  },
  "suppliers.welcome_title": {
    fr: "Par où commencer ?",
    en: "Where to start?",
    nl: "Waar wilt u beginnen?",
  },
  "suppliers.welcome_hint": {
    fr: "Choisissez une ville, un service courant, ou explorez tout le réseau belge.",
    en: "Pick a city, a common service, or browse the whole Belgian network.",
    nl: "Kies een stad, een veelgevraagde dienst, of verken het Belgische netwerk.",
  },
  "suppliers.browse_all": {
    fr: "Voir tous les fournisseurs",
    en: "See all suppliers",
    nl: "Alle leveranciers bekijken",
  },
  "suppliers.quick_cities": { fr: "Villes", en: "Cities", nl: "Steden" },
  "suppliers.quick_services": { fr: "Services fréquents", en: "Popular services", nl: "Populaire diensten" },
  "suppliers.browse_mode_hint": {
    fr: "Tous les fournisseurs (Belgique)",
    en: "All suppliers (Belgium)",
    nl: "Alle leveranciers (België)",
  },
  "suppliers.category_label": { fr: "Catégorie", en: "Category", nl: "Categorie" },
  "suppliers.services_label": { fr: "Services proposés", en: "Services offered", nl: "Aangeboden diensten" },
  "suppliers.services_hint": {
    fr: "Cliquez sur une catégorie pour voir les exemples, puis cochez ce que vous proposez.",
    en: "Tap a category to see examples, then tick what you offer.",
    nl: "Tik op een categorie om voorbeelden te zien en vink aan wat u aanbiedt.",
  },
  "suppliers.sectors_label": { fr: "Secteurs d'activité", en: "Activity sectors", nl: "Activiteitssectoren" },
  "suppliers.sectors_hint": {
    fr: "Dans quels domaines travaillez-vous ? Un professionnel peut couvrir plusieurs secteurs.",
    en: "Which domains do you work in? A professional can cover several sectors.",
    nl: "In welke domeinen werkt u? Een professional kan meerdere sectoren bestrijken.",
  },
  "suppliers.filters_title": { fr: "Affiner la recherche", en: "Refine search", nl: "Zoekopdracht verfijnen" },
  "suppliers.explore_label": {
    fr: "Machines, métiers & fournitures",
    en: "Machines, trades & supplies",
    nl: "Machines, beroepen & leveringen",
  },
  "suppliers.explore_hint": {
    fr: "Choisissez une ou plusieurs cases : vente, location, bâtiment, électricité, chauffage, jardin…",
    en: "Pick one or more tiles: sales, rental, construction, electrical, heating, garden…",
    nl: "Kies een of meer tegels: verkoop, verhuur, bouw, elektriciteit, verwarming, tuin…",
  },
  "suppliers.filter_search_placeholder": { fr: "Rechercher…", en: "Search…", nl: "Zoeken…" },
  "suppliers.filter_search_empty": { fr: "Aucun résultat", en: "No results", nl: "Geen resultaten" },
  "suppliers.filter_choose": { fr: "Choisir…", en: "Choose…", nl: "Kiezen…" },
  "suppliers.radius_title": { fr: "Rayon de recherche", en: "Search radius", nl: "Zoekstraal" },
  "suppliers.radius_selected": { fr: "Rayon sélectionné : {km} km", en: "Selected radius: {km} km", nl: "Geselecteerde straal: {km} km" },
  "suppliers.radius_decrease": { fr: "Diminuer le rayon", en: "Decrease radius", nl: "Straal verkleinen" },
  "suppliers.radius_increase": { fr: "Augmenter le rayon", en: "Increase radius", nl: "Straal vergroten" },
  "suppliers.empty_radius_title": {
    fr: "Aucun fournisseur trouvé dans un rayon de {km} km.",
    en: "No suppliers found within a {km} km radius.",
    nl: "Geen leveranciers gevonden binnen een straal van {km} km.",
  },
  "suppliers.widen_radius": { fr: "Élargir le rayon de recherche", en: "Widen search radius", nl: "Zoekstraal vergroten" },
  "suppliers.active_filters": { fr: "Filtres actifs", en: "Active filters", nl: "Actieve filters" },
  "suppliers.reset_filters": { fr: "Réinitialiser les filtres", en: "Reset filters", nl: "Filters resetten" },
  "suppliers.reset_all_filters": { fr: "Réinitialiser tous les filtres", en: "Reset all filters", nl: "Alle filters resetten" },
  "suppliers.remove_filter": { fr: "Retirer", en: "Remove", nl: "Verwijderen" },
  "suppliers.matches_one": {
    fr: "1 fournisseur correspond à votre recherche",
    en: "1 supplier matches your search",
    nl: "1 leverancier komt overeen met uw zoekopdracht",
  },
  "suppliers.matches_many": {
    fr: "{count} fournisseurs correspondent à votre recherche",
    en: "{count} suppliers match your search",
    nl: "{count} leveranciers komen overeen met uw zoekopdracht",
  },
  "suppliers.empty_filters_hint": {
    fr: "Aucun fournisseur ne correspond à ces critères. Supprimez un ou plusieurs filtres pour élargir les résultats.",
    en: "No suppliers match these criteria. Remove one or more filters to widen results.",
    nl: "Geen leveranciers voldoen aan deze criteria. Verwijder een of meer filters om de resultaten te verbreden.",
  },
  "suppliers.home_services_kicker": { fr: "Annuaire pro", en: "Pro directory", nl: "Pro-gids" },
  "suppliers.home_services_title": { fr: "Trouver un fournisseur par service ou secteur", en: "Find a supplier by service or sector", nl: "Vind een leverancier per dienst of sector" },
  "suppliers.home_services_subtitle": {
    fr: "Combinez services et secteurs d'activité pour trouver le bon professionnel près de votre chantier.",
    en: "Combine services and activity sectors to find the right professional near your job site.",
    nl: "Combineer diensten en activiteitssectoren om de juiste professional bij uw werf te vinden.",
  },
  "suppliers.act_jardin": { fr: "Jardin & espaces verts", en: "Garden & green spaces", nl: "Tuin & groenvoorzieningen" },
  "suppliers.act_batiment": { fr: "Bâtiment", en: "Construction", nl: "Bouw" },
  "suppliers.act_electricite": { fr: "Électricité", en: "Electrical", nl: "Elektriciteit" },
  "suppliers.act_plomberie_chauffage": { fr: "Plomberie & chauffage", en: "Plumbing & heating", nl: "Sanitair & verwarming" },
  "suppliers.act_menuiserie": { fr: "Menuiserie", en: "Joinery", nl: "Schrijnwerkerij" },
  "suppliers.act_peinture": { fr: "Peinture & revêtements", en: "Painting & finishes", nl: "Schilderwerk & afwerking" },
  "suppliers.act_terrassement": { fr: "Terrassement", en: "Earthworks", nl: "Grondwerken" },
  "suppliers.act_agriculture": { fr: "Agriculture", en: "Agriculture", nl: "Landbouw" },
  "suppliers.act_industrie": { fr: "Industrie", en: "Industry", nl: "Industrie" },
  "suppliers.category_all": { fr: "Tous", en: "All", nl: "Alle" },
  "suppliers.cta_search": { fr: "Rechercher", en: "Search", nl: "Zoeken" },
  "suppliers.use_my_location": { fr: "Utiliser ma position", en: "Use my location", nl: "Mijn locatie gebruiken" },
  "suppliers.geo_loading": { fr: "Localisation…", en: "Locating…", nl: "Lokaliseren…" },
  "suppliers.geo_hint": { fr: "Autorisez la localisation pour voir les fournisseurs autour de vous.", en: "Allow location access to see suppliers around you.", nl: "Sta locatietoegang toe om leveranciers rondom u te zien." },
  "suppliers.need_location": {
    fr: "Indiquez un code postal, une ville, un mot-clé, ou utilisez votre position.",
    en: "Enter a postal code, city, keyword, or use your location.",
    nl: "Geef een postcode, stad of trefwoord in, of gebruik uw locatie.",
  },
  "suppliers.geo_ok": {
    fr: "Position détectée. Cliquez sur Rechercher pour voir les fournisseurs autour de vous.",
    en: "Location detected. Click Search to see suppliers around you.",
    nl: "Locatie gedetecteerd. Klik op Zoeken om leveranciers in de buurt te zien.",
  },
  "suppliers.geo_filled": {
    fr: "Position : {location}. Cliquez sur Rechercher pour voir les fournisseurs autour de vous.",
    en: "Location: {location}. Click Search to see suppliers around you.",
    nl: "Locatie: {location}. Klik op Zoeken om leveranciers in de buurt te zien.",
  },
  "suppliers.geo_imprecise": {
    fr: "Position approximative (± {km} km) : {location}. Vérifiez le code postal si ce n’est pas votre chantier.",
    en: "Approximate location (± {km} km): {location}. Check the postal code if this is not your job site.",
    nl: "Geschatte locatie (± {km} km): {location}. Controleer de postcode als dit niet uw werf is.",
  },
  "suppliers.geo_keep_typed": {
    fr: "GPS trop imprécis — on garde le code postal {postal}. Cliquez sur Rechercher.",
    en: "GPS too imprecise — keeping postal code {postal}. Click Search.",
    nl: "GPS te onnauwkeurig — postcode {postal} behouden. Klik op Zoeken.",
  },
  "suppliers.geo_manual_hint": {
    fr: "GPS indisponible — saisissez le code postal ou la ville, puis cliquez sur Rechercher.",
    en: "GPS unavailable — enter a postal code or city, then click Search.",
    nl: "GPS niet beschikbaar — voer een postcode of stad in en klik op Zoeken.",
  },
  "suppliers.hint_start": {
    fr: "Indiquez un code postal ou utilisez votre position, puis cliquez sur Rechercher.",
    en: "Enter a postal code or use your location, then click Search.",
    nl: "Geef een postcode in of gebruik uw locatie, en klik op Zoeken.",
  },
  "suppliers.loading": { fr: "Recherche en cours…", en: "Searching…", nl: "Zoeken…" },
  "suppliers.result_singular": { fr: "fournisseur", en: "supplier", nl: "leverancier" },
  "suppliers.result_plural": { fr: "fournisseurs", en: "suppliers", nl: "leveranciers" },
  "suppliers.within": { fr: "dans un rayon de", en: "within", nl: "binnen" },
  "suppliers.empty_title": { fr: "Aucun fournisseur n'est actuellement référencé dans cette zone.", en: "No suppliers are currently listed in this area.", nl: "Er zijn momenteel geen leveranciers in deze zone." },
  "suppliers.empty_hint": { fr: "Élargissez le rayon de recherche ou essayez une autre ville.", en: "Widen the search radius or try another city.", nl: "Vergroot de zoekradius of probeer een andere stad." },
  "suppliers.try_other_city": { fr: "Ou recherchez dans une autre ville ci-dessus.", en: "Or search in another city above.", nl: "Of zoek hierboven in een andere stad." },
  "suppliers.view_supplier": { fr: "Voir le fournisseur", en: "View supplier", nl: "Bekijk leverancier" },
  "suppliers.view_profile": { fr: "Voir le profil", en: "View profile", nl: "Bekijk profiel" },
  "suppliers.open_maps": { fr: "Itinéraire", en: "Directions", nl: "Route" },
  "suppliers.no_maps": { fr: "Pas de GPS", en: "No GPS", nl: "Geen GPS" },
  "directions.choose_app": { fr: "Ouvrir avec", en: "Open with", nl: "Openen met" },
  "directions.google_maps": { fr: "Google Maps", en: "Google Maps", nl: "Google Maps" },
  "directions.waze": { fr: "Waze", en: "Waze", nl: "Waze" },
  "suppliers.approx": { fr: "~", en: "~", nl: "~" },
  "suppliers.svc_vente_machines": { fr: "Vente de machines", en: "Machine sales", nl: "Machineverkoop" },
  "suppliers.svc_location_machines": { fr: "Location de machines", en: "Machine rental", nl: "Machineverhuur" },
  "suppliers.svc_reparation_machines": { fr: "Réparation de machines", en: "Machine repair", nl: "Machinereparatie" },
  "suppliers.svc_entretien": { fr: "Entretien & maintenance", en: "Service & maintenance", nl: "Onderhoud & onderhoudscontract" },
  "suppliers.svc_pieces": { fr: "Pièces détachées", en: "Spare parts", nl: "Onderdelen" },
  "suppliers.svc_accessoires": { fr: "Accessoires & équipements", en: "Attachments & equipment", nl: "Accessoires & uitrusting" },
  "suppliers.svc_materiaux_chantier": { fr: "Granulats & bétons", en: "Aggregates & concrete", nl: "Granulaten & beton" },
  "suppliers.svc_granulats_betons": { fr: "Granulats & bétons", en: "Aggregates & concrete", nl: "Granulaten & beton" },
  "suppliers.svc_maconnerie_voirie": { fr: "Maçonnerie & voirie", en: "Masonry & paving", nl: "Metselwerk & bestrating" },
  "suppliers.svc_bois_panneaux": { fr: "Bois & panneaux", en: "Timber & panels", nl: "Hout & platen" },
  "suppliers.svc_metaux": { fr: "Métaux & profilés", en: "Metals & profiles", nl: "Metalen & profielen" },
  "suppliers.svc_electricite": { fr: "Électricité", en: "Electrical supplies", nl: "Elektriciteit" },
  "suppliers.svc_plomberie": { fr: "Plomberie", en: "Plumbing supplies", nl: "Sanitair" },
  "suppliers.svc_quincaillerie": { fr: "Quincaillerie & fixations", en: "Hardware & fixings", nl: "Ijzerwaren & bevestiging" },
  "suppliers.svc_isolation": { fr: "Isolation", en: "Insulation", nl: "Isolatie" },
  "suppliers.svc_peinture": { fr: "Peinture & finition", en: "Paint & finishing", nl: "Verf & afwerking" },
  "suppliers.svc_consommables": { fr: "Consommables atelier", en: "Workshop consumables", nl: "Werkplaatsverbruiksartikelen" },
  "suppliers.svc_autres_materiaux": { fr: "Autres matériaux", en: "Other materials", nl: "Andere materialen" },
  "suppliers.svc_outillage": { fr: "Outillage", en: "Tools", nl: "Gereedschap" },
  "suppliers.svc_echafaudage": { fr: "Échafaudage & coffrage", en: "Scaffolding & formwork", nl: "Stellingen & bekisting" },
  "suppliers.svc_energie": { fr: "Énergie de chantier", en: "Jobsite power", nl: "Werfstroom" },
  "suppliers.svc_sanitaires": { fr: "Sanitaires & bungalows", en: "Sanitary & site cabins", nl: "Sanitair & werfketen" },
  "suppliers.svc_epi": { fr: "EPI & sécurité", en: "PPE & safety", nl: "PBM & veiligheid" },
  "suppliers.svc_pneus": { fr: "Pneus", en: "Tyres", nl: "Banden" },
  "suppliers.svc_reprise": { fr: "Reprise & occasion", en: "Trade-in & used", nl: "Inruil & tweedehands" },
  "suppliers.svc_carburant": { fr: "Carburant", en: "Fuel", nl: "Brandstof" },
  "suppliers.svc_conteneurs": { fr: "Conteneurs", en: "Containers", nl: "Containers" },
  "suppliers.svc_dechetterie": { fr: "Déchetterie", en: "Waste facility", nl: "Containerpark" },
  "suppliers.svc_transport": { fr: "Transport", en: "Transport", nl: "Transport" },
  "suppliers.svc_levage_grutage": { fr: "Levage & Grutage", en: "Lifting & crane", nl: "Hef- & kraanwerken" },
  "suppliers.svc_pepiniere": { fr: "Pépinière", en: "Nursery", nl: "Kwekerij" },
  "suppliers.svc_plantes_arbres": { fr: "Plantes & arbres", en: "Plants & trees", nl: "Planten & bomen" },
  "suppliers.svc_terreaux": { fr: "Terreaux & amendements", en: "Soil & amendments", nl: "Potgrond & bodemverbeteraars" },
  "suppliers.svc_bois_paillage": { fr: "Bois & paillage", en: "Wood & mulch", nl: "Hout & mulch" },
  "suppliers.svc_gazon": { fr: "Gazon & semences", en: "Lawn & seeds", nl: "Gazons & zaden" },
  "suppliers.svc_arrosage": { fr: "Arrosage & irrigation", en: "Watering & irrigation", nl: "Beregening & irrigatie" },
  "suppliers.svc_group_tap": {
    fr: "Appuyer pour voir les exemples",
    en: "Tap to see examples",
    nl: "Tik om voorbeelden te zien",
  },
  "suppliers.svc_group_examples": {
    fr: "Exemples",
    en: "Examples",
    nl: "Voorbeelden",
  },
  "suppliers.svc_example_machines": { fr: "Machines", en: "Machines", nl: "Machines" },
  "suppliers.svc_group_vente": { fr: "Vente", en: "Sales", nl: "Verkoop" },
  "suppliers.svc_group_location": { fr: "Location", en: "Rental", nl: "Verhuur" },
  "suppliers.svc_group_reparation_entretien": {
    fr: "Réparation & entretien",
    en: "Repair & maintenance",
    nl: "Reparatie & onderhoud",
  },
  "suppliers.svc_group_pieces_accessoires": {
    fr: "Pièces & accessoires",
    en: "Parts & accessories",
    nl: "Onderdelen & accessoires",
  },
  "suppliers.svc_group_chantier_construction": {
    fr: "Chantier & construction",
    en: "Jobsite & construction",
    nl: "Werf & bouw",
  },
  "suppliers.svc_group_espaces_verts_agricole": {
    fr: "Espaces verts & agricole",
    en: "Green spaces & agriculture",
    nl: "Groen & landbouw",
  },
  "suppliers.svc_group_services_logistique": {
    fr: "Services & logistique",
    en: "Services & logistics",
    nl: "Diensten & logistiek",
  },
  "suppliers.svc_group_machines": { fr: "Machines", en: "Machines", nl: "Machines" },
  "suppliers.svc_group_chantier": { fr: "Chantier", en: "Jobsite", nl: "Werf" },
  "suppliers.svc_group_fournitures": { fr: "Fournitures & matériaux", en: "Supplies & materials", nl: "Leveringen & materialen" },
  "suppliers.svc_group_espaces_verts": { fr: "Espaces verts", en: "Green spaces", nl: "Groenvoorziening" },
  "suppliers.day_mon": { fr: "Lun", en: "Mon", nl: "Ma" },
  "suppliers.day_tue": { fr: "Mar", en: "Tue", nl: "Di" },
  "suppliers.day_wed": { fr: "Mer", en: "Wed", nl: "Wo" },
  "suppliers.day_thu": { fr: "Jeu", en: "Thu", nl: "Do" },
  "suppliers.day_fri": { fr: "Ven", en: "Fri", nl: "Vr" },
  "suppliers.day_sat": { fr: "Sam", en: "Sat", nl: "Za" },
  "suppliers.day_sun": { fr: "Dim", en: "Sun", nl: "Zo" },
  "suppliers.day_full_mon": { fr: "Lundi", en: "Monday", nl: "Maandag" },
  "suppliers.day_full_tue": { fr: "Mardi", en: "Tuesday", nl: "Dinsdag" },
  "suppliers.day_full_wed": { fr: "Mercredi", en: "Wednesday", nl: "Woensdag" },
  "suppliers.day_full_thu": { fr: "Jeudi", en: "Thursday", nl: "Donderdag" },
  "suppliers.day_full_fri": { fr: "Vendredi", en: "Friday", nl: "Vrijdag" },
  "suppliers.day_full_sat": { fr: "Samedi", en: "Saturday", nl: "Zaterdag" },
  "suppliers.day_full_sun": { fr: "Dimanche", en: "Sunday", nl: "Zondag" },
  "hours.title": { fr: "Horaires d'ouverture", en: "Opening hours", nl: "Openingsuren" },
  "hours.open_now": { fr: "Ouvert actuellement", en: "Open now", nl: "Nu open" },
  "hours.closed_now": { fr: "Fermé actuellement", en: "Closed now", nl: "Nu gesloten" },
  "hours.open_now_short": { fr: "Ouvert", en: "Open", nl: "Open" },
  "hours.closed_now_short": { fr: "Fermé", en: "Closed", nl: "Gesloten" },
  "hours.closed": { fr: "Fermé", en: "Closed", nl: "Gesloten" },
  "hours.today": { fr: "Aujourd'hui", en: "Today", nl: "Vandaag" },
  "hours.closes_at": { fr: "Ferme à {time}", en: "Closes at {time}", nl: "Sluit om {time}" },
  "hours.opens_today": { fr: "Ouvre aujourd'hui à {time}", en: "Opens today at {time}", nl: "Opent vandaag om {time}" },
  "hours.opens_tomorrow": { fr: "Ouvre demain à {time}", en: "Opens tomorrow at {time}", nl: "Opent morgen om {time}" },
  "hours.opens_on": { fr: "Ouvre {day} à {time}", en: "Opens {day} at {time}", nl: "Opent {day} om {time}" },
  "hours.directions": { fr: "Itinéraire", en: "Directions", nl: "Route" },
  "hours.editor_hint": {
    fr: "Indiquez vos horaires jour par jour. La pause déjeuner est optionnelle.",
    en: "Set your hours day by day. Lunch break is optional.",
    nl: "Stel uw uren per dag in. Lunchpauze is optioneel.",
  },
  "hours.copy_weekdays": { fr: "Copier lundi → ven.", en: "Copy Mon → Fri", nl: "Kopieer ma → vr" },
  "hours.open_day": { fr: "Ouvert", en: "Open", nl: "Open" },
  "hours.open_time": { fr: "Ouverture", en: "Opens", nl: "Opening" },
  "hours.close_time": { fr: "Fermeture", en: "Closes", nl: "Sluiting" },
  "hours.lunch_break": { fr: "Fermeture le midi", en: "Lunch break", nl: "Lunchpauze" },
  "hours.break_start": { fr: "Début pause", en: "Break start", nl: "Pauze start" },
  "hours.break_end": { fr: "Fin pause", en: "Break end", nl: "Pauze einde" },
  "hours.clear_day": { fr: "Effacer", en: "Clear", nl: "Wissen" },
  "hours.timezone_note": {
    fr: "Horaires interprétés en fuseau {tz} (Belgique).",
    en: "Hours interpreted in the {tz} timezone (Belgium).",
    nl: "Uren geïnterpreteerd in tijdzone {tz} (België).",
  },

  // ---------- Home hero
  "home.badge": { fr: "Marketplace belge • Matériel pro & fournisseurs", en: "Belgian marketplace • Pro equipment & suppliers", nl: "Belgische marktplaats • Pro-materieel & leveranciers" },
  "home.hero_hook": {
    fr: "Achetez, vendez et trouvez un fournisseur près de votre chantier, la référence belge du matériel professionnel.",
    en: "Buy, sell and find a supplier near your job site, Belgium’s reference for professional equipment.",
    nl: "Koop, verkoop en vind een leverancier bij uw werf, de Belgische referentie voor professioneel materieel.",
  },
  "home.buy_better": { fr: "Achetez mieux.", en: "Buy smarter.", nl: "Koop slimmer." },
  "home.sell_more": { fr: "Revendez plus.", en: "Sell more.", nl: "Verkoop meer." },
  "home.slogan": {
    fr: "La plateforme belge spécialisée dans le matériel professionnel d'occasion, pour les professionnels et les particuliers sérieux. Tondeuses, tracteurs, mini-pelles, outillage : tout, près de chez vous, partout en Belgique.",
    en: "The Belgian marketplace for used professional equipment, for pros and serious individuals. Mowers, tractors, mini-excavators, tools: everything, close to you, all over Belgium.",
    nl: "Het Belgische platform voor tweedehands professioneel materieel, voor professionals en serieuze particulieren. Grasmaaiers, tractoren, minigravers, gereedschap: alles, dicht bij u, in heel België.",
  },
  "home.trusted_sellers": { fr: "Professionnels & particuliers", en: "Pros & individuals", nl: "Professionals & particulieren" },
  "home.all_belgium": { fr: "Partout en Belgique", en: "All over Belgium", nl: "In heel België" },
  "home.free_listing": { fr: "Dépôt gratuit", en: "Free listing", nl: "Gratis plaatsen" },
  "home.search_placeholder": { fr: "Ex : mini-pelle, tondeuse John Deere, Kubota…", en: "e.g. mini-excavator, John Deere mower, Kubota…", nl: "Bijv. minigraver, John Deere maaier, Kubota…" },
  "home.cta_search": { fr: "Rechercher", en: "Search", nl: "Zoeken" },
  "home.cta_post_ad_free": { fr: "Déposer une annonce gratuitement", en: "Post an ad for free", nl: "Plaats gratis een advertentie" },
  "home.cta_find_supplier": { fr: "Trouver un fournisseur près de mon chantier", en: "Find a supplier near my job site", nl: "Vind een leverancier bij mijn werf" },

  // ---------- Home stats
  "home.stat_listings": { fr: "Annonces en ligne", en: "Live listings", nl: "Online advertenties" },
  "home.stat_companies": { fr: "Fournisseurs", en: "Suppliers", nl: "Leveranciers" },
  "home.stat_users": { fr: "Utilisateurs", en: "Users", nl: "Gebruikers" },
  "home.stat_particuliers": { fr: "Particuliers", en: "Individuals", nl: "Particulieren" },
  "home.stat_searches": { fr: "Recherches", en: "Searches", nl: "Zoekopdrachten" },
  "home.stat_cities": { fr: "Villes couvertes", en: "Cities covered", nl: "Steden bediend" },
  "home.stat_see_suppliers": { fr: "Voir les fournisseurs", en: "See suppliers", nl: "Leveranciers bekijken" },
  "home.stat_see_listings": { fr: "Voir les annonces", en: "See listings", nl: "Advertenties bekijken" },
  "home.stat_see_map": { fr: "Voir la carte", en: "See the map", nl: "Kaart bekijken" },
  "home.near_map_empty": {
    fr: "La carte s'affichera dès que des fournisseurs ou annonces sont disponibles près de chez vous.",
    en: "The map will appear as soon as suppliers or listings are available near you.",
    nl: "De kaart verschijnt zodra er leveranciers of advertenties bij u in de buurt beschikbaar zijn.",
  },
  "home.stats_title": { fr: "MATPASS en chiffres", en: "MATPASS in numbers", nl: "MATPASS in cijfers" },
  "home.stats_subtitle": {
    fr: "La confiance des professionnels, chaque jour.",
    en: "The trust of professionals, every day.",
    nl: "Het vertrouwen van professionals, elke dag.",
  },
  "home.stats_proof_title": { fr: "Pensé pour le chantier", en: "Built for the job site", nl: "Gemaakt voor de werf" },
  "home.stats_proof_subtitle": {
    fr: "Ce que MatPass vous apporte, concrètement.",
    en: "What MatPass gives you, concretely.",
    nl: "Wat MatPass u concreet biedt.",
  },
  "home.stat_proof_suppliers_title": {
    fr: "Fournisseurs près de votre chantier",
    en: "Suppliers near your job site",
    nl: "Leveranciers bij uw werf",
  },
  "home.stat_proof_suppliers_desc": {
    fr: "Trouvez des pros locaux selon votre secteur et vos besoins.",
    en: "Find local pros by sector and what you need.",
    nl: "Vind lokale professionals per sector en behoefte.",
  },
  "home.stat_proof_listings_title": {
    fr: "Marché de l'occasion pro",
    en: "Pro used equipment market",
    nl: "Markt voor gebruikte pro-uitrusting",
  },
  "home.stat_proof_listings_desc": {
    fr: "Achetez et vendez du matériel professionnel, sans intermédiaire opaque.",
    en: "Buy and sell professional equipment, without a black-box middleman.",
    nl: "Koop en verkoop professioneel materiaal, zonder onduidelijke tussenpersoon.",
  },
  "home.stat_proof_map_title": {
    fr: "Près de chez vous",
    en: "Near you",
    nl: "Bij u in de buurt",
  },
  "home.stat_proof_map_desc": {
    fr: "Explorez fournisseurs et annonces sur la carte, autour de votre chantier.",
    en: "Explore suppliers and listings on the map, around your job site.",
    nl: "Verken leveranciers en advertenties op de kaart, rond uw werf.",
  },

  "badge.verified_supplier": {
    fr: "Fournisseur vérifié",
    en: "Verified supplier",
    nl: "Geverifieerde leverancier",
  },
  "home.new_joiners_kicker": { fr: "Réseau en croissance", en: "Growing network", nl: "Groeiend netwerk" },
  "home.new_joiners_title": {
    fr: "Ils viennent de rejoindre MatPass",
    en: "They just joined MatPass",
    nl: "Zij zijn net toegetreden tot MatPass",
  },
  "home.new_joiners_subtitle": {
    fr: "Les derniers professionnels inscrits sur la plateforme, mis à jour en temps réel.",
    en: "The latest professionals who joined, updated in real time.",
    nl: "De nieuwste professionals op het platform, live bijgewerkt.",
  },
  "home.top_rated_kicker": { fr: "Confiance", en: "Trust", nl: "Vertrouwen" },
  "home.top_rated_title": {
    fr: "Les fournisseurs les mieux notés",
    en: "Top-rated suppliers",
    nl: "Best beoordeelde leveranciers",
  },
  "home.top_rated_subtitle": {
    fr: "Les entreprises avec les meilleures évaluations de leurs clients.",
    en: "Companies with the best ratings from their customers.",
    nl: "Bedrijven met de beste beoordelingen van hun klanten.",
  },
  "home.popular_kicker": { fr: "Tendances", en: "Trending", nl: "Trending" },
  "home.popular_title": {
    fr: "Les annonces les plus populaires",
    en: "Most popular listings",
    nl: "Populairste advertenties",
  },
  "home.popular_subtitle": {
    fr: "Classées automatiquement selon les vues et l'engagement.",
    en: "Ranked automatically by views and engagement.",
    nl: "Automatisch gerangschikt op weergaven en engagement.",
  },
  "home.popular_views": { fr: "vues", en: "views", nl: "weergaven" },
  "home.view_listing": { fr: "Voir l'annonce", en: "View listing", nl: "Advertentie bekijken" },
  "home.near_map_kicker": { fr: "Carte", en: "Map", nl: "Kaart" },
  "home.near_map_title": { fr: "Près de chez vous", en: "Near you", nl: "Bij u in de buurt" },
  "home.near_map_subtitle": {
    fr: "Fournisseurs, annonces et points de retrait sur la carte.",
    en: "Suppliers, listings and pickup points on the map.",
    nl: "Leveranciers, advertenties en afhaalpunten op de kaart.",
  },
  "home.near_map_subtitle_geo": {
    fr: "Découvrez les professionnels et annonces autour de votre position.",
    en: "Discover professionals and listings around your location.",
    nl: "Ontdek professionals en advertenties rond uw locatie.",
  },
  "home.near_map_pickup": { fr: "Points de retrait", en: "Pickup points", nl: "Afhaalpunten" },
  "home.cta_kicker": { fr: "Rejoignez-nous", en: "Join us", nl: "Word lid" },
  "home.cta_title": {
    fr: "Rejoignez dès aujourd'hui la communauté MatPass",
    en: "Join the MatPass community today",
    nl: "Word vandaag lid van de MatPass-community",
  },
  "home.cta_subtitle": {
    fr: "Publiez vos annonces, développez votre visibilité et connectez-vous à des milliers de professionnels en Belgique.",
    en: "Publish listings, grow your visibility and connect with thousands of professionals in Belgium.",
    nl: "Publiceer advertenties, vergroot uw zichtbaarheid en maak contact met duizenden professionals in België.",
  },
  "home.cta_register": { fr: "Créer mon compte", en: "Create my account", nl: "Mijn account aanmaken" },
  "home.cta_open_shop": { fr: "Ouvrir ma boutique", en: "Open my shop", nl: "Mijn winkel openen" },

  // ---------- Home universes (replaces brand strip)
  "home.universes_kicker": { fr: "Univers", en: "Universes", nl: "Universa" },
  "home.universes_title": {
    fr: "Tout le matériel professionnel au même endroit",
    en: "All professional equipment in one place",
    nl: "Al het professionele materieel op één plek",
  },
  "home.universes_subtitle": {
    fr: "Que vous soyez entrepreneur, artisan, agriculteur ou particulier, trouvez rapidement le matériel adapté à votre activité.",
    en: "Whether you’re a contractor, craftsman, farmer or individual, quickly find the right equipment for your work.",
    nl: "Of u nu aannemer, vakman, landbouwer of particulier bent: vind snel het materieel dat bij uw activiteit past.",
  },
  "home.universe_building_title": { fr: "Bâtiment", en: "Construction", nl: "Bouw" },
  "home.universe_building_desc": {
    fr: "Matériel de chantier, outillage, terrassement et équipements professionnels.",
    en: "Jobsite equipment, tools, earthmoving and professional gear.",
    nl: "Werfmaterieel, gereedschap, grondverzet en professionele uitrusting.",
  },
  "home.universe_garden_title": { fr: "Jardin & Espaces verts", en: "Garden & Green spaces", nl: "Tuin & Groen" },
  "home.universe_garden_desc": {
    fr: "Tondeuses, mini-pelles, débroussailleuses, broyeurs et matériel paysager.",
    en: "Mowers, mini excavators, brushcutters, chippers and landscaping gear.",
    nl: "Maaiers, minigravers, bosmaaiers, versnipperaars en landschapsmaterieel.",
  },
  "home.universe_agri_title": { fr: "Agriculture", en: "Agriculture", nl: "Landbouw" },
  "home.universe_agri_desc": {
    fr: "Tracteurs, remorques, outils agricoles et équipements d'exploitation.",
    en: "Tractors, trailers, farm implements and estate equipment.",
    nl: "Tractoren, aanhangers, landbouwwerktuigen en bedrijfsuitrusting.",
  },
  "home.universe_industry_title": { fr: "Manutention & Industrie", en: "Handling & Industry", nl: "Handling & Industrie" },
  "home.universe_industry_desc": {
    fr: "Chariots élévateurs, nacelles, télescopiques, groupes électrogènes et équipements industriels.",
    en: "Forklifts, aerial platforms, telehandlers, generators and industrial equipment.",
    nl: "Heftrucks, hoogwerkers, verreikers, generatoren en industriële uitrusting.",
  },

  // ---------- Home brands (legacy keys kept for compatibility)
  "home.brands_kicker": { fr: "Marques", en: "Brands", nl: "Merken" },
  "home.brands_title": { fr: "Les grandes marques du chantier", en: "The major worksite brands", nl: "De grote merken op de werf" },
  "home.brands_subtitle": {
    fr: "Recherchez rapidement du matériel Kubota, Bobcat, Caterpillar et bien d'autres.",
    en: "Quickly search Kubota, Bobcat, Caterpillar equipment and more.",
    nl: "Zoek snel materieel van Kubota, Bobcat, Caterpillar en meer.",
  },

  // ---------- Home categories section
  "home.explore_kicker": { fr: "Explorer", en: "Explore", nl: "Ontdek" },
  "home.categories_title": { fr: "Choisissez votre univers", en: "Choose your universe", nl: "Kies uw universum" },
  "home.categories_subtitle": { fr: "Quatre grandes familles de matériel professionnel d'occasion, du Nord au Sud de la Belgique. En un clic vous êtes dans votre métier.", en: "Four families of used professional equipment, from north to south of Belgium. One click, straight to your trade.", nl: "Vier families van tweedehands professioneel materieel, van noord tot zuid België. Eén klik en u zit in uw vak." },
  "home.popular_categories_title": { fr: "Catégories populaires", en: "Popular categories", nl: "Populaire categorieën" },
  "home.popular_categories_subtitle": {
    fr: "Accédez en un clic aux matériels les plus recherchés en Belgique.",
    en: "One click to the most searched equipment in Belgium.",
    nl: "Met één klik naar het meest gezochte materieel in België.",
  },
  "home.cat_mini_excavators": { fr: "Mini-pelles", en: "Mini excavators", nl: "Minigravers" },
  "home.cat_excavators": { fr: "Pelles", en: "Excavators", nl: "Graafmachines" },
  "home.cat_loaders": { fr: "Chargeuses", en: "Loaders", nl: "Wielladers" },
  "home.cat_telehandlers": { fr: "Télescopiques", en: "Telehandlers", nl: "Verreikers" },
  "home.cat_platforms": { fr: "Nacelles", en: "Aerial platforms", nl: "Hoogwerkers" },
  "home.cat_compactors": { fr: "Compacteurs", en: "Compactors", nl: "Walsen" },
  "home.cat_tools": { fr: "Outillage", en: "Tools", nl: "Gereedschap" },
  "home.cat_garden": { fr: "Matériel de jardin", en: "Garden equipment", nl: "Tuinmaterieel" },
  "home.cat_containers": { fr: "Conteneurs", en: "Containers", nl: "Containers" },
  "home.subcategories_label": { fr: "sous-catégories", en: "subcategories", nl: "subcategorieën" },
  "home.explore_arrow": { fr: "Explorer →", en: "Explore →", nl: "Verkennen →" },

  // ---------- Category names (by slug)
  "category.espaces-verts": { fr: "Espaces verts", en: "Green spaces", nl: "Groenvoorzieningen" },
  "category.btp-chantier": { fr: "Construction & BTP", en: "Construction & Public works", nl: "Bouw & Openbare werken" },
  "category.outillage-professionnel": { fr: "Outillage", en: "Tools", nl: "Gereedschap" },
  "category.agricole": { fr: "Agriculture", en: "Agriculture", nl: "Landbouw" },
  "category.conteneurs": { fr: "Conteneurs", en: "Containers", nl: "Containers" },
  "category.materiaux-chantier": {
    fr: "Matériaux & fournitures métier",
    en: "Trade materials & supplies",
    nl: "Vakmaterialen & leveringen",
  },
  "category.vegetal": {
    fr: "Jardin, terrasse & extérieur",
    en: "Garden, terrace & outdoor",
    nl: "Tuin, terras & buiten",
  },

  "shop.activity_title": {
    fr: "Mon activité",
    en: "My activity",
    nl: "Mijn activiteit",
  },
  "shop.activity_hint": {
    fr: "Indiquez au minimum un service matériel (vente, location, réparation ou pièces) pour apparaître sur la carte « Rechercher un fournisseur ». Les prestations de travaux seules ne sont pas acceptées.",
    en: "Select at least one equipment service (sales, rental, repair or parts) to appear on the Find a supplier map. Service-only trade profiles are not listed.",
    nl: "Selecteer minstens één materieeldienst (verkoop, verhuur, reparatie of onderdelen) om op de kaart « Leverancier zoeken » te staan. Alleen klusdiensten worden niet opgenomen.",
  },
  "shop.directory_checklist_title": {
    fr: "Visibilité carte & annuaire",
    en: "Map & directory visibility",
    nl: "Zichtbaarheid kaart & directory",
  },
  "shop.directory_checklist_intro": {
    fr: "Complétez les éléments ci-dessous pour apparaître dans « Rechercher un fournisseur » (en plus de votre abonnement actif).",
    en: "Complete the items below to appear in Find a supplier (in addition to your active subscription).",
    nl: "Vul onderstaande items aan om in « Leverancier zoeken » te verschijnen (naast uw actieve abonnement).",
  },
  "shop.directory_visible_ok": {
    fr: "Votre boutique est prête pour la carte et l'annuaire.",
    en: "Your shop is ready for the map and directory.",
    nl: "Uw winkel is klaar voor de kaart en directory.",
  },
  "shop.directory_req_equipment_service": {
    fr: "Au moins un service matériel (vente, location, réparation ou pièces)",
    en: "At least one equipment service (sales, rental, repair or parts)",
    nl: "Minstens één materieeldienst (verkoop, verhuur, reparatie of onderdelen)",
  },
  "shop.directory_req_location": {
    fr: "Adresse ou code postal + commune",
    en: "Address or postal code + city",
    nl: "Adres of postcode + gemeente",
  },
  "shop.directory_req_phone": {
    fr: "Téléphone public de contact",
    en: "Public contact phone number",
    nl: "Openbaar contacttelefoonnummer",
  },
  "shop.directory_req_visual": {
    fr: "Logo, bannière, photo galerie ou au moins une annonce publiée",
    en: "Logo, banner, gallery photo or at least one published listing",
    nl: "Logo, banner, galerijfoto of minstens één gepubliceerde advertentie",
  },
  "shop.activity_step_services": {
    fr: "Services & magasin",
    en: "Services & store",
    nl: "Diensten & winkel",
  },
  "shop.activity_step_sectors": {
    fr: "Secteurs d'activité",
    en: "Business sectors",
    nl: "Activiteitssectoren",
  },
  "shop.activity_step_details": {
    fr: "Précisions",
    en: "Details",
    nl: "Details",
  },
  "shop.activity_note_hint": {
    fr: "Exemples de stock, rayons de livraison, spécialités…",
    en: "Stock examples, delivery radius, specialties…",
    nl: "Voorbeelden van voorraad, leveringsradius, specialiteiten…",
  },
  "shop.activity_summary": {
    fr: "{services} service(s) · {sectors} secteur(s)",
    en: "{services} service(s) · {sectors} sector(s)",
    nl: "{services} dienst(en) · {sectors} sector(en)",
  },
  "shop.activity_public_title": {
    fr: "Activité",
    en: "Activity",
    nl: "Activiteit",
  },
  "shop.assortment_title": {
    fr: "Ce que je vends en magasin",
    en: "What I sell in store",
    nl: "Wat ik in de winkel verkoop",
  },
  "shop.assortment_hint": {
    fr: "Cochez vos rayons (plomberie, électricité, couverture, menuiserie, soudure, jardin…). Pas besoin de lister chaque référence.",
    en: "Tick the material / supply families you offer. No need to list every SKU.",
    nl: "Vink de materiaal- / leveringsfamilies aan die u aanbiedt. U hoeft niet elke referentie te vermelden.",
  },
  "shop.assortment_note_label": {
    fr: "Précisions (optionnel)",
    en: "Details (optional)",
    nl: "Details (optioneel)",
  },
  "shop.assortment_note_placeholder": {
    fr: "Ex. : sable 0/2 et 0/4, ciment en sacs, livraison benne dans un rayon de 30 km…",
    en: "E.g. sand 0/2 and 0/4, bagged cement, tipper delivery within 30 km…",
    nl: "Bv. zand 0/2 en 0/4, cement in zakken, levering met kipwagen binnen 30 km…",
  },
  "shop.assortment_public_title": {
    fr: "Ce que nous vendons",
    en: "What we sell",
    nl: "Wat wij verkopen",
  },
  "shop.assortment_public_subtitle": {
    fr: "En magasin, hors machines — sans prix, sur demande.",
    en: "In store, besides machines — no prices, on request.",
    nl: "In de winkel, naast machines — zonder prijzen, op aanvraag.",
  },
  "shop.assortment_public_materials": {
    fr: "Fournitures chantier & métiers",
    en: "Jobsite & trade supplies",
    nl: "Bouw- & vakleveringen",
  },
  "shop.assortment_public_plants": {
    fr: "Jardin, terrasse & extérieur",
    en: "Garden, terrace & outdoor",
    nl: "Tuin, terras & buiten",
  },

  // ---------- Home dynamic feeds
  "home.featured_suppliers_kicker": { fr: "À la une", en: "Featured", nl: "Uitgelicht" },
  "home.featured_suppliers_title": {
    fr: "Fournisseurs à la une",
    en: "Featured suppliers",
    nl: "Uitgelichte leveranciers",
  },
  "home.featured_suppliers_subtitle": {
    fr: "Premium, mieux notés, les plus actifs et les nouveaux professionnels, mis à jour automatiquement.",
    en: "Premium, top-rated, most active and newest professionals, updated automatically.",
    nl: "Premium, best beoordeeld, meest actief en nieuwste professionals, automatisch bijgewerkt.",
  },
  "home.featured_supplier_cta": { fr: "Voir la boutique", en: "View shop", nl: "Winkel bekijken" },
  "home.nearby_listings_kicker": { fr: "Près de vous", en: "Near you", nl: "Bij u in de buurt" },
  "home.nearby_listings_title": {
    fr: "Nouvelles annonces près de chez vous",
    en: "New listings near you",
    nl: "Nieuwe advertenties bij u in de buurt",
  },
  "home.nearby_listings_subtitle": {
    fr: "Les dernières annonces publiées sur MatPass, triées par date.",
    en: "The latest listings on MatPass, sorted by date.",
    nl: "De nieuwste advertenties op MatPass, gesorteerd op datum.",
  },
  "home.nearby_listings_subtitle_geo": {
    fr: "Les annonces les plus récentes à proximité de votre position.",
    en: "The most recent listings near your location.",
    nl: "De meest recente advertenties bij uw locatie.",
  },
  "home.proof_kicker": { fr: "En direct", en: "Live", nl: "Live" },
  "home.proof_title": {
    fr: "Près de vous, maintenant",
    en: "Near you, right now",
    nl: "Bij u in de buurt, nu",
  },
  "home.proof_subtitle": {
    fr: "Annonces et fournisseurs sur MatPass — explorez la carte et passez à l’action.",
    en: "Listings and suppliers on MatPass — explore the map and take action.",
    nl: "Advertenties en leveranciers op MatPass — bekijk de kaart en ga aan de slag.",
  },
  "home.proof_subtitle_geo": {
    fr: "Sélection autour de votre position, mise à jour automatiquement.",
    en: "A selection around your location, updated automatically.",
    nl: "Een selectie rond uw locatie, automatisch bijgewerkt.",
  },
  "home.proof_subtitle_suppliers": {
    fr: "Des professionnels mis en avant près de vos chantiers.",
    en: "Featured professionals near your job sites.",
    nl: "Uitgelichte professionals bij uw werven.",
  },
  "home.trust_kicker": { fr: "Confiance", en: "Trust", nl: "Vertrouwen" },
  "home.trust_title": {
    fr: "Pensé pour les pros belges",
    en: "Built for Belgian pros",
    nl: "Gemaakt voor Belgische professionals",
  },
  "home.see_all_listings": { fr: "Voir toutes les annonces", en: "View all listings", nl: "Alle advertenties bekijken" },

  // ---------- Home recent listings (legacy keys)
  "home.recent_kicker": { fr: "Fraîchement en ligne", en: "Freshly listed", nl: "Nieuw online" },
  "home.recent_title": { fr: "Annonces récentes", en: "Recent listings", nl: "Recente advertenties" },
  "home.see_all": { fr: "Voir tout →", en: "See all →", nl: "Alles bekijken →" },

  // ---------- Home pros section
  "home.pros_kicker": { fr: "Boutiques", en: "Shops", nl: "Winkels" },
  "home.pros_title": { fr: "Professionnels sur MatPass", en: "Professionals on MatPass", nl: "Professionals op MatPass" },
  "home.pros_subtitle": { fr: "Boutiques et vendeurs professionnels présents sur la plateforme.", en: "Professional shops and sellers on the platform.", nl: "Professionele winkels en verkopers op het platform." },
  "home.all_shops": { fr: "Toutes les boutiques →", en: "All shops →", nl: "Alle winkels →" },
  "home.premium_pros_kicker": { fr: "Premium", en: "Premium", nl: "Premium" },
  "home.premium_pros_title": { fr: "Entreprises mises en avant", en: "Featured companies", nl: "Uitgelichte bedrijven" },
  "home.premium_pros_subtitle": {
    fr: "Partenaires Premium visibles en priorité sur la plateforme.",
    en: "Premium partners shown first on the platform.",
    nl: "Premium-partners eerst zichtbaar op het platform.",
  },
  "home.new_suppliers_kicker": { fr: "Réseau", en: "Network", nl: "Netwerk" },
  "home.new_suppliers_title": { fr: "Nouveaux fournisseurs", en: "New suppliers", nl: "Nieuwe leveranciers" },
  "home.new_suppliers_subtitle": {
    fr: "Les derniers professionnels inscrits sur MatPass.",
    en: "The latest professionals who joined MatPass.",
    nl: "De nieuwste professionals op MatPass.",
  },
  "home.find_suppliers": { fr: "Voir la carte →", en: "View map →", nl: "Kaart bekijken →" },

  // ---------- Home entrepreneurs value
  "home.entrepreneurs_kicker": {
    fr: "Pour les entrepreneurs",
    en: "For business owners",
    nl: "Voor ondernemers",
  },
  "home.entrepreneurs_title": {
    fr: "Pourquoi les pros utilisent MATPASS",
    en: "Why pros use MATPASS",
    nl: "Waarom professionals MATPASS gebruiken",
  },
  "home.entrepreneurs_lead": {
    fr: "Moins de temps perdu au téléphone, plus de temps sur le chantier — fournisseurs et matériel au même endroit.",
    en: "Less time on the phone, more time on site — suppliers and equipment in one place.",
    nl: "Minder tijd aan de telefoon, meer tijd op de werf — leveranciers en materieel op één plek.",
  },
  "home.entrepreneurs_1_title": {
    fr: "Gagner du temps sur les fournisseurs",
    en: "Save time finding suppliers",
    nl: "Tijd besparen bij leveranciers",
  },
  "home.entrepreneurs_1_desc": {
    fr: "Trouvez rapidement qui vend, loue ou répare près de vous, sans enchaîner les appels.",
    en: "Quickly find who sells, rents or repairs near you — without endless phone calls.",
    nl: "Vind snel wie bij u in de buurt verkoopt, verhuurt of herstelt — zonder eindeloze telefoontjes.",
  },
  "home.entrepreneurs_2_title": {
    fr: "Rester proche du chantier",
    en: "Stay close to the job site",
    nl: "Dicht bij de werf blijven",
  },
  "home.entrepreneurs_2_desc": {
    fr: "Filtrez par distance et localisation pour choisir le bon interlocuteur au bon endroit.",
    en: "Filter by distance and location to pick the right contact in the right place.",
    nl: "Filter op afstand en locatie om de juiste contactpersoon op de juiste plek te kiezen.",
  },
  "home.entrepreneurs_3_title": {
    fr: "Préparer vos devis plus vite",
    en: "Prepare quotes faster",
    nl: "Offertes sneller voorbereiden",
  },
  "home.entrepreneurs_3_desc": {
    fr: "Comparez disponibilité, services et matériel d'occasion pour chiffrer plus sereinement.",
    en: "Compare availability, services and used equipment to quote with more confidence.",
    nl: "Vergelijk beschikbaarheid, diensten en tweedehands materieel om rustiger te calculeren.",
  },
  "home.entrepreneurs_cta_suppliers": {
    fr: "Trouver un fournisseur",
    en: "Find a supplier",
    nl: "Leverancier zoeken",
  },
  "home.entrepreneurs_cta_marketplace": {
    fr: "Voir l'occasion",
    en: "Browse used gear",
    nl: "Tweedehands bekijken",
  },

  // ---------- Home why MATPASS
  "home.why_kicker": { fr: "Pourquoi MATPASS", en: "Why MATPASS", nl: "Waarom MATPASS" },
  "home.why_title": {
    fr: "La plateforme pensée pour le matériel professionnel",
    en: "Built for professional equipment",
    nl: "Ontworpen voor professioneel materieel",
  },
  "home.why_lead": {
    fr: "Pensée pour les entrepreneurs : acheter, vendre et trouver un fournisseur plus vite, plus près, en toute confiance.",
    en: "Built for entrepreneurs: buy, sell and find a supplier faster, closer, with confidence.",
    nl: "Gemaakt voor ondernemers: sneller kopen, verkopen en een leverancier vinden, dichterbij en met vertrouwen.",
  },
  "home.why_title_pre": { fr: "La marketplace pensée pour le matériel", en: "The marketplace designed for", nl: "De marktplaats ontworpen voor" },
  "home.why_title_hl": { fr: "professionnel", en: "professional equipment", nl: "professioneel materieel" },
  "home.why_title_dot": { fr: ".", en: ".", nl: "." },
  "home.why_subtitle": { fr: "MATPASS n'est pas une marketplace généraliste : chaque fonctionnalité est conçue pour vendre et acheter du matériel technique en toute confiance.", en: "MATPASS is not a generalist marketplace: every feature is built to buy and sell technical equipment with confidence.", nl: "MATPASS is geen algemene marktplaats: elke functie is ontworpen om technisch materieel met vertrouwen te kopen en verkopen." },
  "home.why1_title": { fr: "Acheter rapidement", en: "Buy fast", nl: "Snel kopen" },
  "home.why1_desc": { fr: "Filtres pro, carte et recherche intelligente pour trouver le bon matériel en quelques clics.", en: "Pro filters, map and smart search to find the right machine in a few clicks.", nl: "Pro-filters, kaart en slimme zoekopdracht om snel het juiste materieel te vinden." },
  "home.why2_title": { fr: "Vendre facilement", en: "Sell easily", nl: "Makkelijk verkopen" },
  "home.why2_desc": { fr: "Déposez une annonce gratuitement, boostez-la à la demande et touchez des acheteurs sérieux.", en: "Post for free, boost on demand and reach serious buyers.", nl: "Plaats gratis, boost op aanvraag en bereik serieuze kopers." },
  "home.why3_title": { fr: "Trouver un fournisseur proche", en: "Find a nearby supplier", nl: "Vind een leverancier dichtbij" },
  "home.why3_desc": { fr: "Localisez vente, location, réparation et pièces autour de votre chantier.", en: "Locate sales, rental, repair and parts around your job site.", nl: "Lokaliseer verkoop, verhuur, reparatie en onderdelen rond uw werf." },
  "home.why4_title": { fr: "Gagner du temps", en: "Save time", nl: "Tijd besparen" },
  "home.why4_desc": { fr: "Tout le parcours en un seul endroit : recherche, contact, messagerie et suivi.", en: "The full journey in one place: search, contact, messaging and follow-up.", nl: "Het hele traject op één plek: zoeken, contact, berichten en opvolging." },
  "home.why5_title": { fr: "Comparer les offres", en: "Compare offers", nl: "Aanbiedingen vergelijken" },
  "home.why5_desc": { fr: "Prix, heures, année et distance : décidez avec les bons critères métier.", en: "Price, hours, year and distance: decide with the right trade criteria.", nl: "Prijs, uren, jaar en afstand: beslis met de juiste criteria." },
  "home.why6_title": { fr: "Développer son entreprise", en: "Grow your business", nl: "Uw bedrijf laten groeien" },
  "home.why6_desc": { fr: "Boutique publique, badge vérifié et statistiques pour les professionnels ambitieux.", en: "Public shop, verified badge and analytics for ambitious professionals.", nl: "Publieke winkel, geverifieerde badge en statistieken voor ambitieuze professionals." },
  "home.benefit1_title": { fr: "Mise en relation directe", en: "Direct connection", nl: "Directe connectie" },
  "home.benefit1_desc": { fr: "MatPass met en relation acheteurs et vendeurs. Vous échangez directement, sans intermédiaire opaque.", en: "MatPass connects buyers and sellers. You deal directly, without a black-box middleman.", nl: "MatPass verbindt kopers en verkopers. U handelt rechtstreeks, zonder onduidelijke tussenpersoon." },
  "home.benefit2_title": { fr: "Filtres pro", en: "Pro filters", nl: "Pro-filters" },
  "home.benefit2_desc": { fr: "Marque, modèle, année, heures moteur, état, distance : trouvez précisément le bon matériel.", en: "Brand, model, year, engine hours, condition, distance: find exactly the right equipment.", nl: "Merk, model, jaar, motoruren, staat, afstand: vind precies het juiste materieel." },
  "home.benefit3_title": { fr: "Contact direct", en: "Direct contact", nl: "Rechtstreeks contact" },
  "home.benefit3_desc": { fr: "Messagerie interne + téléphone. Pas d'intermédiaire, échangez librement avec le vendeur.", en: "Internal messaging + phone. No middleman, talk directly to the seller.", nl: "Interne berichten + telefoon. Geen tussenpersoon, praat rechtstreeks met de verkoper." },
  "home.benefit4_title": { fr: "Paiements sécurisés", en: "Secure payments", nl: "Veilige betalingen" },
  "home.benefit4_desc": { fr: "Vos abonnements et boosts sont traités par Stripe, avec TVA gérée automatiquement.", en: "Your subscriptions and boosts are processed by Stripe, with VAT handled automatically.", nl: "Uw abonnementen en boosts worden verwerkt door Stripe, met btw automatisch geregeld." },
  "home.benefit5_title": { fr: "Proximité belge", en: "Belgian proximity", nl: "Belgische nabijheid" },
  "home.benefit5_desc": { fr: "Trouvez du matériel à moins de 10, 25, 50 ou 100 km, partout en Belgique. Distance calculée en temps réel.", en: "Find equipment within 10, 25, 50 or 100 km, all over Belgium. Distance computed in real time.", nl: "Vind materieel binnen 10, 25, 50 of 100 km, in heel België. Afstand realtime berekend." },
  "home.benefit6_title": { fr: "Dépôt gratuit", en: "Free posting", nl: "Gratis plaatsen" },
  "home.benefit6_desc": { fr: "Publier une annonce reste 100 % gratuit. Boostez à la demande à partir de 4,99 €.", en: "Posting an ad stays 100% free. Boost on demand from €4.99.", nl: "Een advertentie plaatsen blijft 100% gratis. Boost op aanvraag vanaf €4,99." },
  "home.benefit7_title": { fr: "Support 24/7", en: "24/7 Support", nl: "24/7 ondersteuning" },
  "home.benefit7_desc": { fr: "Assistant IA disponible en permanence et conseiller humain sur demande.", en: "AI assistant available round the clock and human advisor on request.", nl: "AI-assistent altijd beschikbaar en menselijke adviseur op aanvraag." },
  "home.benefit8_title": { fr: "Fait pour les pros", en: "Made for pros", nl: "Gemaakt voor professionals" },
  "home.benefit8_desc": { fr: "Statistiques et boutique publique, pensé pour les professionnels.", en: "Analytics and public shop, designed for professionals.", nl: "Statistieken en publieke winkel, ontworpen voor professionals." },
  "home.cta_view_pricing": { fr: "Voir les tarifs Pro", en: "View Pro pricing", nl: "Bekijk Pro-tarieven" },
  "home.cta_post_ad": { fr: "Déposer une annonce", en: "Post an ad", nl: "Advertentie plaatsen" },

  // ---------- Home testimonials
  "home.testimonials_kicker": { fr: "Ils nous font confiance", en: "Trusted by pros", nl: "Vertrouwd door professionals" },
  "home.testimonials_title": { fr: "Témoignages", en: "Testimonials", nl: "Getuigenissen" },
  "home.testimonials_subtitle": {
    fr: "Ce que disent les professionnels qui utilisent MATPASS au quotidien.",
    en: "What pros who use MATPASS every day have to say.",
    nl: "Wat professionals die MATPASS dagelijks gebruiken ervan vinden.",
  },
  "home.t1_quote": {
    fr: "J’ai trouvé une mini-pelle Kubota à 35 km de mon chantier en moins d’une heure. Contact direct, transaction claire.",
    en: "I found a Kubota mini excavator 35 km from my site in under an hour. Direct contact, clean deal.",
    nl: "Ik vond een Kubota-minigraver op 35 km van mijn werf in minder dan een uur. Rechtstreeks contact, duidelijke deal.",
  },
  "home.t1_author": { fr: "Marc D.", en: "Marc D.", nl: "Marc D." },
  "home.t1_role": { fr: "Entrepreneur TP, Brabant wallon", en: "Civil works contractor, Walloon Brabant", nl: "Aannemer GWW, Waals-Brabant" },
  "home.t2_quote": {
    fr: "La carte des fournisseurs nous fait gagner un temps fou pour la location et l’hydraulique autour de Namur.",
    en: "The supplier map saves us huge time for rental and hydraulics around Namur.",
    nl: "De leverancierskaart bespaart ons enorm veel tijd voor verhuur en hydraulica rond Namen.",
  },
  "home.t2_author": { fr: "Sophie L.", en: "Sophie L.", nl: "Sophie L." },
  "home.t2_role": { fr: "Responsable matériel, entreprise de construction", en: "Fleet manager, construction company", nl: "Materieelverantwoordelijke, bouwbedrijf" },
  "home.t3_quote": {
    fr: "Depuis notre boutique MatPass, on reçoit des contacts qualifiés chaque semaine. Le badge vérifié rassure les acheteurs.",
    en: "Since our MatPass shop went live, we get qualified leads every week. The verified badge reassures buyers.",
    nl: "Sinds onze MatPass-winkel live is, krijgen we elke week gekwalificeerde leads. De geverifieerde badge stelt kopers gerust.",
  },
  "home.t3_author": { fr: "Johan V.", en: "Johan V.", nl: "Johan V." },
  "home.t3_role": { fr: "Dirigeant, concession matériel Occ. Flandre", en: "Owner, used equipment dealer, Flanders", nl: "Zaakvoerder, handelaar tweedehands materieel, Vlaanderen" },

  // ---------- Listing card
  "card.no_photo": { fr: "Pas de photo", en: "No photo", nl: "Geen foto" },
  "card.premium": { fr: "Premium", en: "Premium", nl: "Premium" },
  "card.highlighted": { fr: "En avant", en: "Featured", nl: "Uitgelicht" },
  "card.pro": { fr: "Pro", en: "Pro", nl: "Pro" },
  "card.professional": { fr: "Professionnel", en: "Professional", nl: "Professional" },
  "card.individual": { fr: "Particulier", en: "Individual", nl: "Particulier" },
  "card.delivery": { fr: "Livraison", en: "Delivery", nl: "Levering" },
  "card.per_day": { fr: "/ jour", en: "/ day", nl: "/ dag" },
  "card.rental": { fr: "Location", en: "Rental", nl: "Verhuur" },
  "card.listing_singular": { fr: "annonce", en: "listing", nl: "advertentie" },
  "card.listing_plural": { fr: "annonces", en: "listings", nl: "advertenties" },
  "card.view_shop": { fr: "Voir la boutique →", en: "View shop →", nl: "Winkel bekijken →" },

  // ---------- Premium carousel
  "premium.kicker": { fr: "Premium", en: "Premium", nl: "Premium" },
  "premium.title": { fr: "À la une", en: "Featured", nl: "Uitgelicht" },
  "premium.see_all": { fr: "Voir tout", en: "See all", nl: "Alles bekijken" },

  // ---------- AI Recommendations
  "reco.kicker": { fr: "Recommandé pour vous", en: "Recommended for you", nl: "Aanbevolen voor u" },
  "reco.title": { fr: "Sélection MATPASS AI", en: "MATPASS AI selection", nl: "MATPASS AI-selectie" },
  "reco.explore": { fr: "Explorer", en: "Explore", nl: "Verkennen" },

  // ---------- AdSlot
  "ad.publicity": { fr: "Publicité", en: "Advertisement", nl: "Advertentie" },

  // ---------- Common actions
  "action.save": { fr: "Enregistrer", en: "Save", nl: "Opslaan" },
  "action.cancel": { fr: "Annuler", en: "Cancel", nl: "Annuleren" },
  "action.delete": { fr: "Supprimer", en: "Delete", nl: "Verwijderen" },
  "action.edit": { fr: "Modifier", en: "Edit", nl: "Bewerken" },
  "action.share": { fr: "Partager", en: "Share", nl: "Delen" },
  "action.duplicate": { fr: "Dupliquer", en: "Duplicate", nl: "Dupliceren" },
  "action.mark_sold": { fr: "Marquer comme vendue", en: "Mark as sold", nl: "Markeren als verkocht" },
  "action.sale_complete": { fr: "Vente conclue", en: "Sale completed", nl: "Verkoop afgerond" },
  "action.sale_cancel": { fr: "Annuler la transaction", en: "Cancel transaction", nl: "Transactie annuleren" },
  "sale.confirm_title": { fr: "Confirmer la vente ?", en: "Confirm the sale?", nl: "Verkoop bevestigen?" },
  "sale.transaction_ended": { fr: "Transaction terminée", en: "Transaction completed", nl: "Transactie afgerond" },
  "action.close": { fr: "Fermer", en: "Close", nl: "Sluiten" },
  "action.continue": { fr: "Continuer", en: "Continue", nl: "Doorgaan" },
  "action.back": { fr: "Retour", en: "Back", nl: "Terug" },
  "action.confirm": { fr: "Confirmer", en: "Confirm", nl: "Bevestigen" },
  "action.see_similar": { fr: "Voir des annonces similaires", en: "See similar listings", nl: "Vergelijkbare advertenties bekijken" },

  // ---------- Dashboard
  "dashboard.title": { fr: "Mon tableau de bord", en: "My dashboard", nl: "Mijn dashboard" },
  "dashboard.welcome_prefix": { fr: "Bonjour", en: "Hello", nl: "Hallo" },
  "dashboard.welcome_suffix": { fr: ". Voici les performances de vos annonces.", en: ". Here's how your listings are performing.", nl: ". Zo presteren uw advertenties." },
  "dashboard.stat_views": { fr: "Vues", en: "Views", nl: "Weergaven" },
  "dashboard.stat_favorites": { fr: "Favoris", en: "Favorites", nl: "Favorieten" },
  "dashboard.stat_messages": { fr: "Messages", en: "Messages", nl: "Berichten" },
  "dashboard.stat_active": { fr: "Annonces actives", en: "Active listings", nl: "Actieve advertenties" },
  "dashboard.my_listings": { fr: "Mes annonces", en: "My listings", nl: "Mijn advertenties" },
  "dashboard.empty_title": { fr: "Vous n'avez pas encore publié d'annonce", en: "You haven't posted any listings yet", nl: "U heeft nog geen advertenties geplaatst" },
  "dashboard.empty_desc": {
    fr: "Commencez dès maintenant pour toucher des milliers de professionnels partout en Belgique.",
    en: "Start now to reach thousands of professionals across Belgium.",
    nl: "Begin nu om duizenden professionals in heel België te bereiken.",
  },
  "dashboard.tips_title": { fr: "Conseils MATPASS", en: "MATPASS Tips", nl: "MATPASS Tips" },
  "dashboard.quality_title": { fr: "Score de qualité des annonces", en: "Listing quality score", nl: "Kwaliteitsscore advertenties" },
  "dashboard.improve": { fr: "Améliorer mes annonces", en: "Improve my listings", nl: "Mijn advertenties verbeteren" },


  // ---------- Footer
  "footer.tagline": { fr: "La plateforme belge spécialisée dans le matériel professionnel d'occasion, pour les professionnels et les particuliers sérieux.", en: "The Belgian marketplace for used professional equipment, for pros and serious individuals.", nl: "Het Belgische platform voor tweedehands professioneel materieel, voor professionals en serieuze particulieren." },
  "footer.made_in_be": { fr: "Créé en Belgique pour les professionnels belges", en: "Made in Belgium for Belgian professionals", nl: "Gemaakt in België voor Belgische professionals" },
  "footer.buy_better_sell_more": { fr: "Achetez mieux. Revendez plus.", en: "Buy smarter. Sell more.", nl: "Koop slimmer. Verkoop meer." },
  "footer.col_marketplace": { fr: "Marketplace", en: "Marketplace", nl: "Marktplaats" },
  "footer.col_matpass": { fr: "MATPASS", en: "MATPASS", nl: "MATPASS" },
  "footer.col_legal": { fr: "Légal", en: "Legal", nl: "Juridisch" },
  "footer.link_search": { fr: "Rechercher", en: "Search", nl: "Zoeken" },
  "footer.link_post_ad": { fr: "Déposer une annonce", en: "Post an ad", nl: "Advertentie plaatsen" },
  "footer.link_favorites": { fr: "Mes favoris", en: "My favorites", nl: "Mijn favorieten" },
  "footer.link_contacted": { fr: "Entreprises contactées", en: "Contacted companies", nl: "Gecontacteerde bedrijven" },
  "footer.link_messages": { fr: "Messages", en: "Messages", nl: "Berichten" },
  "footer.link_pricing": { fr: "Tarifs", en: "Pricing", nl: "Tarieven" },
  "footer.link_become_pro": { fr: "Devenir Pro", en: "Become a Pro", nl: "Word Pro" },
  "footer.link_pro_area": { fr: "Espace Professionnel", en: "Pro Area", nl: "Professionele ruimte" },
  "footer.link_support": { fr: "Aide & Support", en: "Help & Support", nl: "Hulp & Ondersteuning" },
  "footer.link_legal_notices": { fr: "Mentions légales", en: "Legal notices", nl: "Wettelijke vermeldingen" },
  "footer.link_terms": { fr: "CGU", en: "Terms", nl: "Algemene voorwaarden" },
  "footer.link_privacy": { fr: "Politique de confidentialité", en: "Privacy policy", nl: "Privacybeleid" },
  "footer.link_contact": { fr: "Contact", en: "Contact", nl: "Contact" },
  "footer.rights_reserved": { fr: "Tous droits réservés.", en: "All rights reserved.", nl: "Alle rechten voorbehouden." },
  "footer.stripe_secured": { fr: "Paiements sécurisés Stripe", en: "Stripe-secured payments", nl: "Beveiligde betalingen via Stripe" },

  // ---------- Beta landing
  "beta.badge": { fr: "🚀 BETA MATPASS", en: "🚀 MATPASS BETA", nl: "🚀 MATPASS BÈTA" },
  "beta.title": { fr: "Bienvenue dans la version Beta de MATPASS", en: "Welcome to the MATPASS Beta", nl: "Welkom bij de MATPASS Bèta" },
  "beta.subtitle": {
    fr: "Vous êtes parmi les premiers à découvrir la plateforme belge de matériel professionnel d'occasion. Votre feedback nous aide à construire l'expérience de demain.",
    en: "You're among the first to discover the Belgian marketplace for used professional equipment. Your feedback helps us build tomorrow's experience.",
    nl: "U bent een van de eersten die het Belgische platform voor tweedehands professioneel materieel ontdekt. Uw feedback helpt ons de ervaring van morgen op te bouwen.",
  },
  "beta.cta_start": { fr: "Commencer le test", en: "Start the test", nl: "Begin de test" },

  // ---------- Common labels
  "label.email": { fr: "Adresse email", en: "Email address", nl: "E-mailadres" },
  "label.password": { fr: "Mot de passe", en: "Password", nl: "Wachtwoord" },
  "label.new_password": { fr: "Nouveau mot de passe", en: "New password", nl: "Nieuw wachtwoord" },
  "label.city": { fr: "Ville", en: "City", nl: "Stad" },
  "label.postal_code": { fr: "Code postal", en: "Postal code", nl: "Postcode" },
  "label.phone": { fr: "Téléphone", en: "Phone", nl: "Telefoon" },
  "label.country": { fr: "Pays", en: "Country", nl: "Land" },
  "label.province": { fr: "Province", en: "Province", nl: "Provincie" },
  "label.price": { fr: "Prix", en: "Price", nl: "Prijs" },
  "label.year": { fr: "Année", en: "Year", nl: "Jaar" },
  "label.hours": { fr: "Heures", en: "Hours", nl: "Uren" },
  "label.condition": { fr: "État", en: "Condition", nl: "Staat" },
  "label.category": { fr: "Catégorie", en: "Category", nl: "Categorie" },
  "label.brand": { fr: "Marque", en: "Brand", nl: "Merk" },
  "label.model": { fr: "Modèle", en: "Model", nl: "Model" },

  // ---------- Status
  "status.active": { fr: "Active", en: "Active", nl: "Actief" },
  "status.sold": { fr: "Vendue", en: "Sold", nl: "Verkocht" },
  "status.draft": { fr: "Brouillon", en: "Draft", nl: "Concept" },
  "status.suspended": { fr: "Suspendue", en: "Suspended", nl: "Opgeschort" },

  // ---------- Email verify banner
  "verify.banner_title": { fr: "Vérifiez votre adresse email pour publier une annonce", en: "Verify your email address to post a listing", nl: "Verifieer uw e-mailadres om een advertentie te plaatsen" },
  "verify.resend": { fr: "Renvoyer le lien", en: "Resend link", nl: "Link opnieuw versturen" },

  // ---------- Search
  "search.title": { fr: "Rechercher du matériel", en: "Search equipment", nl: "Zoek materieel" },
  "search.marketplace_kicker": { fr: "Marché de l'occasion", en: "Used marketplace", nl: "Tweedehandsmarkt" },
  "search.marketplace_title": {
    fr: "Vous explorez le marché de l'occasion",
    en: "You're browsing the used marketplace",
    nl: "U verkent de tweedehandsmarkt",
  },
  "search.marketplace_subtitle": {
    fr: "Achetez du matériel pro d'occasion, ou déposez votre annonce en quelques minutes.",
    en: "Buy used pro equipment, or post your listing in a few minutes.",
    nl: "Koop gebruikte pro-uitrusting, of plaats uw advertentie in enkele minuten.",
  },
  "search.nearme_title": {
    fr: "Près de chez vous ?",
    en: "Near you?",
    nl: "Bij u in de buurt?",
  },
  "search.nearme_hint": {
    fr: "Centrez les résultats autour de votre position. Les annonces restent visibles même sans GPS.",
    en: "Center results around your location. Listings stay visible even without GPS.",
    nl: "Centreer resultaten rond uw locatie. Advertenties blijven zichtbaar, ook zonder GPS.",
  },
  "search.nearme_cta": {
    fr: "Voir près de chez moi",
    en: "Show near me",
    nl: "Toon bij mij",
  },
  "search.geo_loading": { fr: "Localisation…", en: "Locating…", nl: "Lokaliseren…" },
  "search.universes_label": {
    fr: "Par où commencer ?",
    en: "Where to start?",
    nl: "Waar wilt u beginnen?",
  },
  "search.discover_tile": {
    fr: "Découvrir",
    en: "Discover",
    nl: "Ontdekken",
  },
  "search.discover_kicker": {
    fr: "Découvrir",
    en: "Discover",
    nl: "Ontdekken",
  },
  "search.discover_title": {
    fr: "Machines mélangées du marché",
    en: "Mixed machines from the market",
    nl: "Gemengde machines van de markt",
  },
  "search.discover_subtitle": {
    fr: "Un aperçu varié de l'occasion : BTP, espaces verts, agricole et outillage.",
    en: "A mixed peek at used gear: construction, greenspace, agri and tools.",
    nl: "Een gevarieerde blik op tweedehands: bouw, groen, landbouw en gereedschap.",
  },
  "search.quick_types_label": {
    fr: "Types fréquents",
    en: "Popular types",
    nl: "Populaire types",
  },
  "search.sell_banner_title": {
    fr: "Vous avez du matériel à vendre ?",
    en: "Got equipment to sell?",
    nl: "Heeft u materiaal te verkopen?",
  },
  "search.sell_banner_hint": {
    fr: "Publiez gratuitement et touchez des acheteurs pros et particuliers en Belgique.",
    en: "Post for free and reach pro and private buyers in Belgium.",
    nl: "Plaats gratis en bereik professionele en particuliere kopers in België.",
  },
  "search.empty_first_title": {
    fr: "Pas encore d'annonce dans cette sélection",
    en: "No listings in this selection yet",
    nl: "Nog geen advertenties in deze selectie",
  },
  "search.empty_first_hint": {
    fr: "Élargissez vos filtres, ou soyez le premier à publier ici.",
    en: "Widen your filters, or be the first to post here.",
    nl: "Verruim uw filters, of wees de eerste die hier plaatst.",
  },
  "search.empty_reset": { fr: "Réinitialiser les filtres", en: "Reset filters", nl: "Filters resetten" },
  "search.filter_province": { fr: "Province (Belgique)", en: "Province (Belgium)", nl: "Provincie (België)" },
  "search.all_belgium": { fr: "Toute la Belgique", en: "All Belgium", nl: "Heel België" },
  "search.reset": { fr: "Réinitialiser les filtres", en: "Reset filters", nl: "Filters wissen" },
  "search.no_results": { fr: "Aucune annonce ne correspond à vos critères", en: "No listings match your criteria", nl: "Geen advertenties komen overeen met uw criteria" },

  // ---------- Search filters
  "search.title_h1": { fr: "Rechercher du matériel professionnel", en: "Search professional equipment", nl: "Professioneel materieel zoeken" },
  "search.subtitle": { fr: "Filtrez par catégorie, marque, région et budget.", en: "Filter by category, brand, region and budget.", nl: "Filter op categorie, merk, regio en budget." },
  "search.placeholder_q": { fr: "Kubota, JCB, Husqvarna, tondeuse, mini-pelle… (partout en Belgique)", en: "Kubota, JCB, Husqvarna, mower, mini-excavator… (all over Belgium)", nl: "Kubota, JCB, Husqvarna, maaier, minigraver… (in heel België)" },
  "search.cta_search": { fr: "Rechercher", en: "Search", nl: "Zoeken" },
  "search.suggest_loading": { fr: "Suggestions…", en: "Suggestions…", nl: "Suggesties…" },
  "search.suggest_empty": { fr: "Aucune suggestion", en: "No suggestions", nl: "Geen suggesties" },
  "search.suggest_equipment": { fr: "Matériels", en: "Equipment", nl: "Materieel" },
  "search.suggest_brands": { fr: "Marques", en: "Brands", nl: "Merken" },
  "search.suggest_models": { fr: "Modèles", en: "Models", nl: "Modellen" },
  "search.suggest_categories": { fr: "Catégories", en: "Categories", nl: "Categorieën" },
  "search.suggest_sectors": { fr: "Secteurs", en: "Sectors", nl: "Sectoren" },
  "search.suggest_offers": { fr: "Types d'annonces", en: "Listing types", nl: "Advertentietypes" },
  "search.suggest_listings": { fr: "Annonces", en: "Listings", nl: "Advertenties" },
  "search.filter_category": { fr: "Catégorie", en: "Category", nl: "Categorie" },
  "search.filter_subcategory": { fr: "Sous-catégorie", en: "Subcategory", nl: "Subcategorie" },
  "search.filter_machine_type": { fr: "Type de machine", en: "Machine type", nl: "Machinetype" },
  "search.filter_machine_hint": { fr: "Choisissez d'abord une catégorie pour afficher les types de machines.", en: "Pick a category first to see machine types.", nl: "Kies eerst een categorie om machinetypes te zien." },
  "search.filter_location": { fr: "Localisation", en: "Location", nl: "Locatie" },
  "search.filter_extras": { fr: "Options supplémentaires", en: "Extra options", nl: "Extra opties" },
  "search.filter_brand": { fr: "Marque", en: "Brand", nl: "Merk" },
  "search.filter_price_min": { fr: "Prix min (€)", en: "Min price (€)", nl: "Min prijs (€)" },
  "search.filter_price_max": { fr: "Prix max (€)", en: "Max price (€)", nl: "Max prijs (€)" },
  "search.filter_year_min": { fr: "Année min", en: "Year from", nl: "Jaar vanaf" },
  "search.filter_hours_max": { fr: "Heures max", en: "Max hours", nl: "Max uren" },
  "search.filter_condition": { fr: "État", en: "Condition", nl: "Staat" },
  "search.filter_seller_type": { fr: "Type de vendeur", en: "Seller type", nl: "Type verkoper" },
  "search.filter_delivery": { fr: "Livraison possible", en: "Delivery available", nl: "Levering mogelijk" },
  "search.filter_radius": { fr: "Rayon", en: "Radius", nl: "Straal" },
  "search.sort": { fr: "Trier par", en: "Sort by", nl: "Sorteren op" },
  "search.sort_recent": { fr: "Les plus récentes", en: "Most recent", nl: "Meest recent" },
  "search.sort_price_asc": { fr: "Les moins chères", en: "Lowest price", nl: "Goedkoopste" },
  "search.sort_price_desc": { fr: "Les plus chères", en: "Highest price", nl: "Duurste" },
  "search.results_count": { fr: "annonces", en: "listings", nl: "advertenties" },
  "search.pagination_prev": { fr: "Précédent", en: "Previous", nl: "Vorige" },
  "search.pagination_next": { fr: "Suivant", en: "Next", nl: "Volgende" },
  "search.smart_search": { fr: "Recherche intelligente (IA)", en: "Smart search (AI)", nl: "Slim zoeken (AI)" },
  "search.smart_placeholder": { fr: "Ex: Je cherche une mini-pelle Kubota de moins de 20 000 € proche de Namur", en: "e.g. I'm looking for a Kubota mini-excavator under €20,000 near Namur", nl: "Bijv. ik zoek een Kubota minigraver onder €20.000 bij Namen" },
  "search.filters": { fr: "Filtres", en: "Filters", nl: "Filters" },
  "search.clear": { fr: "Effacer", en: "Clear", nl: "Wissen" },
  "search.view_list": { fr: "Liste", en: "List", nl: "Lijst" },
  "search.view_map": { fr: "Carte", en: "Map", nl: "Kaart" },
  "search.use_my_location": { fr: "Utiliser ma position", en: "Use my location", nl: "Mijn locatie gebruiken" },
  "search.save": { fr: "Enregistrer", en: "Save", nl: "Opslaan" },
  "search.save_alert": { fr: "Créer une alerte", en: "Create alert", nl: "Alert maken" },
  "search.save_search_title": { fr: "Créer une alerte", en: "Create an alert", nl: "Een alert maken" },
  "search.save_alert_intro": {
    fr: "On vous prévient dès qu’une nouvelle annonce correspond à ces filtres.",
    en: "We'll notify you when a new listing matches these filters.",
    nl: "We waarschuwen u zodra een nieuwe advertentie aan deze filters voldoet.",
  },
  "search.save_name_label": { fr: "Nom de l’alerte", en: "Alert name", nl: "Naam van de alert" },
  "search.save_name_placeholder": { fr: "Ex : Mini-pelle · 2–5 t · 50 km", en: "e.g. Mini excavator · 2–5 t · 50 km", nl: "Bijv. Minigraver · 2–5 t · 50 km" },
  "search.save_notify_label": { fr: "Notifications email", en: "Email notifications", nl: "E-mailmeldingen" },
  "search.save_alert_hint": {
    fr: "Email + notification dès qu’une machine correspond (ex. mini-pelle 2–5 t près de chez vous).",
    en: "Email + notification when a machine matches (e.g. 2–5 t mini excavator near you).",
    nl: "E-mail + melding wanneer een machine overeenkomt (bijv. minigraver 2–5 t in de buurt).",
  },
  "search.save_alert_cta": { fr: "Activer l’alerte", en: "Enable alert", nl: "Alert activeren" },
  "search.filter_weight": { fr: "Tonnage (t)", en: "Weight (t)", nl: "Tonnage (t)" },
  "search.filter_weight_hint": { fr: "Ex. mini-pelle : 2 à 5 tonnes", en: "e.g. mini excavator: 2 to 5 tonnes", nl: "Bijv. minigraver: 2 tot 5 ton" },
  "search.weight_min_placeholder": { fr: "Min t", en: "Min t", nl: "Min t" },
  "search.weight_max_placeholder": { fr: "Max t", en: "Max t", nl: "Max t" },
  "search.signup_alerts_title": {
    fr: "Ne manquez aucune nouvelle annonce",
    en: "Don't miss new listings",
    nl: "Mis geen nieuwe advertenties",
  },
  "search.signup_alerts_hint": {
    fr: "Créez un compte gratuit pour enregistrer vos recherches et être alerté dès qu'une machine correspond à vos critères.",
    en: "Create a free account to save your searches and get alerted when a machine matches your criteria.",
    nl: "Maak een gratis account aan om zoekopdrachten op te slaan en een melding te krijgen wanneer een machine aan uw criteria voldoet.",
  },
  "search.signup_alerts_cta": {
    fr: "Créer un compte",
    en: "Create an account",
    nl: "Account aanmaken",
  },
  "search.signup_alerts_dismiss": {
    fr: "Masquer",
    en: "Dismiss",
    nl: "Sluiten",
  },
  "search.smart_dialog_title": { fr: "Recherche intelligente", en: "Smart search", nl: "Slim zoeken" },
  "search.smart_hint": { fr: "Décrivez ce que vous cherchez comme si vous parliez à un conseiller. L'IA convertit votre demande en filtres.", en: "Describe what you're looking for as if talking to an advisor. The AI turns it into filters.", nl: "Beschrijf wat u zoekt alsof u met een adviseur praat. AI zet dit om in filters." },
  "search.analyzing": { fr: "Analyse…", en: "Analyzing…", nl: "Analyseren…" },
  "search.filter_price_label": { fr: "Prix (€)", en: "Price (€)", nl: "Prijs (€)" },
  "search.min": { fr: "Min", en: "Min", nl: "Min" },
  "search.max": { fr: "Max", en: "Max", nl: "Max" },
  "search.all_fem": { fr: "Toutes", en: "All", nl: "Alle" },
  "search.all_masc": { fr: "Tous", en: "All", nl: "Alle" },
  "search.brand_placeholder": { fr: "John Deere, Kubota…", en: "John Deere, Kubota…", nl: "John Deere, Kubota…" },
  "search.only_with_delivery": { fr: "Uniquement avec livraison", en: "With delivery only", nl: "Alleen met levering" },
  "search.city_placeholder": { fr: "Ex : Bruxelles, Liège", en: "e.g. Brussels, Liège", nl: "Bijv. Brussel, Luik" },
  "search.city_not_found": { fr: "Aucune ville trouvée", en: "No city found", nl: "Geen stad gevonden" },
  "search.postal_not_found": { fr: "Aucun code postal trouvé", en: "No postal code found", nl: "Geen postcode gevonden" },
  "search.postal_placeholder": { fr: "Ex : 1000, 4000, 5000", en: "e.g. 1000, 4000, 5000", nl: "Bijv. 1000, 4000, 5000" },
  "search.loading": { fr: "Chargement…", en: "Loading…", nl: "Laden…" },
  "search.results_found_singular": { fr: "annonce trouvée", en: "listing found", nl: "advertentie gevonden" },
  "search.results_found_plural": { fr: "annonces trouvées", en: "listings found", nl: "advertenties gevonden" },
  "search.no_results_hint": { fr: "Essayez d'élargir vos filtres ou déposez votre annonce.", en: "Try broadening your filters or post your own listing.", nl: "Probeer uw filters ruimer te maken of plaats uw eigen advertentie." },
  "search.post_listing_cta": { fr: "Déposer une annonce", en: "Post a listing", nl: "Advertentie plaatsen" },
  "search.map_loading": { fr: "Chargement de la carte…", en: "Loading the map…", nl: "Kaart laden…" },
  "search.map_error_title": { fr: "Impossible d'afficher la carte", en: "Unable to display the map", nl: "Kaart kan niet worden weergegeven" },
  "search.map_error_hint": { fr: "Réessayez ou revenez à la liste. Si le problème continue, rechargez la page.", en: "Try again or go back to the list. If it persists, reload the page.", nl: "Probeer opnieuw of ga terug naar de lijst. Herlaad de pagina als het aanhoudt." },
  "search.map_no_geo": { fr: "Aucune annonce géolocalisée disponible pour le moment.", en: "No geolocated listings available at the moment.", nl: "Momenteel geen geolokaliseerde advertenties beschikbaar." },
  "search.map_no_geo_hint": { fr: "Élargissez vos filtres ou revenez à la liste pour voir toutes les annonces.", en: "Broaden your filters or switch back to the list to see all listings.", nl: "Verruim uw filters of ga terug naar de lijst om alle advertenties te zien." },
  "search.map_user_only_hint": { fr: "Votre position est affichée. Aucune annonce géolocalisée dans cette zone.", en: "Your location is shown. No geolocated listings in this area.", nl: "Uw locatie wordt getoond. Geen geolokaliseerde advertenties in dit gebied." },
  "search.map_back_to_list": { fr: "Revenir à la liste", en: "Back to list", nl: "Terug naar lijst" },
  "search.view_listing": { fr: "Voir l'annonce", en: "View listing", nl: "Advertentie bekijken" },
  "search.map_draw_zone": { fr: "Dessiner une zone", en: "Draw a zone", nl: "Teken een zone" },
  "search.map_click_to_use": {
    fr: "Cliquez pour utiliser la carte",
    en: "Click to use the map",
    nl: "Klik om de kaart te gebruiken",
  },
  "search.map_clear_zone": { fr: "Effacer la zone", en: "Clear zone", nl: "Zone wissen" },
  "search.zone_filter_active": { fr: "Zone active", en: "Zone active", nl: "Zone actief" },
  "search.geo_unsupported": { fr: "Géolocalisation non supportée par votre navigateur", en: "Geolocation is not supported by your browser", nl: "Geolocatie wordt niet ondersteund door uw browser" },
  "search.geo_insecure": {
    fr: "La géolocalisation nécessite une connexion sécurisée (HTTPS). Vous utilisez actuellement une version de développement. Cette fonctionnalité sera disponible sur la version sécurisée de MATPASS.",
    en: "Geolocation requires a secure connection (HTTPS). You are currently using a development version. This feature will be available on the secure version of MATPASS.",
    nl: "Geolocatie vereist een beveiligde verbinding (HTTPS). U gebruikt momenteel een ontwikkelversie. Deze functie is beschikbaar op de beveiligde versie van MATPASS.",
  },
  "geo.insecure_title": {
    fr: "Géolocalisation indisponible",
    en: "Geolocation unavailable",
    nl: "Geolocatie niet beschikbaar",
  },
  "geo.insecure_body": {
    fr: "Sur cette version de développement (HTTP), le navigateur bloque la position GPS. En production HTTPS, « Utiliser ma position » fonctionnera normalement.",
    en: "On this development version (HTTP), the browser blocks GPS location. On production HTTPS, “Use my location” will work normally.",
    nl: "Op deze ontwikkelversie (HTTP) blokkeert de browser GPS. Op productie-HTTPS werkt “Mijn locatie gebruiken” normaal.",
  },
  "geo.insecure_hint": {
    fr: "En attendant, indiquez un code postal ou une ville pour chercher près de votre chantier.",
    en: "In the meantime, enter a postal code or city to search near your job site.",
    nl: "Gebruik intussen een postcode of stad om bij uw werf te zoeken.",
  },
  "geo.insecure_cta_postal": {
    fr: "Entrer un code postal",
    en: "Enter a postal code",
    nl: "Postcode invoeren",
  },
  "geo.insecure_close": { fr: "Fermer", en: "Close", nl: "Sluiten" },
  "geo.denied_title": {
    fr: "Localisation bloquée dans le navigateur",
    en: "Location blocked in the browser",
    nl: "Locatie geblokkeerd in de browser",
  },
  "geo.denied_body": {
    fr: "Chrome (ou Safari) a mémorisé un refus. Cliquez sur le cadenas à gauche de l’URL, choisissez Position → Autoriser, puis rechargez la page.",
    en: "Chrome (or Safari) remembered a denial. Click the lock icon left of the URL, set Location → Allow, then reload.",
    nl: "Chrome (of Safari) heeft een weigering onthouden. Klik op het slot links van de URL, kies Locatie → Toestaan, en herlaad.",
  },
  "geo.denied_hint": {
    fr: "iPhone : Réglages → Safari → Localisation → « Lors de l'utilisation de l'app ». Android : icône 🔒 dans la barre d'adresse → Position → Autoriser, puis rechargez.",
    en: "iPhone: Settings → Safari → Location → “While Using the App”. Android: lock icon in the address bar → Location → Allow, then reload.",
    nl: "iPhone: Instellingen → Safari → Locatie → “Tijdens gebruik van de app”. Android: slotpictogram → Locatie → Toestaan, en herlaad.",
  },
  "geo.iframe_title": {
    fr: "Ouvrez la page dans un onglet complet",
    en: "Open the page in a full tab",
    nl: "Open de pagina in een volledig tabblad",
  },
  "geo.iframe_body": {
    fr: "L’aperçu intégré bloque le GPS. Ouvrez http://localhost:3000 dans Chrome ou Safari (pas dans l’aperçu Cursor).",
    en: "The embedded preview blocks GPS. Open http://localhost:3000 in Chrome or Safari (not in the Cursor preview).",
    nl: "De ingebedde preview blokkeert GPS. Open http://localhost:3000 in Chrome of Safari (niet in de Cursor-preview).",
  },
  "geo.iframe_hint": {
    fr: "Ensuite cliquez à nouveau sur « Utiliser ma position » et acceptez la demande.",
    en: "Then click “Use my location” again and accept the prompt.",
    nl: "Klik daarna opnieuw op “Mijn locatie gebruiken” en aanvaard de vraag.",
  },
  "geo.timeout_title": {
    fr: "Le GPS a mis trop de temps",
    en: "GPS took too long",
    nl: "GPS duurde te lang",
  },
  "geo.timeout_body": {
    fr: "Le navigateur n’a pas obtenu de position à temps. Réessayez, ou saisissez le code postal du chantier.",
    en: "The browser did not get a position in time. Try again, or enter the job site postal code.",
    nl: "De browser kreeg de locatie niet op tijd. Probeer opnieuw, of voer de postcode van de werf in.",
  },
  "geo.failed_title": {
    fr: "Position GPS indisponible",
    en: "GPS position unavailable",
    nl: "GPS-positie niet beschikbaar",
  },
  "geo.failed_body": {
    fr: "Le Mac / téléphone n’a pas pu estimer votre position (Wi-Fi ou GPS). Saisissez le code postal, c’est plus fiable pour un chantier.",
    en: "The Mac / phone could not estimate your position (Wi-Fi or GPS). Enter the postal code — it is more reliable for a job site.",
    nl: "De Mac / telefoon kon uw positie niet schatten. Voer de postcode in — dat is betrouwbaarder voor een werf.",
  },
  "search.geo_located": { fr: "Localisé", en: "Located", nl: "Gelokaliseerd" },
  "search.geo_no_postal": { fr: "Localisation trouvée mais pas de code postal", en: "Location found but no postal code", nl: "Locatie gevonden maar geen postcode" },
  "search.geo_denied": { fr: "Localisation refusée. Autorisez l'accès à votre position dans les paramètres du navigateur (icône cadenas près de l'URL), puis réessayez.", en: "Location denied. Allow access to your position in the browser settings (lock icon near the URL), then try again.", nl: "Locatie geweigerd. Sta toegang tot uw positie toe in de browserinstellingen (slotpictogram bij de URL) en probeer opnieuw." },
  "search.geo_timeout": { fr: "Délai dépassé pour obtenir votre position. Réessayez.", en: "Timed out while getting your location. Please try again.", nl: "Time-out bij ophalen van uw locatie. Probeer opnieuw." },
  "search.geo_failed": { fr: "Impossible d'obtenir votre position", en: "Unable to get your location", nl: "Kan uw locatie niet ophalen" },
  "search.sort_distance": { fr: "Les plus proches", en: "Nearest", nl: "Dichtstbij" },
  "search.sort_oldest": { fr: "Les plus anciennes", en: "Oldest", nl: "Oudste" },
  "search.sort_popular": { fr: "Les plus consultées", en: "Most viewed", nl: "Meest bekeken" },
  "search.sort_label": { fr: "Tri", en: "Sort", nl: "Sorteren" },
  "search.mobile_filters": { fr: "Filtres", en: "Filters", nl: "Filters" },
  "search.active_filters": { fr: "Filtres actifs", en: "Active filters", nl: "Actieve filters" },
  "search.reset_all_filters": { fr: "Réinitialiser tous les filtres", en: "Reset all filters", nl: "Alle filters resetten" },
  "search.matches_singular": { fr: "{count} annonce correspond à votre recherche", en: "{count} listing matches your search", nl: "{count} advertentie komt overeen met uw zoekopdracht" },
  "search.matches_plural": { fr: "{count} annonces correspondent à votre recherche", en: "{count} listings match your search", nl: "{count} advertenties komen overeen met uw zoekopdracht" },
  "search.radius_title": { fr: "Rayon de recherche", en: "Search radius", nl: "Zoekstraal" },
  "search.radius_selected": { fr: "Rayon sélectionné : {km} km", en: "Selected radius: {km} km", nl: "Geselecteerde straal: {km} km" },
  "search.radius_need_hint": { fr: "Sélectionnez un rayon pour filtrer autour de votre code postal ou ville.", en: "Select a radius to filter around your postal code or city.", nl: "Selecteer een straal om rond uw postcode of stad te filteren." },
  "search.widen_radius": { fr: "Élargir le rayon", en: "Widen radius", nl: "Straal verruimen" },
  "card.badge_new": { fr: "Nouvelle annonce", en: "New listing", nl: "Nieuwe advertentie" },
  "card.badge_sold": { fr: "Vendu", en: "Sold", nl: "Verkocht" },
  "card.badge_hot": { fr: "Très demandée", en: "High demand", nl: "Zeer gevraagd" },
  "card.badge_verified": { fr: "Vendeur vérifié", en: "Verified seller", nl: "Geverifieerde verkoper" },
  "card.matpass_supplier": { fr: "Fournisseur MatPass", en: "MatPass supplier", nl: "MatPass-leverancier" },
  "card.contact": { fr: "Contacter", en: "Contact", nl: "Contact" },
  "compare.add": { fr: "Comparer", en: "Compare", nl: "Vergelijken" },
  "compare.added": { fr: "Ajouté", en: "Added", nl: "Toegevoegd" },
  "compare.selected": { fr: "{count} annonces sélectionnées", en: "{count} listings selected", nl: "{count} advertenties geselecteerd" },
  "compare.clear": { fr: "Vider", en: "Clear", nl: "Leegmaken" },
  "compare.cta": { fr: "Comparer", en: "Compare", nl: "Vergelijken" },
  "compare.title": { fr: "Comparaison d'annonces", en: "Listing comparison", nl: "Advertentievergelijking" },
  "compare.criteria": { fr: "Critère", en: "Criteria", nl: "Criterium" },
  "compare.price": { fr: "Prix", en: "Price", nl: "Prijs" },
  "compare.brand": { fr: "Marque", en: "Brand", nl: "Merk" },
  "compare.model": { fr: "Modèle", en: "Model", nl: "Model" },
  "compare.year": { fr: "Année", en: "Year", nl: "Jaar" },
  "compare.hours": { fr: "Heures", en: "Hours", nl: "Uren" },
  "compare.condition": { fr: "État", en: "Condition", nl: "Staat" },
  "compare.location": { fr: "Localisation", en: "Location", nl: "Locatie" },
  "compare.seller": { fr: "Vendeur", en: "Seller", nl: "Verkoper" },
  "compare.page_desc": {
    fr: "Comparez plusieurs annonces de matériel professionnel côte à côte sur MATPASS.",
    en: "Compare several professional equipment listings side by side on MATPASS.",
    nl: "Vergelijk meerdere professionele materiaaladvertenties naast elkaar op MATPASS.",
  },
  "compare.page_sub": {
    fr: "Prix, marque, modèle, état et localisation en un coup d'œil.",
    en: "Price, brand, model, condition and location at a glance.",
    nl: "Prijs, merk, model, staat en locatie in één oogopslag.",
  },
  "compare.back_search": { fr: "Retour à la recherche", en: "Back to search", nl: "Terug naar zoeken" },
  "compare.empty": {
    fr: "Aucune annonce sélectionnée. Ajoutez des annonces depuis la recherche avec le bouton « Comparer ».",
    en: "No listings selected. Add listings from search using the « Compare » button.",
    nl: "Geen advertenties geselecteerd. Voeg advertenties toe via zoeken met de knop « Vergelijken ».",
  },
  "compare.min_two": {
    fr: "Sélectionnez au moins 2 annonces pour afficher le tableau comparatif.",
    en: "Select at least 2 listings to show the comparison table.",
    nl: "Selecteer minstens 2 advertenties om de vergelijkingstabel te tonen.",
  },
  "compare.add_more": { fr: "Ajouter une annonce", en: "Add a listing", nl: "Advertentie toevoegen" },
  "compare.remove": { fr: "Retirer", en: "Remove", nl: "Verwijderen" },
  "compare.some_unavailable": {
    fr: "Certaines annonces ne sont plus disponibles et ont été retirées de la comparaison.",
    en: "Some listings are no longer available and were removed from the comparison.",
    nl: "Sommige advertenties zijn niet meer beschikbaar en werden uit de vergelijking verwijderd.",
  },

  // ---------- Post ad (5 steps)
  "post.title": { fr: "Déposer une annonce", en: "Post a listing", nl: "Advertentie plaatsen" },
  "post.subtitle": { fr: "5 étapes rapides pour publier gratuitement en Belgique.", en: "5 quick steps to publish for free in Belgium.", nl: "5 snelle stappen om gratis in België te publiceren." },
  "post.step_category": { fr: "Catégorie", en: "Category", nl: "Categorie" },
  "post.step_details": { fr: "Détails", en: "Details", nl: "Details" },
  "post.step_photos": { fr: "Photos", en: "Photos", nl: "Foto's" },
  "post.photos_label": { fr: "Photos", en: "Photos", nl: "Foto's" },
  "post.photos_hint": {
    fr: "Au moins 1 photo obligatoire. Jusqu'à 15 photos, formats JPG/PNG. Compression automatique.",
    en: "At least 1 photo required. Up to 15 photos, JPG/PNG. Automatic compression.",
    nl: "Minstens 1 foto verplicht. Max. 15 foto's, JPG/PNG. Automatische compressie.",
  },
  "post.photos_click": { fr: "Cliquez pour ajouter", en: "Click to add", nl: "Klik om toe te voegen" },
  "post.photos_drop": {
    fr: "ou glissez-déposez vos photos ici",
    en: "or drag and drop your photos here",
    nl: "of sleep hier uw foto's naartoe",
  },
  "post.photos_main": { fr: "Principale", en: "Main", nl: "Hoofdfoto" },
  "post.error_photo_required": {
    fr: "Ajoutez au moins une photo de l'article.",
    en: "Add at least one photo of the item.",
    nl: "Voeg minstens één foto van het artikel toe.",
  },
  "post.step_location": { fr: "Localisation", en: "Location", nl: "Locatie" },
  "post.step_preview": { fr: "Aperçu", en: "Preview", nl: "Voorbeeld" },
  "post.next": { fr: "Suivant", en: "Next", nl: "Volgende" },
  "post.prev": { fr: "Précédent", en: "Previous", nl: "Vorige" },
  "post.publish": { fr: "Publier l'annonce", en: "Publish listing", nl: "Advertentie publiceren" },
  "post.save_draft": { fr: "Enregistrer en brouillon", en: "Save as draft", nl: "Opslaan als concept" },
  "post.title_placeholder": { fr: "Ex : Mini-pelle Kubota KX016-4", en: "e.g. Mini-excavator Kubota KX016-4", nl: "Bijv. Minigraver Kubota KX016-4" },
  "post.description_placeholder": { fr: "Décrivez l'état, l'entretien, les options, la raison de la vente…", en: "Describe condition, maintenance, options, reason for sale…", nl: "Beschrijf staat, onderhoud, opties, reden van verkoop…" },
  "post.delivery_label": { fr: "Livraison possible", en: "Delivery possible", nl: "Levering mogelijk" },
  "post.delivery_desc": { fr: "Cochez si vous acceptez d'organiser la livraison en Belgique.", en: "Check if you can arrange delivery in Belgium.", nl: "Aanvinken als u levering in België kunt regelen." },
  "post.invoice_label": {
    fr: "Avez-vous toujours la facture de la machine ?",
    en: "Do you still have the machine's invoice?",
    nl: "Heeft u nog steeds de factuur van de machine?",
  },
  "post.invoice_optional": { fr: "optionnel", en: "optional", nl: "optioneel" },
  "post.invoice_hint": {
    fr: "Rassurer les acheteurs si vous pouvez fournir la facture d'achat. Vous pouvez passer cette question.",
    en: "Reassures buyers if you can provide the purchase invoice. You can skip this question.",
    nl: "Stelt kopers gerust als u de aankoopfactuur kunt leveren. U mag deze vraag overslaan.",
  },
  "post.invoice_skip": { fr: "Ne pas préciser", en: "Prefer not to say", nl: "Liever niet zeggen" },
  "post.invoice_yes": { fr: "Oui, j'ai la facture", en: "Yes, I have the invoice", nl: "Ja, ik heb de factuur" },
  "post.invoice_no": { fr: "Non", en: "No", nl: "Nee" },
  "listing_detail.invoice_yes": {
    fr: "Facture disponible",
    en: "Invoice available",
    nl: "Factuur beschikbaar",
  },
  "listing_detail.invoice_no": {
    fr: "Sans facture",
    en: "No invoice",
    nl: "Geen factuur",
  },
  "ui.yes": { fr: "Oui", en: "Yes", nl: "Ja" },
  "ui.no": { fr: "Non", en: "No", nl: "Nee" },
  "post.country_label": { fr: "Pays de publication", en: "Publishing country", nl: "Publicatieland" },
  "post.error_pick_category": { fr: "Choisissez d'abord une catégorie", en: "Please pick a category first", nl: "Kies eerst een categorie" },
  "post.published_toast": { fr: "Annonce publiée avec succès !", en: "Listing published successfully!", nl: "Advertentie succesvol gepubliceerd!" },
  "post.location_from_profile": {
    fr: "Adresse et téléphone repris de votre profil / boutique. Modifiez-les si cette machine est ailleurs.",
    en: "Address and phone taken from your profile / shop. Change them if this machine is elsewhere.",
    nl: "Adres en telefoon overgenomen van uw profiel / winkel. Wijzig ze als deze machine elders staat.",
  },
  "post.another_title": { fr: "Annonce publiée", en: "Listing published", nl: "Advertentie gepubliceerd" },
  "post.another_hint": {
    fr: "Catégorie, marque, adresse et téléphone sont conservés. Il ne reste que le modèle, le prix et les photos.",
    en: "Category, brand, address and phone are kept. Only model, price and photos remain.",
    nl: "Categorie, merk, adres en telefoon blijven behouden. Alleen model, prijs en foto's blijven over.",
  },
  "post.another_cta": { fr: "Poster une autre machine", en: "Post another machine", nl: "Nog een machine plaatsen" },
  "post.view_listing": { fr: "Voir l'annonce", en: "View listing", nl: "Advertentie bekijken" },

  // ---------- Auth
  "auth.login_title": { fr: "Connexion à MATPASS", en: "Sign in to MATPASS", nl: "Inloggen bij MATPASS" },
  "auth.login_subtitle": { fr: "Content de vous revoir ! Connectez-vous pour continuer.", en: "Welcome back! Sign in to continue.", nl: "Welkom terug! Log in om verder te gaan." },
  "auth.register_title": { fr: "Créer un compte MATPASS", en: "Create a MATPASS account", nl: "MATPASS-account aanmaken" },
  "auth.register_subtitle": { fr: "Rejoignez la plateforme belge du matériel professionnel d'occasion.", en: "Join the Belgian marketplace for used professional equipment.", nl: "Word lid van het Belgische platform voor tweedehands professioneel materieel." },
  "auth.forgot_pw": { fr: "Mot de passe oublié ?", en: "Forgot your password?", nl: "Wachtwoord vergeten?" },
  "auth.no_account": { fr: "Pas encore de compte ?", en: "No account yet?", nl: "Nog geen account?" },
  "auth.has_account": { fr: "Vous avez déjà un compte ?", en: "Already have an account?", nl: "Heeft u al een account?" },
  "auth.role_particulier": { fr: "Particulier", en: "Individual", nl: "Particulier" },
  "auth.role_pro": { fr: "Professionnel", en: "Professional", nl: "Professioneel" },
  "auth.field_full_name": { fr: "Nom complet", en: "Full name", nl: "Volledige naam" },
  "auth.field_company_name": { fr: "Nom de l'entreprise", en: "Company name", nl: "Bedrijfsnaam" },
  "auth.field_company_number": { fr: "Numéro d'entreprise (BE)", en: "Company number (BE)", nl: "Ondernemingsnummer (BE)" },
  "auth.field_confirm_password": { fr: "Confirmer le mot de passe", en: "Confirm password", nl: "Wachtwoord bevestigen" },
  "auth.submit_login": { fr: "Se connecter", en: "Sign in", nl: "Inloggen" },
  "auth.submit_register": { fr: "Créer mon compte", en: "Create my account", nl: "Mijn account aanmaken" },
  "auth.register_join_matpass": { fr: "Rejoignez MATPASS : dépôt d'annonce gratuit.", en: "Join MATPASS: free listings.", nl: "Word lid van MATPASS: gratis advertenties." },
  "auth.role_particulier_desc": { fr: "J'achète ou je revends du matériel", en: "I buy or resell equipment", nl: "Ik koop of verkoop materieel" },
  "auth.role_pro_desc": {
    fr: "Boutique, loueur ou atelier matériel (BCE/TVA)",
    en: "Equipment shop, rental fleet or workshop (VAT/BCE)",
    nl: "Materiaalwinkel, verhuurpark of werkplaats (BTW/KBO)",
  },
  "auth.field_email": { fr: "Email", en: "Email", nl: "E-mail" },
  "auth.field_password": { fr: "Mot de passe", en: "Password", nl: "Wachtwoord" },
  "auth.field_phone_optional": { fr: "Téléphone (facultatif)", en: "Phone (optional)", nl: "Telefoon (optioneel)" },
  "auth.field_city": { fr: "Ville", en: "City", nl: "Stad" },
  "auth.field_city_placeholder": { fr: "Ex : Bruxelles, Liège, Namur", en: "e.g. Brussels, Liège, Namur", nl: "Bijv. Brussel, Luik, Namen" },
  "auth.field_postal_code": { fr: "Code postal", en: "Postal code", nl: "Postcode" },
  "auth.field_postal_code_placeholder": { fr: "Ex : 1000, 4000, 5000", en: "e.g. 1000, 4000, 5000", nl: "Bijv. 1000, 4000, 5000" },
  "auth.company_info": { fr: "Informations entreprise", en: "Company information", nl: "Bedrijfsinformatie" },
  "auth.field_website": { fr: "Site internet", en: "Website", nl: "Website" },
  "auth.field_description": { fr: "Description", en: "Description", nl: "Beschrijving" },
  "auth.pro_verified_note": {
    fr: "Le statut fournisseur (boutique, carte, annuaire) est réservé aux professionnels du matériel et n'est activé qu'après validation par MATPASS.",
    en: "Supplier status (shop, map, directory) is reserved for equipment professionals and only activated after MATPASS validation.",
    nl: "Leveranciersstatus (shop, kaart, directory) is voorbehouden aan materieelprofessionals en wordt pas na validatie door MATPASS geactiveerd.",
  },
  "auth.field_description_hint": {
    fr: "Décrivez votre activité matériel : vente, location, réparation, pièces… (pas vos prestations de travaux chez le client).",
    en: "Describe your equipment business: sales, rental, repair, parts… (not on-site trade services for end customers).",
    nl: "Beschrijf uw materieelactiviteit: verkoop, verhuur, reparatie, onderdelen… (geen klus- of werkdiensten bij de klant).",
  },
  "auth.already_have_account": { fr: "Déjà un compte ?", en: "Already have an account?", nl: "Heeft u al een account?" },
  "auth.sign_in": { fr: "Se connecter", en: "Sign in", nl: "Inloggen" },
  "auth.register_loading": { fr: "Création en cours…", en: "Creating account…", nl: "Account aanmaken…" },
  "auth.forgot_title": { fr: "Réinitialiser le mot de passe", en: "Reset your password", nl: "Wachtwoord opnieuw instellen" },
  "auth.forgot_subtitle": { fr: "Entrez votre email. Nous vous enverrons un lien pour choisir un nouveau mot de passe.", en: "Enter your email. We'll send a link to choose a new password.", nl: "Voer uw e-mail in. We sturen een link om een nieuw wachtwoord te kiezen." },
  "auth.forgot_submit": { fr: "Envoyer le lien", en: "Send link", nl: "Link versturen" },
  "auth.error_email_used": { fr: "Cet email est déjà utilisé", en: "This email is already registered", nl: "Deze e-mail is al geregistreerd" },
  "auth.error_wrong_credentials": { fr: "Email ou mot de passe incorrect", en: "Wrong email or password", nl: "Verkeerd e-mail of wachtwoord" },

  // ---------- Account settings
  "settings.title": { fr: "Paramètres du compte", en: "Account settings", nl: "Accountinstellingen" },
  "settings.subtitle": { fr: "Gérez votre sécurité, votre adresse email et vos données personnelles.", en: "Manage your security, email address and personal data.", nl: "Beheer uw beveiliging, e-mailadres en persoonlijke gegevens." },
  "settings.back_profile": { fr: "Retour au profil", en: "Back to profile", nl: "Terug naar profiel" },
  "settings.notifs_title": { fr: "Préférences d'emails", en: "Email preferences", nl: "E-mailvoorkeuren" },
  "settings.notifs_desc": {
    fr: "Choisissez les emails MATPASS que vous souhaitez recevoir. Les emails de sécurité (vérification, mot de passe, changement d'adresse) restent toujours actifs conformément aux règles anti-fraude.",
    en: "Choose which MATPASS emails you want to receive. Security emails (verification, password, address change) always stay active for fraud protection.",
    nl: "Kies welke MATPASS-e-mails u wilt ontvangen. Beveiligings-e-mails (verificatie, wachtwoord, adreswijziging) blijven altijd actief voor fraudebescherming.",
  },
  "settings.pref_messages": { fr: "Nouveaux messages", en: "New messages", nl: "Nieuwe berichten" },
  "settings.pref_alerts": { fr: "Alertes et favoris", en: "Alerts and favorites", nl: "Meldingen en favorieten" },
  "settings.pref_marketing": { fr: "Nouveautés MATPASS", en: "MATPASS updates", nl: "MATPASS updates" },
  "settings.rgpd_note": { fr: "Vos préférences respectent le RGPD. Vous pouvez les modifier à tout moment.", en: "Your preferences comply with GDPR. You can change them anytime.", nl: "Uw voorkeuren voldoen aan de AVG. U kunt ze altijd wijzigen." },
  "settings.change_pw_title": { fr: "Changer mon mot de passe", en: "Change my password", nl: "Mijn wachtwoord wijzigen" },
  "settings.change_email_title": { fr: "Changer mon adresse email", en: "Change my email address", nl: "Mijn e-mailadres wijzigen" },
  "settings.delete_title": { fr: "Supprimer mon compte (RGPD)", en: "Delete my account (GDPR)", nl: "Mijn account verwijderen (AVG)" },
  "settings.delete_desc": { fr: "Cette action est irréversible. Toutes vos annonces, messages, favoris et données personnelles seront définitivement effacés.", en: "This action is permanent. All your listings, messages, favorites and personal data will be erased.", nl: "Deze actie is onomkeerbaar. Al uw advertenties, berichten, favorieten en persoonlijke gegevens worden gewist." },
  "settings.delete_button": { fr: "Supprimer mon compte", en: "Delete my account", nl: "Mijn account verwijderen" },


  // ---------- Verify email page
  "verify_page.verifying": { fr: "Vérification en cours…", en: "Verifying…", nl: "Verifiëren…" },
  "verify_page.success": { fr: "Email vérifié 🎉", en: "Email verified 🎉", nl: "E-mail geverifieerd 🎉" },
  "verify_page.error": { fr: "Vérification impossible", en: "Verification failed", nl: "Verificatie mislukt" },
  "verify_page.can_publish": { fr: "Vous pouvez maintenant publier vos annonces sur MATPASS 🇧🇪", en: "You can now post listings on MATPASS 🇧🇪", nl: "U kunt nu advertenties plaatsen op MATPASS 🇧🇪" },
  "verify_page.email_confirmed": { fr: "est désormais confirmée.", en: "is now confirmed.", nl: "is nu bevestigd." },
  "verify_page.toast_verified": { fr: "Adresse email vérifiée ✓", en: "Email address verified ✓", nl: "E-mailadres geverifieerd ✓" },
  "verify_page.missing_token": { fr: "Lien de vérification manquant.", en: "Verification link missing.", nl: "Verificatielink ontbreekt." },
  "verify_page.invalid_or_expired": { fr: "Lien invalide ou expiré", en: "Invalid or expired link", nl: "Ongeldige of verlopen link" },
  "verify_page.resend_from_profile": { fr: "Demander un nouvel e-mail", en: "Request a new email", nl: "Nieuwe e-mail aanvragen" },
  "verify_page.back_home": { fr: "Retour à l'accueil", en: "Back to home", nl: "Terug naar de startpagina" },
  "verify_page.cta_post": { fr: "Déposer une annonce", en: "Post an ad", nl: "Advertentie plaatsen" },
  "verify_page.cta_dashboard": { fr: "Mon tableau de bord", en: "My dashboard", nl: "Mijn dashboard" },
  "verify_page.resend_sending": { fr: "Envoi…", en: "Sending…", nl: "Verzenden…" },
  "verify_page.resend_cta": { fr: "Renvoyer l'e-mail de vérification", en: "Resend verification email", nl: "Verificatie-e-mail opnieuw verzenden" },
  "verify_page.resend_login_hint": { fr: "Se connecter pour renvoyer l'e-mail", en: "Sign in to resend the email", nl: "Inloggen om e-mail opnieuw te verzenden" },

  // ---------- Pricing / Tarifs
  "pricing.kicker": { fr: "Tarifs MATPASS", en: "MATPASS pricing", nl: "MATPASS-prijzen" },
  "pricing.hero_title_1": { fr: "Vendez plus vite.", en: "Sell faster.", nl: "Verkoop sneller." },
  "pricing.hero_title_2": { fr: "Vendez plus cher.", en: "Sell for more.", nl: "Verkoop voor meer." },
  "pricing.hero_sub": {
    fr: "Le dépôt d'annonce reste gratuit. Boostez une annonce ou passez Pro / Premium pour maximiser votre visibilité.",
    en: "Posting an ad stays free. Boost a listing or go Pro / Premium to maximise visibility.",
    nl: "Advertenties plaatsen blijft gratis. Boost een advertentie of ga Pro / Premium voor meer zichtbaarheid.",
  },
  "pricing.coming_soon": {
    fr: "Les paiements seront disponibles prochainement.",
    en: "Payments will be available soon.",
    nl: "Betalingen zijn binnenkort beschikbaar.",
  },
  "pricing.coming_soon_badge": { fr: "Bientôt disponible", en: "Coming soon", nl: "Binnenkort beschikbaar" },
  "pricing.loading": { fr: "Chargement…", en: "Loading…", nl: "Laden…" },
  "pricing.boost_kicker": { fr: "Booster une annonce", en: "Boost a listing", nl: "Advertentie boosten" },
  "pricing.boost_title": { fr: "Options ponctuelles", en: "One-off options", nl: "Eenmalige opties" },
  "pricing.boost_cta": { fr: "Booster une annonce", en: "Boost a listing", nl: "Advertentie boosten" },
  "pricing.subs_kicker": { fr: "Pour les professionnels", en: "For professionals", nl: "Voor professionals" },
  "pricing.subs_title": { fr: "Abonnements", en: "Subscriptions", nl: "Abonnementen" },
  "pricing.subs_sub": {
    fr: "Renforcez votre présence dans Rechercher un fournisseur — multi-agences, boutique soignée, et priorité Premium. Prix pour l'entreprise, agences incluses. L'annuel inclut −{pct} % vs le mensuel.",
    en: "Strengthen your presence in Find a supplier — multi-branch, polished shop, and Premium priority. Price is per company, branches included. Annual plans include −{pct} % vs monthly.",
    nl: "Versterk uw aanwezigheid in Leverancier zoeken — meerdere vestigingen, verzorgde shop en Premium-prioriteit. Prijs per bedrijf, vestigingen inbegrepen. Jaarlijks: −{pct} % t.o.v. maandelijks.",
  },
  "pricing.billing_aria": { fr: "Périodicité", en: "Billing period", nl: "Factureringsperiode" },
  "pricing.billing_month": { fr: "Mensuel", en: "Monthly", nl: "Maandelijks" },
  "pricing.billing_year": {
    fr: "Annuel (−{pct} %)",
    en: "Annual (−{pct} %)",
    nl: "Jaarlijks (−{pct} %)",
  },
  "pricing.per_month": { fr: "/ mois", en: "/ month", nl: "/ maand" },
  "pricing.per_year": { fr: "/ an", en: "/ year", nl: "/ jaar" },
  "pricing.free_title": { fr: "Gratuit", en: "Free", nl: "Gratis" },
  "pricing.free_desc": {
    fr: "Pour démarrer et préparer votre boutique. À la validation fournisseur : 30 jours d'essai Pro offerts (carte + annuaire).",
    en: "To get started and prepare your shop. On supplier approval: 30 days of Pro trial included (map + directory).",
    nl: "Om te starten en uw shop voor te bereiden. Bij validatie als leverancier: 30 dagen Pro-proefperiode (kaart + gids).",
  },
  "pricing.free_f1": { fr: "5 annonces maximum", en: "Up to 5 listings", nl: "Maximaal 5 advertenties" },
  "pricing.free_f2": {
    fr: "Non visible sur la carte ni dans Rechercher un fournisseur",
    en: "Not listed on the map or in Find a supplier",
    nl: "Niet zichtbaar op de kaart of in Leverancier zoeken",
  },
  "pricing.free_f3": { fr: "Boutique publique basique", en: "Basic public shop", nl: "Basis openbare shop" },
  "pricing.free_f4": { fr: "1 agence", en: "1 branch", nl: "1 vestiging" },
  "pricing.free_f5": { fr: "Messagerie et favoris", en: "Messaging and favourites", nl: "Berichten en favorieten" },
  "pricing.free_current": { fr: "Votre offre actuelle", en: "Your current plan", nl: "Uw huidige plan" },
  "pricing.free_base": { fr: "Offre de base", en: "Base plan", nl: "Basisplan" },
  "pricing.pro_title": { fr: "Pro", en: "Pro", nl: "Pro" },
  "pricing.premium_title": { fr: "Premium", en: "Premium", nl: "Premium" },
  "pricing.pkg.highlight.title": { fr: "Mise en avant", en: "Highlight", nl: "Uitgelicht" },
  "pricing.pkg.highlight.desc": {
    fr: "Boostez votre annonce en tête des résultats pendant 7 jours.",
    en: "Boost your listing to the top of results for 7 days.",
    nl: "Zet uw advertentie 7 dagen bovenaan de resultaten.",
  },
  "pricing.pkg.premium.title": { fr: "Annonce premium", en: "Premium listing", nl: "Premium advertentie" },
  "pricing.pkg.premium.desc": {
    fr: "Annonce Premium mise en avant pendant 30 jours + badge premium.",
    en: "Premium listing featured for 30 days + premium badge.",
    nl: "Premium advertentie 30 dagen uitgelicht + premiumbadge.",
  },
  "pricing.pkg.subscription_pro.desc": {
    fr: "Visible sur la carte et dans Rechercher un fournisseur, annonces illimitées, boutique personnalisée — jusqu'à 3 agences incluses.",
    en: "Listed on the map and in Find a supplier, unlimited listings, custom shop — up to 3 branches included.",
    nl: "Zichtbaar op de kaart en in Leverancier zoeken, onbeperkte advertenties, gepersonaliseerde shop — tot 3 vestigingen inbegrepen.",
  },
  "pricing.pkg.subscription_boutique.desc": {
    fr: "Priorité dans Rechercher un fournisseur, stats avancées, jusqu'à 8 agences, support prioritaire.",
    en: "Priority in Find a supplier, advanced stats, up to 8 branches, priority support.",
    nl: "Prioriteit in Leverancier zoeken, geavanceerde stats, tot 8 vestigingen, prioritaire support.",
  },
  "pricing.feat.highlight_1": {
    fr: "En tête des résultats 7 jours",
    en: "Top of results for 7 days",
    nl: "7 dagen bovenaan de resultaten",
  },
  "pricing.feat.highlight_2": {
    fr: "Paiement unique, sans engagement",
    en: "One-time payment, no commitment",
    nl: "Eenmalige betaling, geen verplichting",
  },
  "pricing.feat.premium_1": {
    fr: "Annonce Premium 30 jours",
    en: "Premium listing for 30 days",
    nl: "Premium advertentie 30 dagen",
  },
  "pricing.feat.premium_2": {
    fr: "Badge Premium visible",
    en: "Visible Premium badge",
    nl: "Zichtbare Premium-badge",
  },
  "pricing.feat.pro_1": {
    fr: "Visible sur la carte & Rechercher un fournisseur",
    en: "Listed on the map & Find a supplier",
    nl: "Zichtbaar op de kaart & Leverancier zoeken",
  },
  "pricing.feat.pro_2": { fr: "Annonces illimitées", en: "Unlimited listings", nl: "Onbeperkte advertenties" },
  "pricing.feat.pro_3": {
    fr: "Logo & bannière boutique",
    en: "Shop logo & banner",
    nl: "Shop-logo & banner",
  },
  "pricing.feat.pro_4": {
    fr: "Jusqu'à 3 agences incluses",
    en: "Up to 3 branches included",
    nl: "Tot 3 vestigingen inbegrepen",
  },
  "pricing.feat.pro_5": { fr: "Statistiques standard", en: "Standard statistics", nl: "Standaardstatistieken" },
  "pricing.feat.boutique_1": {
    fr: "Priorité dans Rechercher un fournisseur",
    en: "Priority in Find a supplier",
    nl: "Prioriteit in Leverancier zoeken",
  },
  "pricing.feat.boutique_2": { fr: "Annonces illimitées", en: "Unlimited listings", nl: "Onbeperkte advertenties" },
  "pricing.feat.boutique_3": {
    fr: "Jusqu'à 8 agences incluses",
    en: "Up to 8 branches included",
    nl: "Tot 8 vestigingen inbegrepen",
  },
  "pricing.feat.boutique_4": {
    fr: "Stats avancées (GPS, contacts)",
    en: "Advanced stats (GPS, contacts)",
    nl: "Geavanceerde stats (GPS, contacten)",
  },
  "pricing.feat.boutique_5": { fr: "Support prioritaire", en: "Priority support", nl: "Prioritaire support" },
  "pricing.popular": { fr: "Le plus populaire", en: "Most popular", nl: "Meest populair" },
  "pricing.subscribe": { fr: "Souscrire", en: "Subscribe", nl: "Abonneren" },
  "pricing.active_sub": { fr: "Abonnement actif", en: "Active subscription", nl: "Actief abonnement" },
  "pricing.redirecting": { fr: "Redirection…", en: "Redirecting…", nl: "Doorverwijzen…" },
  "pricing.try_trial": {
    fr: "Essayer {title} ({days} j. gratuits)",
    en: "Try {title} ({days} free days)",
    nl: "Probeer {title} ({days} gratis dagen)",
  },
  "pricing.sub_active_title": {
    fr: "Votre abonnement est actif",
    en: "Your subscription is active",
    nl: "Uw abonnement is actief",
  },
  "pricing.sub_active_manage": {
    fr: "{tier}. Gérez carte, factures et résiliation",
    en: "{tier}. Manage card, invoices and cancellation",
    nl: "{tier}. Beheer kaart, facturen en opzegging",
  },
  "pricing.my_subscription": { fr: "Mon abonnement", en: "My subscription", nl: "Mijn abonnement" },
  "pricing.cancel": { fr: "Résilier", en: "Cancel", nl: "Opzeggen" },
  "pricing.cancel_confirm": {
    fr: "Résilier à la fin de la période en cours ?",
    en: "Cancel at the end of the current period?",
    nl: "Opzeggen aan het einde van de huidige periode?",
  },
  "pricing.cancel_scheduled": {
    fr: "Résiliation prévue en fin de période",
    en: "Cancellation scheduled at period end",
    nl: "Opzegging gepland aan het einde van de periode",
  },
  "pricing.compare_title": { fr: "Comparatif des offres", en: "Plan comparison", nl: "Vergelijking van plannen" },
  "pricing.compare_sub": {
    fr: "Tout ce qui change entre Gratuit, Pro et Premium.",
    en: "Everything that differs between Free, Pro and Premium.",
    nl: "Alles wat verschilt tussen Gratis, Pro en Premium.",
  },
  "pricing.compare_feature": { fr: "Fonction", en: "Feature", nl: "Functie" },
  "pricing.yes": { fr: "Oui", en: "Yes", nl: "Ja" },
  "pricing.no": { fr: "Non", en: "No", nl: "Nee" },
  "pricing.stripe_note": {
    fr: "Paiements sécurisés par Stripe. Renouvellement automatique. Vous pouvez résilier à tout moment depuis",
    en: "Secure payments by Stripe. Auto-renewal. You can cancel anytime from",
    nl: "Veilige betalingen via Stripe. Automatische verlenging. U kunt altijd opzeggen via",
  },
  "pricing.login_required": {
    fr: "Connectez-vous pour souscrire",
    en: "Sign in to subscribe",
    nl: "Log in om te abonneren",
  },
  "pricing.checkout_redirect": {
    fr: "Redirection vers le paiement sécurisé…",
    en: "Redirecting to secure payment…",
    nl: "Doorverwijzen naar veilige betaling…",
  },
  "pricing.checkout_failed": {
    fr: "Le paiement n'a pas pu être initié. Veuillez réessayer.",
    en: "Payment could not be started. Please try again.",
    nl: "Betaling kon niet worden gestart. Probeer opnieuw.",
  },
  "pricing.boost_select": {
    fr: "Sélectionnez une annonce à booster",
    en: "Select a listing to boost",
    nl: "Selecteer een advertentie om te boosten",
  },
  "pricing.boost_empty": {
    fr: "Aucune annonce à booster. Déposez d'abord une annonce puis revenez ici.",
    en: "No listing to boost. Post an ad first, then come back here.",
    nl: "Geen advertentie om te boosten. Plaats eerst een advertentie en kom terug.",
  },
  "pricing.boost_pick": {
    fr: "Sélectionnez l'annonce à booster :",
    en: "Select the listing to boost:",
    nl: "Selecteer de advertentie om te boosten:",
  },
  "pricing.boost_continue": {
    fr: "Continuer vers le paiement",
    en: "Continue to payment",
    nl: "Doorgaan naar betaling",
  },
  "listing.boost_kicker": { fr: "Visibilité", en: "Visibility", nl: "Zichtbaarheid" },
  "listing.boost_title": {
    fr: "Mettre cette annonce en avant",
    en: "Feature this listing",
    nl: "Deze advertentie uitlichten",
  },
  "listing.boost_subtitle": {
    fr: "Plus de vues, en tête des résultats de recherche.",
    en: "More views, at the top of search results.",
    nl: "Meer weergaven, bovenaan de zoekresultaten.",
  },
  "listing.boost_active_highlight": {
    fr: "Mise en avant jusqu'au {date}",
    en: "Featured until {date}",
    nl: "Uitgelicht tot {date}",
  },
  "listing.boost_active_premium": {
    fr: "Annonce Premium jusqu'au {date}",
    en: "Premium listing until {date}",
    nl: "Premium advertentie tot {date}",
  },
  "listing.boost_option_highlight": {
    fr: "En tête des résultats pendant 7 jours",
    en: "Top of results for 7 days",
    nl: "7 dagen bovenaan de resultaten",
  },
  "listing.boost_option_premium": {
    fr: "30 jours + badge Premium",
    en: "30 days + Premium badge",
    nl: "30 dagen + Premium-badge",
  },
  "listing.boost_renew_highlight": {
    fr: "Prolonger 7 jours",
    en: "Extend 7 days",
    nl: "7 dagen verlengen",
  },
  "listing.boost_renew_premium": {
    fr: "Prolonger 30 jours",
    en: "Extend 30 days",
    nl: "30 dagen verlengen",
  },
  "listing.boost_upgrade_premium": {
    fr: "Passer en Premium (30 jours)",
    en: "Upgrade to Premium (30 days)",
    nl: "Upgraden naar Premium (30 dagen)",
  },
  "listing.boost_see_pricing": {
    fr: "Voir les tarifs",
    en: "See pricing",
    nl: "Prijzen bekijken",
  },
  "pricing.cmp.listings": { fr: "Nombre d'annonces", en: "Number of listings", nl: "Aantal advertenties" },
  "pricing.cmp.directory": {
    fr: "Carte & Rechercher un fournisseur",
    en: "Map & Find a supplier",
    nl: "Kaart & Leverancier zoeken",
  },
  "pricing.cmp.shop": { fr: "Boutique publique", en: "Public shop", nl: "Openbare shop" },
  "pricing.cmp.logo": { fr: "Logo personnalisé", en: "Custom logo", nl: "Aangepast logo" },
  "pricing.cmp.banner": { fr: "Bannière", en: "Banner", nl: "Banner" },
  "pricing.cmp.priority": {
    fr: "Priorité dans les recherches",
    en: "Search priority",
    nl: "Zoekprioriteit",
  },
  "pricing.cmp.stats": { fr: "Statistiques", en: "Statistics", nl: "Statistieken" },
  "pricing.cmp.agencies": {
    fr: "Agences / sites (incluses)",
    en: "Branches / sites (included)",
    nl: "Vestigingen / sites (inbegrepen)",
  },
  "pricing.cmp.support": { fr: "Support prioritaire", en: "Priority support", nl: "Prioritaire support" },
  "pricing.cmp.val.unlimited": { fr: "Illimité", en: "Unlimited", nl: "Onbeperkt" },
  "pricing.cmp.val.visible": { fr: "Visible", en: "Visible", nl: "Zichtbaar" },
  "pricing.cmp.val.hidden": { fr: "Non", en: "No", nl: "Nee" },
  "pricing.cmp.val.reinforced": { fr: "Renforcée", en: "Reinforced", nl: "Versterkt" },
  "pricing.cmp.val.priority": { fr: "Prioritaire", en: "Priority", nl: "Prioritair" },
  "pricing.cmp.val.basic": { fr: "Basique", en: "Basic", nl: "Basis" },
  "pricing.cmp.val.standard": { fr: "Standard", en: "Standard", nl: "Standaard" },
  "pricing.cmp.val.advanced": { fr: "Avancées", en: "Advanced", nl: "Geavanceerd" },

  // ---------- Generic UI
  "ui.loading": { fr: "Chargement…", en: "Loading…", nl: "Laden…" },
  "placeholder.not_found_title": { fr: "Page introuvable", en: "Page not found", nl: "Pagina niet gevonden" },
  "placeholder.not_found_desc": { fr: "Cette page n'existe pas ou plus.", en: "This page does not exist or has been removed.", nl: "Deze pagina bestaat niet of is verwijderd." },
  "ui.view": { fr: "Voir", en: "View", nl: "Bekijken" },
  "ui.view_listing": { fr: "Voir l'annonce", en: "View listing", nl: "Advertentie bekijken" },
  "ui.view_listings": { fr: "Voir les annonces", en: "View listings", nl: "Advertenties bekijken" },
  "ui.view_prices": { fr: "Voir les tarifs", en: "View pricing", nl: "Tarieven bekijken" },
  "ui.view_translation": { fr: "Voir la traduction", en: "View translation", nl: "Vertaling bekijken" },
  "ui.view_original": { fr: "Voir l'original", en: "View original", nl: "Origineel bekijken" },
  "ui.back": { fr: "Retour", en: "Back", nl: "Terug" },
  "ui.cancel": { fr: "Annuler", en: "Cancel", nl: "Annuleren" },
  "ui.save": { fr: "Enregistrer", en: "Save", nl: "Opslaan" },
  "ui.saving": { fr: "Enregistrement…", en: "Saving…", nl: "Opslaan…" },
  "ui.delete": { fr: "Supprimer", en: "Delete", nl: "Verwijderen" },
  "ui.confirm": { fr: "Confirmer", en: "Confirm", nl: "Bevestigen" },
  "ui.see_all": { fr: "Voir toutes", en: "See all", nl: "Alles bekijken" },
  "ui.location": { fr: "Localisation", en: "Location", nl: "Locatie" },
  "ui.professional": { fr: "Professionnel", en: "Professional", nl: "Professioneel" },
  "ui.individual": { fr: "Particulier", en: "Individual", nl: "Particulier" },
  "ui.seller": { fr: "Vendeur", en: "Seller", nl: "Verkoper" },
  "ui.no_photo": { fr: "Pas de photo", en: "No photo", nl: "Geen foto" },
  "ui.approx_location": { fr: "Localisation approximative", en: "Approximate location", nl: "Geschatte locatie" },

  // ---------- Listing detail
  "listing_detail.not_found": { fr: "Annonce introuvable.", en: "Listing not found.", nl: "Advertentie niet gevonden." },
  "listing_detail.back": { fr: "Retour aux annonces", en: "Back to listings", nl: "Terug naar advertenties" },
  "listing_detail.rental_badge": { fr: "Location", en: "Rental", nl: "Verhuur" },
  "listing_detail.per_day": { fr: "/ jour", en: "/ day", nl: "/ dag" },
  "listing_detail.per_week": { fr: "/ semaine", en: "/ week", nl: "/ week" },
  "listing_detail.rental_24h": { fr: "24 heures", en: "24 hours", nl: "24 uur" },
  "listing_detail.rental_week": { fr: "Semaine", en: "Week", nl: "Week" },
  "listing_detail.rental_deposit": { fr: "Caution", en: "Deposit", nl: "Waarborg" },
  "listing_detail.delivery": { fr: "Livraison possible", en: "Delivery available", nl: "Levering mogelijk" },
  "listing_detail.spec_category": { fr: "Catégorie", en: "Category", nl: "Categorie" },
  "listing_detail.spec_subcategory": { fr: "Sous-catégorie", en: "Subcategory", nl: "Subcategorie" },
  "listing_detail.spec_brand": { fr: "Marque", en: "Brand", nl: "Merk" },
  "listing_detail.spec_model": { fr: "Modèle", en: "Model", nl: "Model" },
  "listing_detail.spec_year": { fr: "Année", en: "Year", nl: "Jaar" },
  "listing_detail.spec_hours": { fr: "Heures d'utilisation", en: "Hours of use", nl: "Gebruiksuren" },
  "listing_detail.spec_condition": { fr: "État", en: "Condition", nl: "Staat" },
  "listing_detail.map_title": { fr: "Localisation de l'annonce", en: "Listing location", nl: "Locatie van de advertentie" },
  "listing_detail.similar": { fr: "Annonces similaires", en: "Similar listings", nl: "Vergelijkbare advertenties" },
  "listing_detail.no_reviews": { fr: "Pas encore d'avis", en: "No reviews yet", nl: "Nog geen beoordelingen" },
  "listing_detail.listing_count": { fr: "annonce", en: "listing", nl: "advertentie" },
  "listing_detail.listing_count_pl": { fr: "annonces", en: "listings", nl: "advertenties" },
  "listing_detail.contact_seller": { fr: "Envoyer un message", en: "Send a message", nl: "Bericht sturen" },
  "listing_detail.availability_hint": { fr: "Disponibilités, devis ou réservation", en: "Availability, quote or booking", nl: "Beschikbaarheid, offerte of reservering" },
  "listing_detail.ask_question": { fr: "Poser une question", en: "Ask a question", nl: "Een vraag stellen" },
  "listing_detail.buy_btn": { fr: "Acheter", en: "Buy", nl: "Kopen" },
  "listing_detail.buy_secure": { fr: "Achetez en toute sécurité via MatPass", en: "Buy securely through MatPass", nl: "Koop veilig via MatPass" },
  "listing_detail.no_longer_available": { fr: "Cette annonce n'est plus disponible.", en: "This listing is no longer available.", nl: "Deze advertentie is niet meer beschikbaar." },
  "listing_detail.manage_listings": { fr: "Gérer mes annonces", en: "Manage my listings", nl: "Mijn advertenties beheren" },
  "listing_detail.ref": { fr: "Réf.", en: "Ref.", nl: "Ref." },
  "listing_detail.published_ago": { fr: "Publiée", en: "Published", nl: "Gepubliceerd" },

  // ---------- Shop (ProPublic)
  "shop.loading": { fr: "Chargement…", en: "Loading…", nl: "Laden…" },
  "shop.not_found": { fr: "Boutique introuvable.", en: "Shop not found.", nl: "Winkel niet gevonden." },
  "shop.back": { fr: "Retour aux fournisseurs", en: "Back to suppliers", nl: "Terug naar leveranciers" },
  "shop.supplier_badge": { fr: "Fournisseur MatPass", en: "MatPass Supplier", nl: "MatPass Leverancier" },
  "shop.since": { fr: "Depuis", en: "Since", nl: "Sinds" },
  "shop.call": { fr: "Appeler", en: "Call", nl: "Bellen" },
  "shop.send_email": { fr: "Envoyer un email", en: "Send an email", nl: "E-mail sturen" },
  "shop.visit_website": { fr: "Visiter le site", en: "Visit website", nl: "Website bezoeken" },
  "shop.already_contacted": { fr: "Vous avez déjà contacté cette entreprise.", en: "You have already contacted this company.", nl: "U heeft dit bedrijf al gecontacteerd." },
  "shop.resume_conversation": { fr: "Reprendre la conversation", en: "Resume conversation", nl: "Gesprek hervatten" },
  "shop.view_history": { fr: "Voir mon historique", en: "View my history", nl: "Mijn geschiedenis bekijken" },
  "shop.about": { fr: "À propos", en: "About", nl: "Over" },
  "shop.contact_card": { fr: "Contact", en: "Contact", nl: "Contact" },
  "shop.website_label": { fr: "Site internet", en: "Website", nl: "Website" },
  "shop.socials": { fr: "Réseaux sociaux", en: "Social media", nl: "Sociale media" },
  "shop.agencies": { fr: "Agences", en: "Branches", nl: "Vestigingen" },
  "shop.reliability": { fr: "Fiabilité", en: "Reliability", nl: "Betrouwbaarheid" },
  "shop.email_verified": { fr: "Email vérifié", en: "Email verified", nl: "E-mail geverifieerd" },
  "shop.phone_verified": { fr: "Téléphone vérifié", en: "Phone verified", nl: "Telefoon geverifieerd" },
  "shop.pro_verified": { fr: "Professionnel vérifié", en: "Verified professional", nl: "Geverifieerd professioneel" },
  "shop.stats": { fr: "Statistiques", en: "Statistics", nl: "Statistieken" },
  "shop.stat_listings": { fr: "Annonces", en: "Listings", nl: "Advertenties" },
  "shop.stat_sales": { fr: "Ventes", en: "Sales", nl: "Verkopen" },
  "shop.stat_rating": { fr: "Note", en: "Rating", nl: "Beoordeling" },
  "shop.stat_response": { fr: "Réponse", en: "Response", nl: "Reactietijd" },
  "shop.listings_title": { fr: "Annonces", en: "Listings", nl: "Advertenties" },
  "shop.tab_sale": { fr: "Vente", en: "Sale", nl: "Verkoop" },
  "shop.tab_rental": { fr: "Location", en: "Rental", nl: "Verhuur" },
  "shop.no_results_sale": { fr: "Aucune annonce en vente pour ce fournisseur.", en: "No machines for sale from this supplier.", nl: "Geen machines te koop van deze leverancier." },
  "shop.no_results_rental": { fr: "Aucune annonce en location pour ce fournisseur.", en: "No rental listings from this supplier.", nl: "Geen verhuuradvertenties van deze leverancier." },
  "shop.sort_recent": { fr: "Plus récentes", en: "Most recent", nl: "Meest recent" },
  "shop.sort_price_asc": { fr: "Prix croissant", en: "Price: low to high", nl: "Prijs: laag naar hoog" },
  "shop.sort_price_desc": { fr: "Prix décroissant", en: "Price: high to low", nl: "Prijs: hoog naar laag" },
  "shop.sort_popular": { fr: "Popularité", en: "Popularity", nl: "Populariteit" },
  "shop.filter_all_categories": { fr: "Toutes catégories", en: "All categories", nl: "Alle categorieën" },
  "shop.filter_all_conditions": { fr: "Tous états", en: "All conditions", nl: "Alle staten" },
  "shop.filter_brand_placeholder": { fr: "Marque", en: "Brand", nl: "Merk" },
  "shop.filter_min_price": { fr: "€ min", en: "€ min", nl: "€ min" },
  "shop.filter_max_price": { fr: "€ max", en: "€ max", nl: "€ max" },
  "shop.filter_year_min": { fr: "Année min", en: "Year min", nl: "Min jaar" },
  "shop.no_results": { fr: "Aucune annonce ne correspond à ces filtres.", en: "No listings match these filters.", nl: "Geen advertenties voldoen aan deze filters." },
  "shop.map_directions": { fr: "Ouvrir l'itinéraire", en: "Get directions", nl: "Route ophalen" },

  // ---------- Messages
  "msg.title": { fr: "Messagerie", en: "Messages", nl: "Berichten" },
  "msg.inbox": { fr: "Boîte de réception", en: "Inbox", nl: "Postvak in" },
  "msg.trash": { fr: "Corbeille", en: "Trash", nl: "Prullenbak" },
  "msg.loading": { fr: "Chargement…", en: "Loading…", nl: "Laden…" },
  "msg.trash_empty": { fr: "Corbeille vide", en: "Empty trash", nl: "Prullenbak leeg" },
  "msg.no_conversations": { fr: "Aucune conversation", en: "No conversations", nl: "Geen gesprekken" },
  "msg.trash_hint": { fr: "Les discussions terminées que vous supprimez apparaissent ici.", en: "Ended conversations you delete appear here.", nl: "Beëindigde gesprekken die u verwijdert verschijnen hier." },
  "msg.inbox_hint": { fr: "Contactez un vendeur depuis une annonce pour démarrer.", en: "Contact a seller from a listing to get started.", nl: "Neem contact op met een verkoper via een advertentie om te beginnen." },
  "msg.deleted_listing": { fr: "Annonce supprimée", en: "Deleted listing", nl: "Verwijderde advertentie" },
  "msg.new_conversation": { fr: "Nouvelle conversation", en: "New conversation", nl: "Nieuw gesprek" },
  "msg.ended": { fr: "Terminée", en: "Ended", nl: "Beëindigd" },
  "msg.user_fallback": { fr: "Utilisateur", en: "User", nl: "Gebruiker" },
  "msg.not_found": { fr: "Conversation introuvable ou inaccessible", en: "Conversation not found or inaccessible", nl: "Gesprek niet gevonden of niet toegankelijk" },
  "msg.select_trash": { fr: "Sélectionnez une conversation dans la corbeille", en: "Select a conversation from the trash", nl: "Selecteer een gesprek uit de prullenbak" },
  "msg.select": { fr: "Sélectionnez une conversation", en: "Select a conversation", nl: "Selecteer een gesprek" },
  "msg.new_message_toast": { fr: "Nouveau message", en: "New message", nl: "Nieuw bericht" },
  "msg.image_error": { fr: "Impossible d'ajouter cette image", en: "Unable to add this image", nl: "Kan deze afbeelding niet toevoegen" },
  "msg.move_to_trash_confirm": { fr: "Mettre cette conversation à la corbeille ?", en: "Move this conversation to trash?", nl: "Dit gesprek naar de prullenbak verplaatsen?" },
  "msg.moved_to_trash": { fr: "Conversation déplacée dans la corbeille", en: "Conversation moved to trash", nl: "Gesprek verplaatst naar prullenbak" },
  "msg.delete_confirm": { fr: "Supprimer définitivement cette conversation ? Cette action est irréversible.", en: "Permanently delete this conversation? This action cannot be undone.", nl: "Dit gesprek definitief verwijderen? Deze actie kan niet ongedaan worden gemaakt." },
  "msg.deleted": { fr: "Conversation supprimée définitivement", en: "Conversation permanently deleted", nl: "Gesprek definitief verwijderd" },
  "msg.restored": { fr: "Conversation restaurée", en: "Conversation restored", nl: "Gesprek hersteld" },
  "msg.pro_verified": { fr: "Pro vérifié", en: "Verified Pro", nl: "Geverifieerde Pro" },
  "msg.pro": { fr: "Pro", en: "Pro", nl: "Pro" },
  "msg.online": { fr: "En ligne", en: "Online", nl: "Online" },
  "msg.seen": { fr: "Vu", en: "Seen", nl: "Gezien" },
  "msg.restore_title": { fr: "Restaurer", en: "Restore", nl: "Herstellen" },
  "msg.delete_forever_title": { fr: "Supprimer définitivement", en: "Delete permanently", nl: "Definitief verwijderen" },
  "msg.move_to_trash_title": { fr: "Mettre à la corbeille", en: "Move to trash", nl: "Naar prullenbak verplaatsen" },
  "msg.no_messages": { fr: "Aucun message encore. Écrivez le premier.", en: "No messages yet. Write the first one.", nl: "Nog geen berichten. Schrijf het eerste bericht." },
  "msg.in_trash": { fr: "Cette conversation est dans la corbeille. Restaurez-la pour écrire à nouveau.", en: "This conversation is in the trash. Restore it to write again.", nl: "Dit gesprek bevindt zich in de prullenbak. Herstel het om opnieuw te schrijven." },
  "msg.transaction_ended_title": { fr: "Transaction terminée", en: "Transaction ended", nl: "Transactie beëindigd" },
  "msg.transaction_ended_desc": { fr: "Cette annonce a été marquée comme vendue. La conversation est verrouillée.", en: "This listing has been marked as sold. The conversation is locked.", nl: "Deze advertentie is gemarkeerd als verkocht. Het gesprek is vergrendeld." },
  "msg.placeholder": { fr: "Votre message…", en: "Your message…", nl: "Uw bericht…" },
  "msg.back_aria": { fr: "Retour", en: "Back", nl: "Terug" },
  "msg.load_error": { fr: "Impossible de charger la messagerie", en: "Unable to load messages", nl: "Kan berichten niet laden" },
  "msg.contacted_companies": { fr: "Entreprises contactées", en: "Contacted companies", nl: "Gecontacteerde bedrijven" },

  // ---------- Favorites
  "fav.title": { fr: "Mes favoris", en: "My favorites", nl: "Mijn favorieten" },
  "fav.loading": { fr: "Chargement…", en: "Loading…", nl: "Laden…" },
  "fav.empty_title": { fr: "Aucun favori pour le moment", en: "No favorites yet", nl: "Nog geen favorieten" },
  "fav.empty_desc": { fr: "Cliquez sur le cœur d'une annonce pour la sauvegarder ici.", en: "Click the heart on a listing to save it here.", nl: "Klik op het hartje van een advertentie om het hier op te slaan." },
  "fav.explore": { fr: "Explorer les annonces", en: "Explore listings", nl: "Advertenties verkennen" },
  "fav.price_drop": { fr: "Prix baissé", en: "Price dropped", nl: "Prijs gedaald" },
  "fav.instead_of": { fr: "au lieu de", en: "instead of", nl: "in plaats van" },
  "fav.count": { fr: "annonce sauvegardée", en: "saved listing", nl: "opgeslagen advertentie" },
  "fav.count_pl": { fr: "annonces sauvegardées", en: "saved listings", nl: "opgeslagen advertenties" },

  // ---------- AccountSettings
  "settings.staff_no_delete": { fr: "La suppression de compte n'est pas disponible pour les comptes staff. Contactez un administrateur.", en: "Account deletion is not available for staff accounts. Contact an administrator.", nl: "Accountverwijdering is niet beschikbaar voor staffaccounts. Neem contact op met een beheerder." },
  "settings.notifs_desc": { fr: "Choisissez les emails MATPASS que vous souhaitez recevoir. Les emails de sécurité restent toujours actifs.", en: "Choose which MATPASS emails you want to receive. Security emails always remain active.", nl: "Kies welke MATPASS-e-mails u wilt ontvangen. Beveiligings-e-mails blijven altijd actief." },
  "settings.notifs_loading": { fr: "Chargement…", en: "Loading…", nl: "Laden…" },
  "settings.notifs_enabled": { fr: "Emails activés", en: "Emails enabled", nl: "E-mails ingeschakeld" },
  "settings.notifs_disabled": { fr: "Emails désactivés", en: "Emails disabled", nl: "E-mails uitgeschakeld" },
  "settings.pref_messages_label": { fr: "Nouveaux messages", en: "New messages", nl: "Nieuwe berichten" },
  "settings.pref_messages_desc": { fr: "Recevoir un email quand un acheteur ou un vendeur vous écrit.", en: "Receive an email when a buyer or seller writes to you.", nl: "Ontvang een e-mail wanneer een koper of verkoper u schrijft." },
  "settings.pref_alerts_label": { fr: "Alertes et favoris", en: "Alerts and favorites", nl: "Meldingen en favorieten" },
  "settings.pref_alerts_desc": { fr: "Nouvelles annonces pour vos alertes, baisses de prix, annonces vendues.", en: "New listings for your alerts, price drops, sold listings.", nl: "Nieuwe advertenties voor uw meldingen, prijsdalingen, verkochte advertenties." },
  "settings.pref_marketing_label": { fr: "Nouveautés MATPASS", en: "MATPASS updates", nl: "MATPASS-nieuws" },
  "settings.pref_marketing_desc": { fr: "Annonces produit, améliorations et communications importantes de la plateforme.", en: "Product announcements, improvements and important platform communications.", nl: "Productaankondigingen, verbeteringen en belangrijke platformberichten." },
  "settings.rgpd_note": { fr: "🔒 Vos préférences respectent le RGPD. Vous pouvez les modifier à tout moment.", en: "🔒 Your preferences comply with GDPR. You can change them at any time.", nl: "🔒 Uw voorkeuren voldoen aan de AVG. U kunt ze op elk moment wijzigen." },
  "settings.pw_min_length": { fr: "Le nouveau mot de passe doit contenir au moins 8 caractères", en: "New password must be at least 8 characters", nl: "Nieuw wachtwoord moet minimaal 8 tekens bevatten" },
  "settings.pw_mismatch": { fr: "Les deux mots de passe ne correspondent pas", en: "The two passwords do not match", nl: "De twee wachtwoorden komen niet overeen" },
  "settings.pw_updated": { fr: "Mot de passe mis à jour", en: "Password updated", nl: "Wachtwoord bijgewerkt" },
  "settings.pw_desc": { fr: "Renforcez la sécurité de votre compte avec un mot de passe unique.", en: "Strengthen your account security with a unique password.", nl: "Versterk uw accountbeveiliging met een uniek wachtwoord." },
  "settings.pw_current": { fr: "Mot de passe actuel", en: "Current password", nl: "Huidig wachtwoord" },
  "settings.pw_new": { fr: "Nouveau mot de passe", en: "New password", nl: "Nieuw wachtwoord" },
  "settings.pw_min_hint": { fr: "Minimum 8 caractères.", en: "Minimum 8 characters.", nl: "Minimaal 8 tekens." },
  "settings.pw_confirm": { fr: "Confirmer", en: "Confirm", nl: "Bevestigen" },
  "settings.email_updated": { fr: "Adresse email mise à jour. Un email de vérification sera envoyé prochainement.", en: "Email address updated. A verification email will be sent shortly.", nl: "E-mailadres bijgewerkt. Er wordt binnenkort een verificatie-e-mail verzonden." },
  "settings.email_desc": { fr: "Votre email actuel sert d'identifiant de connexion.", en: "Your current email is used as your login ID.", nl: "Uw huidige e-mail wordt gebruikt als inlog-ID." },
  "settings.email_current": { fr: "Actuellement : ", en: "Currently: ", nl: "Momenteel: " },
  "settings.email_new_label": { fr: "Nouvelle adresse email", en: "New email address", nl: "Nieuw e-mailadres" },
  "settings.email_password_label": { fr: "Mot de passe", en: "Password", nl: "Wachtwoord" },
  "settings.email_change_btn": { fr: "Changer l'email", en: "Change email", nl: "E-mail wijzigen" },
  "settings.delete_toast": { fr: "Votre compte a été supprimé. À bientôt.", en: "Your account has been deleted. See you soon.", nl: "Uw account is verwijderd. Tot ziens." },
  "settings.delete_desc": { fr: "Cette action est irréversible. Toutes vos annonces, messages, favoris et données personnelles seront définitivement effacés.", en: "This action is irreversible. All your listings, messages, favorites and personal data will be permanently deleted.", nl: "Deze actie is onomkeerbaar. Al uw advertenties, berichten, favorieten en persoonlijke gegevens worden definitief verwijderd." },
  "settings.delete_rgpd": { fr: "Conformément au RGPD, vous pouvez demander la suppression totale de vos données personnelles à tout moment.", en: "In accordance with GDPR, you can request the complete deletion of your personal data at any time.", nl: "In overeenstemming met de AVG kunt u op elk moment verzoeken om volledige verwijdering van uw persoonsgegevens." },
  "settings.delete_btn": { fr: "Supprimer mon compte", en: "Delete my account", nl: "Mijn account verwijderen" },
  "settings.delete_confirm_title": { fr: "Confirmer la suppression définitive ?", en: "Confirm permanent deletion?", nl: "Definitieve verwijdering bevestigen?" },
  "settings.delete_confirm_desc": { fr: "Toutes vos annonces, favoris, conversations et données personnelles seront supprimés. Les avis que vous avez laissés seront anonymisés (note et commentaire conservés). Vous ne pourrez plus vous connecter à ce compte.", en: "All your listings, favorites, conversations and personal data will be deleted. Reviews you left will be anonymized (rating and comment kept). You will no longer be able to log in to this account.", nl: "Al uw advertenties, favorieten, gesprekken en persoonlijke gegevens worden verwijderd. Beoordelingen die u heeft achtergelaten worden geanonimiseerd (score en commentaar behouden). U kunt niet meer inloggen op dit account." },
  "settings.delete_pw_label": { fr: "Mot de passe", en: "Password", nl: "Wachtwoord" },
  "settings.delete_type_label": { fr: "Tapez SUPPRIMER pour confirmer", en: "Type DELETE to confirm", nl: "Typ VERWIJDEREN om te bevestigen" },
  "settings.delete_final_btn": { fr: "Supprimer définitivement", en: "Delete permanently", nl: "Definitief verwijderen" },

  // ---------- Reviews
  "reviews.title": { fr: "Avis sur le vendeur", en: "Reviews about this seller", nl: "Beoordelingen over de verkoper" },
  "reviews.count": { fr: "avis", en: "reviews", nl: "beoordelingen" },
  "reviews.leave": { fr: "Laisser un avis", en: "Leave a review", nl: "Een beoordeling achterlaten" },
  "reviews.dialog_title": { fr: "Évaluer ce vendeur", en: "Rate this seller", nl: "Beoordeel deze verkoper" },
  "reviews.loading": { fr: "Chargement…", en: "Loading…", nl: "Laden…" },
  "reviews.empty": { fr: "Aucun avis pour le moment.", en: "No reviews yet.", nl: "Nog geen beoordelingen." },
  "reviews.after_sale_hint": {
    fr: "Votre avis aide les futurs acheteurs à choisir en confiance.",
    en: "Your review helps future buyers choose with confidence.",
    nl: "Uw beoordeling helpt toekomstige kopers met vertrouwen te kiezen.",
  },
  "reviews.after_sale_prompt": {
    fr: "La vente est finalisée. Partagez votre expérience avec ce vendeur.",
    en: "The sale is complete. Share your experience with this seller.",
    nl: "De verkoop is afgerond. Deel uw ervaring met deze verkoper.",
  },
  "reviews.seller_reputation_hint": {
    fr: "Note basée sur les ventes finalisées — rassure les acheteurs sur les prochaines annonces.",
    en: "Rating based on completed sales — reassures buyers on future listings.",
    nl: "Score op basis van afgeronde verkopen — stelt kopers gerust bij volgende advertenties.",
  },
  "reviews.error_no_sale": {
    fr: "Avis disponible uniquement après une vente finalisée.",
    en: "Reviews are only available after a completed sale.",
    nl: "Beoordelingen zijn enkel beschikbaar na een afgeronde verkoop.",
  },
  "reviews.toast_published": { fr: "Avis publié. Merci !", en: "Review published. Thank you!", nl: "Beoordeling gepubliceerd. Dank u!" },
  "reviews.rating_label": { fr: "Note", en: "Rating", nl: "Beoordeling" },
  "reviews.comment_label": { fr: "Votre avis", en: "Your review", nl: "Uw beoordeling" },
  "reviews.comment_placeholder": { fr: "Partagez votre expérience avec ce vendeur (réactivité, matériel conforme, échange, etc.)", en: "Share your experience with this seller (responsiveness, accurate equipment, communication, etc.)", nl: "Deel uw ervaring met deze verkoper (reactievermogen, materiaal conform, uitwisseling, etc.)" },
  "reviews.publishing": { fr: "Publication…", en: "Publishing…", nl: "Publiceren…" },
  "reviews.publish": { fr: "Publier l'avis", en: "Publish review", nl: "Beoordeling publiceren" },
  "reviews.anonymous_author": { fr: "Utilisateur supprimé", en: "Deleted user", nl: "Verwijderde gebruiker" },
  "reviews.pending_page_title": { fr: "Mes avis à laisser", en: "Reviews to leave", nl: "Te schrijven beoordelingen" },
  "reviews.pending_page_subtitle": {
    fr: "Après une vente finalisée, votre avis aide les futurs acheteurs à choisir en confiance.",
    en: "After a completed sale, your review helps future buyers choose with confidence.",
    nl: "Na een afgeronde verkoop helpt uw beoordeling toekomstige kopers met vertrouwen te kiezen.",
  },
  "reviews.pending_empty": {
    fr: "Aucun avis en attente. Vous pourrez évaluer un vendeur dès qu'une vente sera finalisée.",
    en: "No reviews pending. You can rate a seller once a sale is completed.",
    nl: "Geen openstaande beoordelingen. U kunt een verkoper beoordelen zodra een verkoop is afgerond.",
  },
  "reviews.pending_banner_one": {
    fr: "Vous avez 1 avis à laisser sur un vendeur",
    en: "You have 1 review to leave for a seller",
    nl: "U heeft 1 beoordeling te schrijven over een verkoper",
  },
  "reviews.pending_banner_many": {
    fr: "Vous avez {n} avis à laisser sur vos vendeurs",
    en: "You have {n} reviews to leave for your sellers",
    nl: "U heeft {n} beoordelingen te schrijven over uw verkopers",
  },
  "reviews.pending_banner_cta": { fr: "Laisser mes avis", en: "Leave my reviews", nl: "Mijn beoordelingen schrijven" },
  "reviews.pending_sold_on": { fr: "Vente finalisée", en: "Sale completed", nl: "Verkoop afgerond" },
  "reviews.profile_link": { fr: "Avis à laisser", en: "Reviews to leave", nl: "Te schrijven beoordelingen" },
  "reviews.profile_link_desc": { fr: "Évaluez vos vendeurs après achat", en: "Rate your sellers after purchase", nl: "Beoordeel uw verkopers na aankoop" },

  "interest.sale_label": { fr: "Je suis intéressé par cette machine", en: "I'm interested in this machine", nl: "Ik ben geïnteresseerd in deze machine" },
  "interest.card_sale": { fr: "Intéressé", en: "Interested", nl: "Geïnteresseerd" },
  "interest.card_rental": { fr: "Intéressé (location)", en: "Interested (rental)", nl: "Geïnteresseerd (verhuur)" },
  "interest.sale_hint": { fr: "Le vendeur sera averti. Vous pourrez aussi envoyer une demande d'achat.", en: "The seller will be notified. You can also send a purchase request.", nl: "De verkoper wordt op de hoogte gebracht. U kunt ook een aankoopverzoek sturen." },
  "interest.purchase_active_hint": { fr: "Vous avez déjà une demande d'achat en cours sur cette machine.", en: "You already have a purchase request in progress for this machine.", nl: "U heeft al een lopend aankoopverzoek voor deze machine." },
  "interest.rental_label": { fr: "Je suis intéressé par cette location", en: "I'm interested in this rental", nl: "Ik ben geïnteresseerd in deze verhuur" },
  "interest.rental_hint": { fr: "Le fournisseur sera averti et pourra vous recontacter.", en: "The supplier will be notified and can get back to you.", nl: "De leverancier wordt op de hoogte gebracht en kan contact opnemen." },
  "interest.login_required": { fr: "Connectez-vous pour vous déclarer intéressé", en: "Sign in to mark your interest", nl: "Log in om interesse te tonen" },
  "interest.already": { fr: "Vous êtes déjà inscrit comme intéressé", en: "You are already marked as interested", nl: "U staat al als geïnteresseerd geregistreerd" },
  "interest.toast_sale": { fr: "Intérêt enregistré — le vendeur est averti", en: "Interest saved — the seller has been notified", nl: "Interesse geregistreerd — verkoper is op de hoogte" },
  "interest.toast_rental": { fr: "Intérêt enregistré — le fournisseur est averti", en: "Interest saved — the supplier has been notified", nl: "Interesse geregistreerd — leverancier is op de hoogte" },
  "interest.waitlist_label": { fr: "Je suis sur la liste d'attente", en: "I'm on the waitlist", nl: "Ik sta op de wachtlijst" },
  "interest.waitlist_hint": { fr: "Vous serez averti si la machine redevient disponible.", en: "You'll be notified if the machine becomes available again.", nl: "U wordt op de hoogte gebracht als de machine weer beschikbaar is." },
  "interest.toast_waitlist": { fr: "Inscrit sur la liste d'attente", en: "Added to the waitlist", nl: "Toegevoegd aan de wachtlijst" },
  "interest.removed": { fr: "Vous n'êtes plus marqué comme intéressé", en: "You are no longer marked as interested", nl: "U staat niet langer als geïnteresseerd geregistreerd" },
  "interest.loading": { fr: "Chargement des intéressés…", en: "Loading interested users…", nl: "Geïnteresseerden laden…" },
  "interest.seller_empty": { fr: "Personne ne s'est encore déclaré intéressé.", en: "No one has marked interest yet.", nl: "Nog niemand heeft interesse getoond." },
  "interest.seller_panel_title": { fr: "Personnes intéressées", en: "Interested people", nl: "Geïnteresseerden" },
  "interest.seller_panel_hint": {
    fr: "Les visiteurs voient une case « Je suis intéressé » — vous recevez une notification ici.",
    en: "Visitors see an « I'm interested » checkbox — you get notified here.",
    nl: "Bezoekers zien een vak « Ik ben geïnteresseerd » — u krijgt hier een melding.",
  },
  "interest.seller_count_sg": { fr: "{count} personne intéressée", en: "{count} interested person", nl: "{count} geïnteresseerde persoon" },
  "interest.seller_count_pl": { fr: "{count} personnes intéressées", en: "{count} interested people", nl: "{count} geïnteresseerde personen" },
  "interest.mode_sale": { fr: "Vente", en: "Sale", nl: "Verkoop" },
  "interest.mode_rental": { fr: "Location", en: "Rental", nl: "Verhuur" },
  "interest.kind_waitlist": { fr: "Liste d'attente", en: "Waitlist", nl: "Wachtlijst" },
  "interest.anonymous": { fr: "Utilisateur", en: "User", nl: "Gebruiker" },

  // ---------- Email verification banner
  "verify.confirm_email": { fr: "Confirmez votre email pour publier des annonces.", en: "Confirm your email to publish listings.", nl: "Bevestig uw e-mail om advertenties te publiceren." },
  "verify.use_resend": { fr: "Utilisez « Renvoyer » si vous n'avez rien reçu (pensez aux spams).", en: "Use \"Resend\" if you haven't received anything (check your spam).", nl: "Gebruik \"Opnieuw verzenden\" als u niets heeft ontvangen (controleer spam)." },
  "verify.hide_aria": { fr: "Masquer", en: "Hide", nl: "Verbergen" },

  // ---------- Login page
  "login.welcome_toast": { fr: "Bienvenue sur MATPASS", en: "Welcome to MATPASS", nl: "Welkom bij MATPASS" },
  "login.tagline": { fr: "La plateforme du matériel professionnel d'occasion.", en: "The marketplace for used professional equipment.", nl: "Het platform voor tweedehands professioneel materieel." },
  "login.benefit1": { fr: "Retrouvez vos annonces, votre messagerie et vos favoris.", en: "Access your listings, messages and favorites.", nl: "Toegang tot uw advertenties, berichten en favorieten." },
  "login.benefit2": { fr: "Achetez mieux. Revendez plus.", en: "Buy smarter. Sell more.", nl: "Slimmer kopen. Meer verkopen." },
  "login.heading": { fr: "Accédez à votre compte MATPASS", en: "Access your MATPASS account", nl: "Toegang tot uw MATPASS-account" },
  "login.email_placeholder": { fr: "vous@exemple.fr", en: "you@example.com", nl: "u@voorbeeld.nl" },
  "login.create_account": { fr: "Créer un compte", en: "Create an account", nl: "Een account aanmaken" },

  // ---------- PurchaseRequestPanel
  "purchase.finalized": { fr: "Vente finalisée", en: "Sale finalized", nl: "Verkoop afgerond" },
  "purchase.refused": { fr: "Votre demande d'achat a été refusée.", en: "Your purchase request has been refused.", nl: "Uw koopverzoek is geweigerd." },
  "purchase.accepted_title": { fr: "Demande acceptée", en: "Request accepted", nl: "Aanvraag geaccepteerd" },
  "purchase.reserved_buyer": { fr: "L'annonce est réservée pour vous.", en: "The listing is reserved for you.", nl: "De advertentie is voor u gereserveerd." },
  "purchase.reserved_seller": { fr: "L'annonce est réservée pour cet acheteur.", en: "The listing is reserved for this buyer.", nl: "De advertentie is gereserveerd voor deze koper." },
  "purchase.finalize_btn": { fr: "Vente finalisée", en: "Finalize sale", nl: "Verkoop afronden" },
  "purchase.finalize_title": { fr: "Finaliser la vente ?", en: "Finalize the sale?", nl: "Verkoop afronden?" },
  "purchase.finalize_desc": { fr: "L'annonce passera en Vendue, disparaîtra de la recherche, la conversation sera fermée et les personnes intéressées seront informées.", en: "The listing will be marked as Sold, removed from search, the conversation will be closed and interested parties will be notified.", nl: "De advertentie wordt gemarkeerd als Verkocht, verwijderd uit zoekresultaten, het gesprek wordt gesloten en geïnteresseerden worden geïnformeerd." },
  "purchase.finalize_success": { fr: "Vente finalisée", en: "Sale finalized", nl: "Verkoop afgerond" },
  "purchase.cancel_reservation_btn": { fr: "Annuler la réservation", en: "Cancel reservation", nl: "Reservering annuleren" },
  "purchase.cancel_title": { fr: "Annuler la réservation", en: "Cancel reservation", nl: "Reservering annuleren" },
  "purchase.cancel_desc": { fr: "Choisissez le motif. L'annonce redeviendra Disponible et la liste d'attente sera notifiée.", en: "Choose the reason. The listing will become Available again and the waiting list will be notified.", nl: "Kies de reden. De advertentie wordt weer Beschikbaar en de wachtlijst wordt geïnformeerd." },
  "purchase.cancel_reason_placeholder": { fr: "Précisez le motif…", en: "Specify the reason…", nl: "Geef de reden op…" },
  "purchase.cancel_success": { fr: "Réservation annulée. Annonce disponible.", en: "Reservation cancelled. Listing available.", nl: "Reservering geannuleerd. Advertentie beschikbaar." },
  "purchase.cancel_confirm_btn": { fr: "Confirmer l'annulation", en: "Confirm cancellation", nl: "Annulering bevestigen" },
  "purchase.choose_reason": { fr: "Choisissez un motif", en: "Choose a reason", nl: "Kies een reden" },
  "purchase.specify_reason": { fr: "Précisez le motif", en: "Please specify the reason", nl: "Geef de reden op" },
  "purchase.pending_title": { fr: "Demande d'achat envoyée", en: "Purchase request sent", nl: "Koopverzoek verzonden" },
  "purchase.pending_discussing": { fr: "Le vendeur souhaite continuer la discussion.", en: "The seller wants to continue the discussion.", nl: "De verkoper wil het gesprek voortzetten." },
  "purchase.pending_waiting": { fr: "En attente de la réponse du vendeur.", en: "Waiting for the seller's response.", nl: "Wachten op antwoord van de verkoper." },
  "purchase.new_request": { fr: "Nouvelle demande d'achat", en: "New purchase request", nl: "Nieuw koopverzoek" },
  "purchase.discussing_hint": { fr: "Discussion en cours. Vous pouvez encore accepter ou refuser.", en: "Discussion in progress. You can still accept or refuse.", nl: "Discussie loopt. U kunt nog accepteren of weigeren." },
  "purchase.accept_btn": { fr: "Accepter la demande", en: "Accept request", nl: "Aanvraag accepteren" },
  "purchase.accept_success": { fr: "Demande acceptée. Annonce réservée.", en: "Request accepted. Listing reserved.", nl: "Aanvraag geaccepteerd. Advertentie gereserveerd." },
  "purchase.discuss_btn": { fr: "Continuer la discussion", en: "Continue discussion", nl: "Discussie voortzetten" },
  "purchase.discuss_success": { fr: "Continuez la discussion", en: "Continue the discussion", nl: "Ga verder met de discussie" },
  "purchase.refuse_btn": { fr: "Refuser", en: "Refuse", nl: "Weigeren" },
  "purchase.refuse_success": { fr: "Demande refusée", en: "Request refused", nl: "Aanvraag geweigerd" },
  "purchase.reason_withdrew": { fr: "L'acheteur s'est désisté", en: "Buyer withdrew", nl: "Koper heeft zich teruggetrokken" },
  "purchase.reason_no_reply": { fr: "L'acheteur ne répond plus", en: "Buyer is not responding", nl: "Koper reageert niet meer" },
  "purchase.reason_no_agreement": { fr: "Aucun accord trouvé", en: "No agreement reached", nl: "Geen akkoord gevonden" },
  "purchase.reason_appointment": { fr: "Rendez-vous annulé", en: "Appointment cancelled", nl: "Afspraak geannuleerd" },
  "purchase.reason_other": { fr: "Autre", en: "Other", nl: "Andere" },

  // ---------- ContactedCompanies
  "contacted.title": { fr: "Entreprises contactées", en: "Contacted companies", nl: "Gecontacteerde bedrijven" },
  "contacted.subtitle": { fr: "Retrouvez les boutiques que vous avez consultées ou contactées.", en: "Find the shops you have visited or contacted.", nl: "Vind de winkels die u heeft bezocht of gecontacteerd." },
  "contacted.loading": { fr: "Chargement…", en: "Loading…", nl: "Laden…" },
  "contacted.empty_title": { fr: "Aucun historique pour le moment", en: "No history yet", nl: "Nog geen geschiedenis" },
  "contacted.empty_desc": { fr: "Quand vous ouvrez une boutique ou contactez un vendeur, il apparaît ici.", en: "When you visit a shop or contact a seller, they appear here.", nl: "Wanneer u een winkel bezoekt of een verkoper contacteert, verschijnen ze hier." },
  "contacted.see_suppliers": { fr: "Voir les fournisseurs", en: "See suppliers", nl: "Leveranciers bekijken" },
  "contacted.explore": { fr: "Explorer les annonces", en: "Explore listings", nl: "Advertenties verkennen" },
  "contacted.badge_contacted": { fr: "Contacté", en: "Contacted", nl: "Gecontacteerd" },
  "contacted.badge_visited": { fr: "Consulté", en: "Visited", nl: "Bekeken" },
  "contacted.listing_count": { fr: "annonce", en: "listing", nl: "advertentie" },
  "contacted.listing_count_pl": { fr: "annonces", en: "listings", nl: "advertenties" },
  "contacted.view_shop": { fr: "Voir la boutique", en: "View shop", nl: "Winkel bekijken" },
  "contacted.view_listing": { fr: "Voir l'annonce", en: "View listing", nl: "Advertentie bekijken" },
  "contacted.remove_aria": { fr: "Retirer de l'historique", en: "Remove from history", nl: "Uit geschiedenis verwijderen" },
  "contacted.removed": { fr: "Retiré de l'historique", en: "Removed from history", nl: "Verwijderd uit geschiedenis" },
  "contacted.company_fallback": { fr: "Entreprise", en: "Company", nl: "Bedrijf" },

  // ---------- Search extras
  "search.saved": { fr: "Recherche enregistrée", en: "Search saved", nl: "Zoekopdracht opgeslagen" },
  "search.ai_hint": { fr: "Décrivez ce que vous cherchez (min 3 caractères)", en: "Describe what you're looking for (min 3 characters)", nl: "Beschrijf wat u zoekt (min 3 tekens)" },
  "search.ai_applied": { fr: "Filtres appliqués par l'IA", en: "Filters applied by AI", nl: "Filters toegepast door AI" },
  "search.ai_unavailable": { fr: "Recherche IA indisponible", en: "AI search unavailable", nl: "AI-zoeken niet beschikbaar" },
  "search.clear_aria": { fr: "Effacer", en: "Clear", nl: "Wissen" },

  // ---------- Nav mobile / layout labels
  "nav.post_short": { fr: "+ Annonce", en: "+ Ad", nl: "+ Adv." },
  "nav.post_label": { fr: "Déposer", en: "Post", nl: "Plaatsen" },
  "nav.home_label": { fr: "Accueil", en: "Home", nl: "Home" },
  "nav.profile_label": { fr: "Profil", en: "Profile", nl: "Profiel" },
  "nav.aria_main": { fr: "Navigation principale", en: "Main navigation", nl: "Hoofdnavigatie" },
  "nav.aria_mobile": { fr: "Navigation mobile", en: "Mobile navigation", nl: "Mobiele navigatie" },
  "nav.favorites_label": { fr: "Favoris", en: "Favorites", nl: "Favorieten" },
  "nav.messages_label": { fr: "Messages", en: "Messages", nl: "Berichten" },
  "nav.messages_unread": { fr: "Messages, {n} non lu(s)", en: "Messages, {n} unread", nl: "Berichten, {n} ongelezen" },
  "nav.logo_home": { fr: "MATPASS — Accueil", en: "MATPASS — Home", nl: "MATPASS — Home" },

  // ---------- Accessibility (WCAG AA)
  "a11y.skip_to_content": { fr: "Aller au contenu principal", en: "Skip to main content", nl: "Ga naar hoofdinhoud" },
  "a11y.search_label": { fr: "Rechercher du matériel", en: "Search equipment", nl: "Materiaal zoeken" },
  "a11y.photo_prev": { fr: "Photo précédente", en: "Previous photo", nl: "Vorige foto" },
  "a11y.photo_next": { fr: "Photo suivante", en: "Next photo", nl: "Volgende foto" },
  "a11y.photo_thumb": { fr: "Photo {n} sur {total}", en: "Photo {n} of {total}", nl: "Foto {n} van {total}" },
  "a11y.carousel_prev": { fr: "Précédent", en: "Previous", nl: "Vorige" },
  "a11y.carousel_next": { fr: "Suivant", en: "Next", nl: "Volgende" },
  "a11y.carousel_region": { fr: "Carrousel", en: "Carousel", nl: "Carrousel" },
  "a11y.show_password": { fr: "Afficher le mot de passe", en: "Show password", nl: "Wachtwoord tonen" },
  "a11y.hide_password": { fr: "Masquer le mot de passe", en: "Hide password", nl: "Wachtwoord verbergen" },
  "a11y.map_region": { fr: "Carte des annonces", en: "Listings map", nl: "Kaart met advertenties" },
  "a11y.results_live": { fr: "{n} annonce(s) trouvée(s)", en: "{n} listing(s) found", nl: "{n} advertentie(s) gevonden" },
  "nav.admin_label": { fr: "Admin", en: "Admin", nl: "Beheer" },

  // ---------- Dashboard / MyListings
  "dashboard.stat_views": { fr: "Vues", en: "Views", nl: "Weergaven" },
  "dashboard.stat_favorites": { fr: "Favoris", en: "Favorites", nl: "Favorieten" },
  "dashboard.stat_messages": { fr: "Messages", en: "Messages", nl: "Berichten" },
  "dashboard.stat_active": { fr: "Annonces actives", en: "Active listings", nl: "Actieve advertenties" },
  "dashboard.purchase_requests_title": { fr: "Demandes d'achat reçues", en: "Purchase requests received", nl: "Ontvangen koopverzoeken" },
  "dashboard.pr_pending": { fr: "En attente", en: "Pending", nl: "In afwachting" },
  "dashboard.pr_reserved": { fr: "Réservées", en: "Reserved", nl: "Gereserveerd" },
  "dashboard.pr_finalized": { fr: "Ventes finalisées", en: "Finalized sales", nl: "Afgeronde verkopen" },
  "dashboard.pr_cancelled": { fr: "Réservations annulées", en: "Cancelled reservations", nl: "Geannuleerde reserveringen" },
  "dashboard.pr_interested": { fr: "Acheteurs intéressés", en: "Interested buyers", nl: "Geïnteresseerde kopers" },
  "dashboard.quota_full": { fr: "Quota atteint", en: "Quota reached", nl: "Quotum bereikt" },
  "dashboard.quota_upgrade": { fr: "Passer Pro", en: "Upgrade to Pro", nl: "Upgraden naar Pro" },
  "dashboard.quota_unlimited": { fr: "illimité", en: "unlimited", nl: "onbeperkt" },
  "dashboard.listings_count": { fr: "annonce", en: "listing", nl: "advertentie" },
  "dashboard.listings_count_pl": { fr: "annonces", en: "listings", nl: "advertenties" },

  // ---------- ProDashboard (Pro)
  "dashboard.pro_account": { fr: "Compte professionnel", en: "Professional account", nl: "Professioneel account" },
  "dashboard.company_dashboard": { fr: "Tableau de bord entreprise", en: "Company dashboard", nl: "Bedrijfsdashboard" },
  "dashboard.view_shop": { fr: "Ma boutique publique", en: "My public shop", nl: "Mijn openbare winkel" },
  "dashboard.contact_matpass": { fr: "Contacter MatPass", en: "Contact MatPass", nl: "Contact MatPass" },
  "dashboard.post_listing_cta": { fr: "+ Déposer une annonce", en: "+ Post a listing", nl: "+ Advertentie plaatsen" },
  "dashboard.tab_overview": { fr: "Vue d'ensemble", en: "Overview", nl: "Overzicht" },
  "dashboard.tab_stats": { fr: "Statistiques", en: "Statistics", nl: "Statistieken" },
  "dashboard.tab_listings": { fr: "Mes annonces", en: "My listings", nl: "Mijn advertenties" },
  "dashboard.tab_shop": { fr: "Ma boutique", en: "My shop", nl: "Mijn winkel" },
  "dashboard.tab_support": { fr: "Support MatPass", en: "MatPass Support", nl: "MatPass Support" },
  "dashboard.tab_subscription": { fr: "Mon abonnement", en: "My subscription", nl: "Mijn abonnement" },
  "dashboard.tab_invoices": { fr: "Mes factures", en: "My invoices", nl: "Mijn facturen" },
  "dashboard.tab_team": { fr: "Mon équipe", en: "My team", nl: "Mijn team" },
  "dashboard.tab_soon": { fr: "Bientôt disponible", en: "Coming soon", nl: "Binnenkort beschikbaar" },
  "dashboard.loading": { fr: "Chargement…", en: "Loading…", nl: "Laden…" },
  "dashboard.stat_listings": { fr: "Annonces", en: "Listings", nl: "Advertenties" },
  "dashboard.stat_sales": { fr: "Ventes", en: "Sales", nl: "Verkopen" },
  "dashboard.stat_contacts": { fr: "Contacts", en: "Contacts", nl: "Contacten" },
  "dashboard.stat_conversations": { fr: "conversations", en: "conversations", nl: "gesprekken" },
  "dashboard.stat_phone_clicks": { fr: "Clics téléphone", en: "Phone clicks", nl: "Telefoonkliks" },
  "dashboard.stat_gps_clicks": { fr: "Clics GPS", en: "GPS clicks", nl: "GPS-kliks" },
  "dashboard.stat_shares": { fr: "Partages", en: "Shares", nl: "Delingen" },
  "dashboard.stat_response_time": { fr: "Temps réponse", en: "Response time", nl: "Reactietijd" },
  "dashboard.stat_rating": { fr: "Note moyenne", en: "Average rating", nl: "Gemiddelde beoordeling" },
  "dashboard.stat_reviews": { fr: "avis", en: "reviews", nl: "beoordelingen" },
  "dashboard.stat_subscription": { fr: "Abonnement", en: "Subscription", nl: "Abonnement" },
  "dashboard.stat_published": { fr: "publiées", en: "published", nl: "gepubliceerd" },
  "dashboard.stat_unlimited": { fr: "illimité", en: "unlimited", nl: "onbeperkt" },
  "dashboard.top_listings_title": { fr: "Annonces les plus vues", en: "Most viewed listings", nl: "Meest bekeken advertenties" },
  "dashboard.no_listings": { fr: "Aucune annonce pour le moment.", en: "No listings yet.", nl: "Nog geen advertenties." },
  "dashboard.quick_access": { fr: "Accès rapide", en: "Quick access", nl: "Snelle toegang" },
  "dashboard.quick_favorites": { fr: "Mes favoris", en: "My favorites", nl: "Mijn favorieten" },
  "dashboard.quick_messages": { fr: "Mes messages", en: "My messages", nl: "Mijn berichten" },
  "dashboard.quick_invoices": { fr: "Mes factures", en: "My invoices", nl: "Mijn facturen" },
  "dashboard.quick_subscription": { fr: "Mon abonnement", en: "My subscription", nl: "Mijn abonnement" },
  "dashboard.stat_views_30d": { fr: "Vues 30j", en: "Views 30d", nl: "Weergaven 30d" },
  "dashboard.stat_favorites_30d": { fr: "Favoris 30j", en: "Favorites 30d", nl: "Favorieten 30d" },
  "dashboard.stat_messages_30d": { fr: "Messages 30j", en: "Messages 30d", nl: "Berichten 30d" },
  "dashboard.stat_phone_30d": { fr: "Clics tél 30j", en: "Phone clicks 30d", nl: "Telefoonkliks 30d" },
  "dashboard.stat_gps_30d": { fr: "Clics GPS 30j", en: "GPS clicks 30d", nl: "GPS-kliks 30d" },
  "dashboard.stat_shares_30d": { fr: "Partages 30j", en: "Shares 30d", nl: "Delingen 30d" },
  "dashboard.evolution_title": { fr: "Évolution sur 30 jours", en: "Trend over 30 days", nl: "Trend over 30 dagen" },
  "dashboard.evolution_subtitle": { fr: "Données réelles agrégées quotidiennement", en: "Real data aggregated daily", nl: "Echte gegevens dagelijks geaggregeerd" },
  "dashboard.no_data": { fr: "Aucune donnée disponible sur la période.", en: "No data available for this period.", nl: "Geen gegevens beschikbaar voor deze periode." },
  "dashboard.chart_views": { fr: "Vues", en: "Views", nl: "Weergaven" },
  "dashboard.chart_favorites": { fr: "Favoris", en: "Favorites", nl: "Favorieten" },
  "dashboard.chart_messages": { fr: "Messages", en: "Messages", nl: "Berichten" },
  "dashboard.chart_phone": { fr: "Clics tél", en: "Phone clicks", nl: "Telefoonkliks" },
  "dashboard.chart_gps": { fr: "Clics GPS", en: "GPS clicks", nl: "GPS-kliks" },
  "dashboard.chart_shares": { fr: "Partages", en: "Shares", nl: "Delingen" },
  "dashboard.sub_active_offer": { fr: "Offre active", en: "Active plan", nl: "Actief abonnement" },
  "dashboard.sub_no_sub": { fr: "Aucun abonnement", en: "No subscription", nl: "Geen abonnement" },
  "dashboard.sub_quota": { fr: "Quota d'annonces :", en: "Listing quota:", nl: "Advertentiequotum:" },
  "dashboard.sub_renewal": { fr: "Prochain renouvellement :", en: "Next renewal:", nl: "Volgende verlenging:" },
  "dashboard.sub_cancel_notice": { fr: "annulation prévue à la fin de la période", en: "cancellation scheduled at period end", nl: "annulering gepland aan het einde van de periode" },
  "dashboard.manage_sub": { fr: "Gérer mon abonnement", en: "Manage my subscription", nl: "Mijn abonnement beheren" },
  "dashboard.change_offer": { fr: "Changer d'offre", en: "Change plan", nl: "Abonnement wijzigen" },
  "dashboard.view_invoices": { fr: "Voir mes factures", en: "View my invoices", nl: "Mijn facturen bekijken" },
  "dashboard.sub_status_active": { fr: "Actif", en: "Active", nl: "Actief" },
  "dashboard.sub_status_trialing": { fr: "Essai", en: "Trial", nl: "Proef" },
  "dashboard.sub_status_past_due": { fr: "Paiement en retard", en: "Payment overdue", nl: "Betaling te laat" },
  "dashboard.sub_status_canceled": { fr: "Résilié", en: "Cancelled", nl: "Opgezegd" },
  "dashboard.sub_status_none": { fr: "Aucun", en: "None", nl: "Geen" },

  // ---------- AutoTranslateBanner
  "autotranslate.translating": { fr: "Traduction automatique en cours…", en: "Auto-translating…", nl: "Automatisch vertalen…" },
  "autotranslate.translated_in": { fr: "Traduit automatiquement en", en: "Auto-translated to", nl: "Automatisch vertaald naar" },

  // ---------- SavedSearches
  "saved_searches.view_listings": { fr: "Voir les annonces", en: "View listings", nl: "Advertenties bekijken" },

  // ---------- ResultsMap
  "map.view_listing": { fr: "Voir l'annonce", en: "View listing", nl: "Advertentie bekijken" },

  // ---------- Onboarding pro
  "onboarding.title": { fr: "Bienvenue sur MatPass — 2 étapes pour bien démarrer", en: "Welcome to MatPass — 2 steps to get started", nl: "Welkom bij MatPass — 2 stappen om te beginnen" },
  "onboarding.step_shop_done": { fr: "Boutique complétée", en: "Shop completed", nl: "Winkel voltooid" },
  "onboarding.step_shop_todo": { fr: "Compléter votre boutique", en: "Complete your shop", nl: "Uw winkel invullen" },
  "onboarding.step_shop_desc": { fr: "Nom, description, logo — visible par tous les clients", en: "Name, description, logo — visible to all clients", nl: "Naam, beschrijving, logo — zichtbaar voor alle klanten" },
  "onboarding.step_listing_done": { fr: "Première annonce publiée", en: "First listing published", nl: "Eerste advertentie gepubliceerd" },
  "onboarding.step_listing_todo": { fr: "Déposer votre première annonce", en: "Post your first listing", nl: "Uw eerste advertentie plaatsen" },
  "onboarding.step_listing_desc": { fr: "Machines, équipements, location ou vente", en: "Machines, equipment, rental or sale", nl: "Machines, uitrusting, verhuur of verkoop" },

  // ---------- Profile page
  "profile.kicker": { fr: "Espace personnel", en: "My account", nl: "Persoonlijke ruimte" },
  "profile.title": { fr: "Mon compte", en: "My account", nl: "Mijn account" },
  "profile.subtitle": { fr: "Gérez votre profil, vos annonces et la sécurité de votre compte MatPass.", en: "Manage your profile, listings and MatPass account security.", nl: "Beheer uw profiel, advertenties en de beveiliging van uw MatPass-account." },
  "profile.loading": { fr: "Chargement…", en: "Loading…", nl: "Laden…" },
  "profile.edit": { fr: "Modifier", en: "Edit", nl: "Bewerken" },
  "profile.save": { fr: "Enregistrer", en: "Save", nl: "Opslaan" },
  "profile.saving": { fr: "Enregistrement…", en: "Saving…", nl: "Opslaan…" },
  "profile.cancel": { fr: "Annuler", en: "Cancel", nl: "Annuleren" },
  "profile.settings": { fr: "Paramètres", en: "Settings", nl: "Instellingen" },
  "profile.shortcuts": { fr: "Raccourcis", en: "Shortcuts", nl: "Snelkoppelingen" },
  "profile.view_shop": { fr: "Voir ma boutique publique", en: "View my public shop", nl: "Mijn openbare winkel bekijken" },
  "profile.about": { fr: "À propos", en: "About", nl: "Over" },
  "profile.email_verified": { fr: "Email vérifié", en: "Email verified", nl: "E-mail geverifieerd" },
  "profile.email_unverified": { fr: "Email à vérifier", en: "Email to verify", nl: "E-mail te verifiëren" },
  "profile.pro_verified": { fr: "Pro vérifié", en: "Verified Pro", nl: "Geverifieerde Pro" },
  "profile.role_admin": { fr: "Administrateur", en: "Administrator", nl: "Beheerder" },
  "profile.role_moderator": { fr: "Modérateur", en: "Moderator", nl: "Moderator" },
  "profile.role_support": { fr: "Support", en: "Support", nl: "Ondersteuning" },
  "profile.role_pro": { fr: "Professionnel", en: "Professional", nl: "Professioneel" },
  "profile.role_particulier": { fr: "Particulier", en: "Individual", nl: "Particulier" },
  "profile.field_name": { fr: "Nom complet", en: "Full name", nl: "Volledige naam" },
  "profile.field_phone": { fr: "Téléphone", en: "Phone", nl: "Telefoon" },
  "profile.field_city": { fr: "Ville", en: "City", nl: "Stad" },
  "profile.field_postal": { fr: "Code postal", en: "Postal code", nl: "Postcode" },
  "profile.field_company": { fr: "Nom de l'entreprise", en: "Company name", nl: "Bedrijfsnaam" },
  "profile.field_vat": { fr: "N° entreprise (BE)", en: "Company No. (BE)", nl: "Ondernemingsnr. (BE)" },
  "profile.field_company_desc": { fr: "Description entreprise", en: "Company description", nl: "Bedrijfsbeschrijving" },
  "profile.account_type": { fr: "Type de compte", en: "Account type", nl: "Accounttype" },
  "profile.currently": { fr: "Actuellement :", en: "Currently:", nl: "Momenteel:" },
  "profile.switch_to_pro": { fr: "Basculer en Professionnel", en: "Switch to Professional", nl: "Overschakelen naar Professioneel" },
  "profile.switch_to_particulier": { fr: "Basculer en Particulier", en: "Switch to Individual", nl: "Overschakelen naar Particulier" },
  "profile.field_location": { fr: "Localisation", en: "Location", nl: "Locatie" },
  "profile.toast_updated": { fr: "Profil mis à jour", en: "Profile updated", nl: "Profiel bijgewerkt" },
  "profile.toast_role_changed": { fr: "Type de compte modifié", en: "Account type changed", nl: "Accounttype gewijzigd" },
  "profile.toast_invalid_image": { fr: "Image invalide", en: "Invalid image", nl: "Ongeldige afbeelding" },
  "profile.toast_company_required": { fr: "Renseignez d'abord le nom de votre entreprise pour passer en professionnel.", en: "Please enter your company name first to switch to Professional.", nl: "Voer eerst uw bedrijfsnaam in om over te schakelen naar Professioneel." },

  // ---------- Register page
  "register.toast_created": { fr: "Compte créé. Vérifiez votre boîte e-mail.", en: "Account created. Please check your email.", nl: "Account aangemaakt. Controleer uw e-mail." },
  "register.toast_created_no_email": { fr: "Compte créé, mais l'e-mail de vérification n'a pas pu être envoyé.", en: "Account created, but the verification email could not be sent.", nl: "Account aangemaakt, maar de verificatie-e-mail kon niet worden verzonden." },
  "register.toast_error": { fr: "Impossible de créer le compte", en: "Unable to create account", nl: "Kan account niet aanmaken" },
  "register.terms_accept": { fr: "J'accepte les CGU et la politique de confidentialité.", en: "I accept the Terms of Service and Privacy Policy.", nl: "Ik accepteer de Algemene Voorwaarden en het Privacybeleid." },
  "register.marketing": { fr: "Je souhaite recevoir les actualités et offres MATPASS par e-mail (optionnel).", en: "I would like to receive MATPASS news and offers by email (optional).", nl: "Ik wil MATPASS-nieuws en aanbiedingen per e-mail ontvangen (optioneel)." },
  "register.location_title": {
    fr: "Votre commune pour des recherches plus pertinentes",
    en: "Your area for more relevant searches",
    nl: "Uw gemeente voor relevantere zoekopdrachten",
  },
  "register.location_body": {
    fr: "Autorisez MatPass à estimer votre commune : nous préremplissons ville et code postal pour vous proposer des annonces et fournisseurs près de chez vous.",
    en: "Allow MatPass to estimate your area: we pre-fill city and postal code to show listings and suppliers near you.",
    nl: "Sta MatPass toe uw gemeente te schatten: we vullen stad en postcode in voor advertenties en leveranciers bij u in de buurt.",
  },
  "register.location_privacy": {
    fr: "Seuls votre ville et code postal sont enregistrés sur votre profil. MatPass ne vous suit pas en arrière-plan.",
    en: "Only your city and postal code are saved on your profile. MatPass does not track you in the background.",
    nl: "Alleen stad en postcode worden op uw profiel bewaard. MatPass volgt u niet op de achtergrond.",
  },
  "register.location_cta": {
    fr: "Autoriser la localisation",
    en: "Allow location",
    nl: "Locatie toestaan",
  },
  "register.location_manual": {
    fr: "Saisir manuellement",
    en: "Enter manually",
    nl: "Handmatig invoeren",
  },
  "register.location_pre_title": {
    fr: "MatPass souhaite utiliser votre position",
    en: "MatPass would like to use your location",
    nl: "MatPass wil uw locatie gebruiken",
  },
  "register.location_pre_body": {
    fr: "Votre téléphone va afficher une demande du navigateur. Choisissez « Lors de l'utilisation du site » ou « Autoriser » — c'est la option recommandée pour faciliter vos recherches.",
    en: "Your phone will show a browser prompt. Choose “While using the site” or “Allow” — recommended to simplify your searches.",
    nl: "Uw telefoon toont een browserverzoek. Kies “Tijdens gebruik van de site” of “Toestaan” — aanbevolen voor eenvoudiger zoeken.",
  },
  "register.location_pre_note": {
    fr: "Les sites web (matpass.be) ne peuvent pas activer le suivi « tout le temps » comme une application installée : la localisation n'est utilisée que pendant votre visite sur MatPass.",
    en: "Websites (matpass.be) cannot use “always on” tracking like a native app: location is only used while you browse MatPass.",
    nl: "Websites (matpass.be) kunnen geen permanente tracking zoals een app: locatie wordt alleen gebruikt tijdens uw bezoek aan MatPass.",
  },
  "register.location_pre_allow": {
    fr: "Continuer",
    en: "Continue",
    nl: "Doorgaan",
  },
  "register.location_pre_skip": {
    fr: "Plus tard",
    en: "Not now",
    nl: "Later",
  },
  "register.location_status_gps": {
    fr: "Localisation en cours…",
    en: "Locating…",
    nl: "Locatie wordt bepaald…",
  },
  "register.location_status_ok": {
    fr: "Commune détectée : {city}",
    en: "Area detected: {city}",
    nl: "Gemeente gedetecteerd: {city}",
  },
  "register.location_status_fallback": {
    fr: "GPS indisponible — estimation via votre connexion…",
    en: "GPS unavailable — estimating from your connection…",
    nl: "GPS niet beschikbaar — schatting via uw verbinding…",
  },
  "register.location_status_manual": {
    fr: "Saisissez votre code postal ci-dessous.",
    en: "Enter your postal code below.",
    nl: "Voer hieronder uw postcode in.",
  },
  "register.location_toast_ok": {
    fr: "Commune enregistrée pour vos recherches.",
    en: "Area saved for your searches.",
    nl: "Gemeente opgeslagen voor uw zoekopdrachten.",
  },
  "register.location_toast_approx": {
    fr: "Position approximative — vérifiez ville et code postal.",
    en: "Approximate location — please verify city and postal code.",
    nl: "Geschatte locatie — controleer stad en postcode.",
  },
  "register.location_toast_manual": {
    fr: "Indiquez votre code postal belge (4 chiffres).",
    en: "Enter your Belgian postal code (4 digits).",
    nl: "Voer uw Belgische postcode in (4 cijfers).",
  },
  "register.validation_name": { fr: "Nom complet requis", en: "Full name required", nl: "Volledige naam vereist" },
  "register.validation_email": { fr: "Email requis", en: "Email required", nl: "E-mail vereist" },
  "register.validation_password": { fr: "Mot de passe (8 caractères min)", en: "Password (8 characters min)", nl: "Wachtwoord (min. 8 tekens)" },
  "register.validation_company": { fr: "Nom de l'entreprise requis", en: "Company name required", nl: "Bedrijfsnaam vereist" },
  "register.validation_terms": { fr: "Acceptation des CGU requise", en: "Terms acceptance required", nl: "Acceptatie van de Algemene Voorwaarden vereist" },
  "register.validation_intent": { fr: "Choix d'intention MATPASS requis", en: "MATPASS intent choice required", nl: "MATPASS-intentie vereist" },
  "register.validation_vat_for_supplier": { fr: "N° TVA/BCE requis pour devenir fournisseur", en: "VAT/BCE number required to become a supplier", nl: "BTW/KBO-nummer vereist om leverancier te worden" },
  "register.intent_question": {
    fr: "Quel est votre objectif sur MATPASS ?",
    en: "What is your goal on MATPASS?",
    nl: "Wat is uw doel op MATPASS?",
  },
  "register.intent_buyer": {
    fr: "Je recherche des fournisseurs et du matériel pour mon activité",
    en: "I am looking for suppliers and equipment for my business",
    nl: "Ik zoek leveranciers en materiaal voor mijn activiteit",
  },
  "register.intent_supplier": {
    fr: "Je tiens une boutique, un parc de location ou un atelier matériel",
    en: "I run an equipment shop, rental fleet or repair workshop",
    nl: "Ik heb een materiaalwinkel, verhuurpark of reparatiewerkplaats",
  },
  "register.intent_both": {
    fr: "Les deux : trouver du matériel et présenter ma boutique",
    en: "Both: find equipment and showcase my shop",
    nl: "Beide: materiaal zoeken en mijn winkel presenteren",
  },
  "register.pro_scope_notice_title": {
    fr: "Compte professionnel — matériel uniquement",
    en: "Professional account — equipment only",
    nl: "Professioneel account — alleen materieel",
  },
  "register.pro_scope_notice_body": {
    fr: "MATPASS référence des professionnels du matériel professionnel : vente, location, réparation et pièces. Ce n'est pas une plateforme pour proposer vos prestations de travaux (jardinage, menuiserie, bâtiment, etc.) aux particuliers.",
    en: "MATPASS lists professional equipment businesses: sales, rental, repair and parts. It is not a platform to offer trade services (gardening, carpentry, construction, etc.) to end customers.",
    nl: "MATPASS vermeldt professionals in professioneel materieel: verkoop, verhuur, reparatie en onderdelen. Het is geen platform om vakdiensten (tuin, schrijnwerk, bouw, enz.) aan particulieren aan te bieden.",
  },
  "register.pro_supplier_notice": {
    fr: "Pour apparaître dans « Rechercher un fournisseur », votre dossier doit prouver une activité matériel (boutique, parc de location ou atelier). Les profils « prestations de services » seront refusés.",
    en: "To appear in “Find a supplier”, your application must show an equipment business (shop, rental fleet or workshop). “Service-only” profiles will be declined.",
    nl: "Om in « Leverancier zoeken » te verschijnen, moet uw dossier een materieelactiviteit aantonen (winkel, verhuurpark of werkplaats). Profielen « alleen diensten » worden geweigerd.",
  },
  "register.toast_supplier_pending": {
    fr: "Demande fournisseur envoyée — validation MATPASS en attente.",
    en: "Supplier request sent — awaiting MATPASS validation.",
    nl: "Leveranciersaanvraag verzonden — wacht op validatie door MATPASS.",
  },
  "profile.become_supplier": { fr: "Devenir fournisseur sur MATPASS", en: "Become a MATPASS supplier", nl: "Leverancier worden op MATPASS" },
  "profile.become_supplier_desc": {
    fr: "Demandez l'accès à votre boutique et à l'annuaire. Validation par l'équipe MATPASS.",
    en: "Request access to your shop and the directory. Validated by the MATPASS team.",
    nl: "Vraag toegang tot uw shop en de directory. Validatie door het MATPASS-team.",
  },
  "profile.supplier_pending": {
    fr: "Demande fournisseur en cours de validation",
    en: "Supplier request pending validation",
    nl: "Leveranciersaanvraag in behandeling",
  },
  "profile.supplier_rejected": {
    fr: "Demande fournisseur refusée",
    en: "Supplier request declined",
    nl: "Leveranciersaanvraag geweigerd",
  },
  "profile.toast_supplier_requested": {
    fr: "Demande envoyée. Vous serez notifié après validation.",
    en: "Request sent. You will be notified after validation.",
    nl: "Aanvraag verzonden. U wordt verwittigd na validatie.",
  },

  // ---------- Search page toasts
  "search.toast_login_to_save": { fr: "Connectez-vous pour enregistrer", en: "Sign in to save", nl: "Log in om op te slaan" },
  "search.toast_name_alert": { fr: "Donnez un nom à cette alerte", en: "Give this alert a name", nl: "Geef deze melding een naam" },
  "search.toast_alert_saved": { fr: "Alerte activée — vous serez notifié(e) des nouvelles annonces", en: "Alert activated — you'll be notified of new listings", nl: "Melding geactiveerd — u wordt geïnformeerd over nieuwe advertenties" },

  // ---------- PostAd page
  "post.step_label": { fr: "Étape", en: "Step", nl: "Stap" },
  "post.step_category_title": { fr: "Catégorie principale", en: "Main category", nl: "Hoofdcategorie" },
  "post.step_category_desc": { fr: "Choisissez le type de matériel que vous vendez.", en: "Choose the type of equipment you are selling.", nl: "Kies het type materieel dat u verkoopt." },
  "post.field_title": { fr: "Titre", en: "Title", nl: "Titel" },
  "post.field_brand": { fr: "Marque", en: "Brand", nl: "Merk" },
  "post.field_model": { fr: "Modèle", en: "Model", nl: "Model" },
  "post.field_year": { fr: "Année", en: "Year", nl: "Jaar" },
  "post.field_hours": { fr: "Heures d'utilisation", en: "Hours of use", nl: "Gebruiksuren" },
  "post.field_price": { fr: "Prix (€) *", en: "Price (€) *", nl: "Prijs (€) *" },
  "post.field_condition": { fr: "État *", en: "Condition *", nl: "Staat *" },
  "post.hint_smart": { fr: "Saisissez la marque et le modèle pour activer les suggestions MatPass.", en: "Enter the brand and model to activate MatPass suggestions.", nl: "Voer het merk en model in om MatPass-suggesties te activeren." },
  "post.hint_confidence": { fr: "Plus vous renseignez de cases, plus les acheteurs auront confiance.", en: "The more fields you fill in, the more confident buyers will be.", nl: "Hoe meer velden u invult, hoe meer vertrouwen kopers zullen hebben." },
  "post.error_price": { fr: "Prix invalide", en: "Invalid price", nl: "Ongeldige prijs" },
  "post.toast_updated": { fr: "Annonce mise à jour", en: "Listing updated", nl: "Advertentie bijgewerkt" },
  "post.toast_max_images": { fr: "photos maximum.", en: "photos maximum.", nl: "foto's maximum." },
  "post.toast_images_added": { fr: "ajoutée(s).", en: "added.", nl: "toegevoegd." },

  // ---------- Beta landing
  "beta.badge_top": { fr: "Beta privée", en: "Private beta", nl: "Privé bèta" },
  "beta.hero_h1_hello": { fr: "Bienvenue sur", en: "Welcome to", nl: "Welkom bij" },
  "beta.hero_p1": { fr: "Merci de faire partie des premiers professionnels à tester MATPASS.", en: "Thanks for being one of the first professionals to test MATPASS.", nl: "Bedankt dat u een van de eerste professionals bent die MATPASS testen." },
  "beta.hero_p2": {
    fr: "Vous découvrez aujourd'hui la première version de MATPASS, la plateforme spécialisée dans l'achat et la vente de matériel professionnel d'occasion. Votre avis est extrêmement précieux. Grâce à vos retours, nous améliorerons MATPASS avant son lancement officiel.",
    en: "You're discovering the first version of MATPASS, the marketplace for used professional equipment. Your feedback is invaluable. It will help us improve MATPASS before the official launch.",
    nl: "U ontdekt vandaag de eerste versie van MATPASS, het platform voor tweedehands professioneel materieel. Uw feedback is van onschatbare waarde. Het helpt ons MATPASS te verbeteren vóór de officiële lancering.",
  },

};

// ---- API publique ----

export function translate(key, lang, fallback) {
  const entry = dict[key];
  if (!entry) return fallback !== undefined ? fallback : key; // clé inconnue → fallback si fourni, sinon clé
  return entry[lang] || entry.fr || fallback || key;
}

export const SUPPORTED_LANGS = ["fr", "en", "nl"];

export default dict;
